/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BoRouteImport } from './routes/bo'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ImpersonateRouteRouteImport } from './routes/impersonate/route'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as ReceiveQuoteRouteRouteImport } from './routes/receive-quote/route'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as SearchRouteRouteImport } from './routes/search/route'
import { Route as SubscribeNoPossibleStepRouteRouteImport } from './routes/subscribe-no-possible-step/route'
import { Route as UnsubscribeRouteRouteImport } from './routes/unsubscribe/route'
import { Route as customerShellRouteImport } from './routes/(customer)/_shell'
import { Route as redirectsContractGuaranteesRouteRouteImport } from './routes/(redirects)/contract-guarantees/route'
import { Route as redirectsPaymentMethodUpdateRouteRouteImport } from './routes/(redirects)/payment-method-update/route'
import { Route as BoIndexRouteImport } from './routes/bo/index'
import { Route as BoActivitiesRouteRouteImport } from './routes/bo/activities/route'
import { Route as BoActivitiesOldRouteRouteImport } from './routes/bo/activities-old/route'
import { Route as BoEphemeralJobsRouteRouteImport } from './routes/bo/ephemeral-jobs/route'
import { Route as BoGenerateSlipsRouteRouteImport } from './routes/bo/generate-slips/route'
import { Route as BoGuaranteesTablesRouteRouteImport } from './routes/bo/guarantees-tables/route'
import { Route as BoLourmelSftpRouteRouteImport } from './routes/bo/lourmel-sftp/route'
import { Route as BoMigrationRouteRouteImport } from './routes/bo/migration/route'
import { Route as BoReferralsRouteRouteImport } from './routes/bo/referrals/route'
import { Route as BoScriptsRouteRouteImport } from './routes/bo/scripts/route'
import { Route as BoSearchRouteRouteImport } from './routes/bo/search/route'
import { Route as BoToolsRouteRouteImport } from './routes/bo/tools/route'
import { Route as BoTrackingDocRouteRouteImport } from './routes/bo/tracking-doc/route'
import { Route as PaymentAuthenticationRouteRouteImport } from './routes/payment/authentication/route'
import { Route as RCodeRouteRouteImport } from './routes/r/$code/route'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as SubscribeExclusionSubscriptionIdRouteRouteImport } from './routes/subscribe-exclusion/$subscriptionId/route'
import { Route as SubscribeLandingRouteRouteImport } from './routes/subscribe/landing/route'
import { Route as customerShellAccountRouteRouteImport } from './routes/(customer)/_shell/account/route'
import { Route as customerShellHealthInsuranceRouteRouteImport } from './routes/(customer)/_shell/health-insurance/route'
import { Route as customerShellHomeRouteRouteImport } from './routes/(customer)/_shell/home/route'
import { Route as customerShellInvoicesRouteRouteImport } from './routes/(customer)/_shell/invoices/route'
import { Route as customerShellProductGuaranteesRouteRouteImport } from './routes/(customer)/_shell/product-guarantees/route'
import { Route as customerShellUnpaidInvoicesRouteRouteImport } from './routes/(customer)/_shell/unpaid-invoices/route'
import { Route as redirectsBakActivitiesRouteRouteImport } from './routes/(redirects)/bak/activities/route'
import { Route as redirectsBakEphemeralJobsRouteRouteImport } from './routes/(redirects)/bak/ephemeral-jobs/route'
import { Route as redirectsBakHomeRouteRouteImport } from './routes/(redirects)/bak/home/route'
import { Route as redirectsBakMembershipsRouteRouteImport } from './routes/(redirects)/bak/memberships/route'
import { Route as redirectsBakMigrationRouteRouteImport } from './routes/(redirects)/bak/migration/route'
import { Route as redirectsBakNewSubscriptionRouteRouteImport } from './routes/(redirects)/bak/new-subscription/route'
import { Route as redirectsBakOrganizationsRouteRouteImport } from './routes/(redirects)/bak/organizations/route'
import { Route as redirectsBakSearchRouteRouteImport } from './routes/(redirects)/bak/search/route'
import { Route as redirectsBakTrackingDocRouteRouteImport } from './routes/(redirects)/bak/tracking-doc/route'
import { Route as redirectsPaymentMethodsNewRouteRouteImport } from './routes/(redirects)/payment-methods/new/route'
import { Route as BoAdminIndexRouteImport } from './routes/bo/admin/index'
import { Route as BoAdminConsumerStatusRouteRouteImport } from './routes/bo/admin/consumer-status/route'
import { Route as BoAdminDebugRouteRouteImport } from './routes/bo/admin/debug/route'
import { Route as BoAdminImaRouteRouteImport } from './routes/bo/admin/ima/route'
import { Route as BoAdminSystemPromptsRouteRouteImport } from './routes/bo/admin/system-prompts/route'
import { Route as BoAdminTimeRouteRouteImport } from './routes/bo/admin/time/route'
import { Route as BoAnnouncementsIndexRouteImport } from './routes/bo/announcements/index'
import { Route as BoAnnouncementsNewRouteImport } from './routes/bo/announcements/new'
import { Route as BoContractsIndexRouteImport } from './routes/bo/contracts/index'
import { Route as BoDashboardIndexRouteImport } from './routes/bo/dashboard/index'
import { Route as BoDocumentationIndexRouteImport } from './routes/bo/documentation/index'
import { Route as BoDocumentationActivityConfigurationRouteRouteImport } from './routes/bo/documentation/activity-configuration/route'
import { Route as BoDocumentationActivitySpecificQuestionsRouteRouteImport } from './routes/bo/documentation/activity-specific-questions/route'
import { Route as BoDocumentationEmailsRouteRouteImport } from './routes/bo/documentation/emails/route'
import { Route as BoDocumentationEndorsementRulesRouteRouteImport } from './routes/bo/documentation/endorsement-rules/route'
import { Route as BoDocumentationExclusionsRouteRouteImport } from './routes/bo/documentation/exclusions/route'
import { Route as BoDocumentationGeneralTermsRouteRouteImport } from './routes/bo/documentation/general-terms/route'
import { Route as BoDocumentationInjectableParamsRouteRouteImport } from './routes/bo/documentation/injectable-params/route'
import { Route as BoDocumentationInputDimensionsRouteRouteImport } from './routes/bo/documentation/input-dimensions/route'
import { Route as BoDocumentationInvoicingBalanceRouteRouteImport } from './routes/bo/documentation/invoicing-balance/route'
import { Route as BoDocumentationProductsRouteRouteImport } from './routes/bo/documentation/products/route'
import { Route as BoDocumentationReimbursementRulesRouteRouteImport } from './routes/bo/documentation/reimbursement-rules/route'
import { Route as BoDocumentationRolesRouteRouteImport } from './routes/bo/documentation/roles/route'
import { Route as BoDocumentationSearchRouteRouteImport } from './routes/bo/documentation/search/route'
import { Route as BoDocumentationSubscriptionFunnelTextsRouteRouteImport } from './routes/bo/documentation/subscription-funnel-texts/route'
import { Route as BoExcludedSubscriptionsIndexRouteImport } from './routes/bo/excluded-subscriptions/index'
import { Route as BoInvoicingInvoiceIdRouteRouteImport } from './routes/bo/invoicing/$invoiceId/route'
import { Route as BoInvoicingNegativeInvoicesRouteRouteImport } from './routes/bo/invoicing/negative-invoices/route'
import { Route as BoOrganizationsIndexRouteImport } from './routes/bo/organizations/index'
import { Route as BoOrganizationsCreateRouteImport } from './routes/bo/organizations/create'
import { Route as BoPasskeysIndexRouteImport } from './routes/bo/passkeys/index'
import { Route as BoProductsIndexRouteImport } from './routes/bo/products/index'
import { Route as BoRenewalIndexRouteImport } from './routes/bo/renewal/index'
import { Route as BoReviewTasksIndexRouteImport } from './routes/bo/review-tasks/index'
import { Route as BoSettingsIndexRouteImport } from './routes/bo/settings/index'
import { Route as BoSubscriptionsIndexRouteImport } from './routes/bo/subscriptions/index'
import { Route as BoSubscriptionsGenerateRouteImport } from './routes/bo/subscriptions/generate'
import { Route as BoSubscriptionsGenerateFailedRouteImport } from './routes/bo/subscriptions/generate-failed'
import { Route as BoSubscriptionsNewRouteRouteImport } from './routes/bo/subscriptions/new/route'
import { Route as BoToolsIndexRouteImport } from './routes/bo/tools/index'
import { Route as BoToolsGuaranteesTablesRouteRouteImport } from './routes/bo/tools/guarantees-tables/route'
import { Route as BoUsersIndexRouteImport } from './routes/bo/users/index'
import { Route as BoUsersUserIdRouteRouteImport } from './routes/bo/users/$userId/route'
import { Route as FormSubscriptionIdFormIdRouteRouteImport } from './routes/form/$subscriptionId/$formId/route'
import { Route as ResourcesDocumentationInjectableParamsRouteRouteImport } from './routes/resources/documentation/injectable-params/route'
import { Route as SAttestationsTokenRouteRouteImport } from './routes/s/attestations/$token/route'
import { Route as SCTokenRouteRouteImport } from './routes/s/c/$token/route'
import { Route as SEV2TokenRouteRouteImport } from './routes/s/e-v2/$token/route'
import { Route as SETokenRouteRouteImport } from './routes/s/e/$token/route'
import { Route as SHfTokenRouteRouteImport } from './routes/s/hf/$token/route'
import { Route as SQTokenRouteRouteImport } from './routes/s/q/$token/route'
import { Route as SRTokenRouteRouteImport } from './routes/s/r/$token/route'
import { Route as SubscribeSubscriptionIdStepIdRouteRouteImport } from './routes/subscribe/$subscriptionId/$stepId/route'
import { Route as SubscribeRestaurantsV2IdentifyRouteRouteImport } from './routes/subscribe/restaurants-v2/identify/route'
import { Route as customerShellContractsIndexRouteImport } from './routes/(customer)/_shell/contracts/index'
import { Route as customerShellHealthInsuranceIndexRouteImport } from './routes/(customer)/_shell/health-insurance/index'
import { Route as customerShellHealthInsuranceBeneficiariesRouteImport } from './routes/(customer)/_shell/health-insurance/beneficiaries'
import { Route as customerShellHealthInsuranceCpmsRouteImport } from './routes/(customer)/_shell/health-insurance/cpms'
import { Route as customerShellHealthInsuranceSanteclairRouteImport } from './routes/(customer)/_shell/health-insurance/santeclair'
import { Route as customerShellLegalAssistanceIndexRouteImport } from './routes/(customer)/_shell/legal-assistance/index'
import { Route as customerShellPaymentMethodsIndexRouteImport } from './routes/(customer)/_shell/payment-methods/index'
import { Route as customerShellProductGuaranteesIndexRouteImport } from './routes/(customer)/_shell/product-guarantees/index'
import { Route as customerShellReferralsIndexRouteImport } from './routes/(customer)/_shell/referrals/index'
import { Route as customerShellReportClaimIndexRouteImport } from './routes/(customer)/_shell/report-claim/index'
import { Route as customerShellUnpaidInvoicesIndexRouteImport } from './routes/(customer)/_shell/unpaid-invoices/index'
import { Route as customerShellUnpaidInvoicesPaymentRouteImport } from './routes/(customer)/_shell/unpaid-invoices/payment'
import { Route as redirectsBakAdminIndexRouteImport } from './routes/(redirects)/bak/admin/index'
import { Route as redirectsBakAdminImaRouteRouteImport } from './routes/(redirects)/bak/admin/ima/route'
import { Route as redirectsBakDocumentationIndexRouteImport } from './routes/(redirects)/bak/documentation/index'
import { Route as redirectsBakDocumentationActivitySpecificQuestionsRouteRouteImport } from './routes/(redirects)/bak/documentation/activity-specific-questions/route'
import { Route as redirectsBakDocumentationExclusionsRouteRouteImport } from './routes/(redirects)/bak/documentation/exclusions/route'
import { Route as redirectsBakDocumentationGeneralTermsRouteRouteImport } from './routes/(redirects)/bak/documentation/general-terms/route'
import { Route as redirectsBakDocumentationRolesRouteRouteImport } from './routes/(redirects)/bak/documentation/roles/route'
import { Route as redirectsBakDocumentationSubscriptionFunnelTextsRouteRouteImport } from './routes/(redirects)/bak/documentation/subscription-funnel-texts/route'
import { Route as redirectsBakInvoicingNegativeInvoicesListRouteRouteImport } from './routes/(redirects)/bak/invoicing/negative-invoices-list/route'
import { Route as redirectsBakPendingSubscriptionsIndexRouteImport } from './routes/(redirects)/bak/pending-subscriptions/index'
import { Route as redirectsBakUsersIndexRouteImport } from './routes/(redirects)/bak/users/index'
import { Route as redirectsBakUsersUserIdRouteRouteImport } from './routes/(redirects)/bak/users/$userId/route'
import { Route as redirectsBoEarningsIndexRouteImport } from './routes/(redirects)/bo/earnings/index'
import { Route as redirectsBoMembershipsIndexRouteImport } from './routes/(redirects)/bo/memberships/index'
import { Route as redirectsBoOrganizationDashboardIndexRouteImport } from './routes/(redirects)/bo/organization-dashboard/index'
import { Route as redirectsBoOrganizationHistoryIndexRouteImport } from './routes/(redirects)/bo/organization-history/index'
import { Route as redirectsBoSlipsIndexRouteImport } from './routes/(redirects)/bo/slips/index'
import { Route as redirectsPartnerOrganizationHomeRouteRouteImport } from './routes/(redirects)/partner/$organization/home/route'
import { Route as redirectsPartnerOrganizationNewSubscriptionRouteRouteImport } from './routes/(redirects)/partner/$organization/new-subscription/route'
import { Route as redirectsPartnerOrganizationSearchRouteRouteImport } from './routes/(redirects)/partner/$organization/search/route'
import { Route as BoAdminDataWarehouseIndexRouteImport } from './routes/bo/admin/data-warehouse/index'
import { Route as BoAdminDispatchersIndexRouteImport } from './routes/bo/admin/dispatchers/index'
import { Route as BoAdminJobsIndexRouteImport } from './routes/bo/admin/jobs/index'
import { Route as BoAdminReducersIndexRouteImport } from './routes/bo/admin/reducers/index'
import { Route as BoAiUnderwritingRulesIndexRouteImport } from './routes/bo/ai-underwriting/rules/index'
import { Route as BoAiEvaluationsIndexRouteImport } from './routes/bo/ai/evaluations/index'
import { Route as BoAiExperimentsAgentIdRouteImport } from './routes/bo/ai/experiments/$agentId'
import { Route as BoAiReviewRunIdRouteImport } from './routes/bo/ai/review/$runId'
import { Route as BoAiRunsIndexRouteImport } from './routes/bo/ai/runs/index'
import { Route as BoAiRunsWorkflowIdRouteImport } from './routes/bo/ai/runs/$workflowId'
import { Route as BoAiWorkflowsIndexRouteImport } from './routes/bo/ai/workflows/index'
import { Route as BoAiWorkflowsWorkflowIdRouteImport } from './routes/bo/ai/workflows/$workflowId'
import { Route as BoAnnouncementsAnnouncementIdIndexRouteImport } from './routes/bo/announcements/$announcementId/index'
import { Route as BoChallengesChallengeIdSubscribeRouteImport } from './routes/bo/challenges/$challengeId/subscribe'
import { Route as BoClaimsClaimIdIndexRouteImport } from './routes/bo/claims/$claimId/index'
import { Route as BoContractsSubscriptionIdIndexRouteImport } from './routes/bo/contracts/$subscriptionId/index'
import { Route as BoContractsSubscriptionIdAttestationsRouteRouteImport } from './routes/bo/contracts/$subscriptionId/attestations/route'
import { Route as BoContractsSubscriptionIdBillingExemptionRouteRouteImport } from './routes/bo/contracts/$subscriptionId/billing-exemption/route'
import { Route as BoContractsSubscriptionIdCpmsRouteRouteImport } from './routes/bo/contracts/$subscriptionId/cpms/route'
import { Route as BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRouteImport } from './routes/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents/route'
import { Route as BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRouteImport } from './routes/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents/route'
import { Route as BoContractsSubscriptionIdStatusRouteRouteImport } from './routes/bo/contracts/$subscriptionId/status/route'
import { Route as BoDocumentationExclusionsIndexRouteImport } from './routes/bo/documentation/exclusions/index'
import { Route as BoDocumentationExclusionsConfigurationRouteImport } from './routes/bo/documentation/exclusions/configuration'
import { Route as BoOrganizationsOrganizationTechnicalNameIndexRouteImport } from './routes/bo/organizations/$organizationTechnicalName/index'
import { Route as BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRouteImport } from './routes/bo/organizations/$organizationTechnicalName/advanced-settings'
import { Route as BoOrganizationsOrganizationTechnicalNameDashboardRouteImport } from './routes/bo/organizations/$organizationTechnicalName/dashboard'
import { Route as BoOrganizationsOrganizationTechnicalNameHistoryRouteRouteImport } from './routes/bo/organizations/$organizationTechnicalName/history/route'
import { Route as BoOrganizationsOrganizationTechnicalNameMembersRouteImport } from './routes/bo/organizations/$organizationTechnicalName/members'
import { Route as BoOrganizationsOrganizationTechnicalNameSlipsRouteImport } from './routes/bo/organizations/$organizationTechnicalName/slips'
import { Route as BoProductsProductGroupSlugIndexRouteImport } from './routes/bo/products/$productGroupSlug/index'
import { Route as BoReviewTasksTaskIdIndexRouteImport } from './routes/bo/review-tasks/$taskId/index'
import { Route as BoSettingsMembersIndexRouteImport } from './routes/bo/settings/members/index'
import { Route as BoSettingsPaymentDetailsIndexRouteImport } from './routes/bo/settings/payment-details/index'
import { Route as BoSettingsSlipsIndexRouteImport } from './routes/bo/settings/slips/index'
import { Route as BoSubscriptionsSubscriptionIdIndexRouteImport } from './routes/bo/subscriptions/$subscriptionId/index'
import { Route as BoSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport } from './routes/bo/subscriptions/$subscriptionId/detailed-sheet/route'
import { Route as BoSubscriptionsSubscriptionIdHistoryRouteRouteImport } from './routes/bo/subscriptions/$subscriptionId/history/route'
import { Route as BoSubscriptionsSubscriptionIdPaymentRouteRouteImport } from './routes/bo/subscriptions/$subscriptionId/payment/route'
import { Route as BoTroubleshootingSessionsSessionIdRouteRouteImport } from './routes/bo/troubleshooting/sessions/$sessionId/route'
import { Route as BoUsersUserIdPaymentMethodsRouteRouteImport } from './routes/bo/users/$userId_/payment-methods/route'
import { Route as BoUsersUserIdUnpaidInvoicesRouteRouteImport } from './routes/bo/users/$userId_/unpaid-invoices/route'
import { Route as SATokenIndexRouteImport } from './routes/s/a/$token/index'
import { Route as SATokenProductRouteRouteImport } from './routes/s/a/$token/$product/route'
import { Route as SubscribeSubscriptionIdStepIdIndexRouteImport } from './routes/subscribe/$subscriptionId/$stepId/index'
import { Route as customerShellContractsSubscriptionIdIndexRouteImport } from './routes/(customer)/_shell/contracts/$subscriptionId/index'
import { Route as customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRouteImport } from './routes/(customer)/_shell/insurance-certificate-generator-real-estate-agents/$subscriptionId/index'
import { Route as customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRouteImport } from './routes/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/index'
import { Route as customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteImport } from './routes/(customer)/_shell/product-guarantees/$subscriptionId/$productName/route'
import { Route as redirectsBakClaimsClaimIdIndexRouteImport } from './routes/(redirects)/bak/claims/$claimId/index'
import { Route as redirectsBakContractsSubscriptionIdIndexRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/index'
import { Route as redirectsBakContractsSubscriptionIdInvoicingRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/invoicing/route'
import { Route as redirectsBakContractsSubscriptionIdNewInvoiceRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/new-invoice/route'
import { Route as redirectsBakContractsSubscriptionIdStatusRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/status/route'
import { Route as redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRouteImport } from './routes/(redirects)/bak/pending-subscriptions/$subscriptionId/history/route'
import { Route as redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport } from './routes/(redirects)/bak/pending-subscriptions/$subscriptionId/payment/route'
import { Route as redirectsBakTroubleshootingSessionSessionIdRouteRouteImport } from './routes/(redirects)/bak/troubleshooting/session/$sessionId/route'
import { Route as redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRouteImport } from './routes/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/index'
import { Route as redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport } from './routes/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet/route'
import { Route as redirectsPartnerOrganizationClaimsClaimIdRouteRouteImport } from './routes/(redirects)/partner/$organization/claims/$claimId/route'
import { Route as redirectsPartnerOrganizationContractsSubscriptionIdRouteRouteImport } from './routes/(redirects)/partner/$organization/contracts/$subscriptionId/route'
import { Route as redirectsPartnerOrganizationPendingSubscriptionsIndexRouteImport } from './routes/(redirects)/partner/$organization/pending-subscriptions/index'
import { Route as redirectsPartnerOrganizationUsersIndexRouteImport } from './routes/(redirects)/partner/$organization/users/index'
import { Route as redirectsPartnerOrganizationUsersUserIdRouteRouteImport } from './routes/(redirects)/partner/$organization/users/$userId/route'
import { Route as BoAdminJobsJobIdIndexRouteImport } from './routes/bo/admin/jobs/$jobId/index'
import { Route as BoAdminReducersReducerNameIndexRouteImport } from './routes/bo/admin/reducers/$reducerName/index'
import { Route as BoAiEvaluationsWorkflowIdIndexRouteImport } from './routes/bo/ai/evaluations/$workflowId/index'
import { Route as BoContractsSubscriptionIdInvoicesDebugRouteRouteImport } from './routes/bo/contracts/$subscriptionId/invoices/debug/route'
import { Route as BoContractsSubscriptionIdInvoicesNewRouteRouteImport } from './routes/bo/contracts/$subscriptionId/invoices/new/route'
import { Route as BoContractsSubscriptionIdPaymentMethodsNewRouteRouteImport } from './routes/bo/contracts/$subscriptionId/payment-methods/new/route'
import { Route as BoUsersUserIdUnpaidInvoicesIndexRouteImport } from './routes/bo/users/$userId_/unpaid-invoices/index'
import { Route as BoUsersUserIdUnpaidInvoicesPaymentRouteRouteImport } from './routes/bo/users/$userId_/unpaid-invoices/payment/route'
import { Route as SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRouteImport } from './routes/subscribe/$subscriptionId/$stepId/$detailType/$detailId/route'
import { Route as customerShellContractsSubscriptionIdAttestationsIndexRouteImport } from './routes/(customer)/_shell/contracts/$subscriptionId/attestations/index'
import { Route as customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRouteImport } from './routes/(customer)/_shell/product-guarantees/$subscriptionId/$productName/$guaranteeType'
import { Route as customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteImport } from './routes/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/route'
import { Route as customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRouteImport } from './routes/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion/route'
import { Route as redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId/route'
import { Route as redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport } from './routes/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment/route'
import { Route as redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRouteImport } from './routes/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/index'
import { Route as BoAdminJobsJobIdConcurrencyKeyIndexRouteImport } from './routes/bo/admin/jobs/$jobId/$concurrencyKey/index'
import { Route as BoAiEvaluationsWorkflowIdDatasetsDatasetIdRouteImport } from './routes/bo/ai/evaluations/$workflowId/datasets/$datasetId'
import { Route as BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRouteImport } from './routes/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history/route'
import { Route as BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport } from './routes/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId/route'
import { Route as BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRouteImport } from './routes/bo/contracts/$subscriptionId/endorsements/$endorsementId/index'
import { Route as BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRouteImport } from './routes/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet/route'
import { Route as BoContractsSubscriptionIdRenewalsEndorsementIdIndexRouteImport } from './routes/bo/contracts/$subscriptionId/renewals/$endorsementId/index'
import { Route as customerShellContractsSubscriptionIdPaymentMethodsNewIndexRouteImport } from './routes/(customer)/_shell/contracts/$subscriptionId/payment-methods/new/index'
import { Route as customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRouteImport } from './routes/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/index'
import { Route as customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRouteImport } from './routes/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/index'
import { Route as redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId/route'
import { Route as redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/index'
import { Route as redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRouteImport } from './routes/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet/route'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BoRoute = BoRouteImport.update({
  id: '/bo',
  path: '/bo',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRouteRoute = ImpersonateRouteRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiveQuoteRouteRoute = ReceiveQuoteRouteRouteImport.update({
  id: '/receive-quote',
  path: '/receive-quote',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesRoute = ResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRouteRoute = SearchRouteRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeNoPossibleStepRouteRoute =
  SubscribeNoPossibleStepRouteRouteImport.update({
    id: '/subscribe-no-possible-step',
    path: '/subscribe-no-possible-step',
    getParentRoute: () => rootRouteImport,
  } as any)
const UnsubscribeRouteRoute = UnsubscribeRouteRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const customerShellRoute = customerShellRouteImport.update({
  id: '/(customer)/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsContractGuaranteesRouteRoute =
  redirectsContractGuaranteesRouteRouteImport.update({
    id: '/(redirects)/contract-guarantees',
    path: '/contract-guarantees',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPaymentMethodUpdateRouteRoute =
  redirectsPaymentMethodUpdateRouteRouteImport.update({
    id: '/(redirects)/payment-method-update',
    path: '/payment-method-update',
    getParentRoute: () => rootRouteImport,
  } as any)
const BoIndexRoute = BoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BoRoute,
} as any)
const BoActivitiesRouteRoute = BoActivitiesRouteRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => BoRoute,
} as any)
const BoActivitiesOldRouteRoute = BoActivitiesOldRouteRouteImport.update({
  id: '/activities-old',
  path: '/activities-old',
  getParentRoute: () => BoRoute,
} as any)
const BoEphemeralJobsRouteRoute = BoEphemeralJobsRouteRouteImport.update({
  id: '/ephemeral-jobs',
  path: '/ephemeral-jobs',
  getParentRoute: () => BoRoute,
} as any)
const BoGenerateSlipsRouteRoute = BoGenerateSlipsRouteRouteImport.update({
  id: '/generate-slips',
  path: '/generate-slips',
  getParentRoute: () => BoRoute,
} as any)
const BoGuaranteesTablesRouteRoute = BoGuaranteesTablesRouteRouteImport.update({
  id: '/guarantees-tables',
  path: '/guarantees-tables',
  getParentRoute: () => BoRoute,
} as any)
const BoLourmelSftpRouteRoute = BoLourmelSftpRouteRouteImport.update({
  id: '/lourmel-sftp',
  path: '/lourmel-sftp',
  getParentRoute: () => BoRoute,
} as any)
const BoMigrationRouteRoute = BoMigrationRouteRouteImport.update({
  id: '/migration',
  path: '/migration',
  getParentRoute: () => BoRoute,
} as any)
const BoReferralsRouteRoute = BoReferralsRouteRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => BoRoute,
} as any)
const BoScriptsRouteRoute = BoScriptsRouteRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => BoRoute,
} as any)
const BoSearchRouteRoute = BoSearchRouteRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => BoRoute,
} as any)
const BoToolsRouteRoute = BoToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => BoRoute,
} as any)
const BoTrackingDocRouteRoute = BoTrackingDocRouteRouteImport.update({
  id: '/tracking-doc',
  path: '/tracking-doc',
  getParentRoute: () => BoRoute,
} as any)
const PaymentAuthenticationRouteRoute =
  PaymentAuthenticationRouteRouteImport.update({
    id: '/payment/authentication',
    path: '/payment/authentication',
    getParentRoute: () => rootRouteImport,
  } as any)
const RCodeRouteRoute = RCodeRouteRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResourcesRoute,
} as any)
const SubscribeExclusionSubscriptionIdRouteRoute =
  SubscribeExclusionSubscriptionIdRouteRouteImport.update({
    id: '/subscribe-exclusion/$subscriptionId',
    path: '/subscribe-exclusion/$subscriptionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SubscribeLandingRouteRoute = SubscribeLandingRouteRouteImport.update({
  id: '/subscribe/landing',
  path: '/subscribe/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const customerShellAccountRouteRoute =
  customerShellAccountRouteRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellHealthInsuranceRouteRoute =
  customerShellHealthInsuranceRouteRouteImport.update({
    id: '/health-insurance',
    path: '/health-insurance',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellHomeRouteRoute = customerShellHomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => customerShellRoute,
} as any)
const customerShellInvoicesRouteRoute =
  customerShellInvoicesRouteRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellProductGuaranteesRouteRoute =
  customerShellProductGuaranteesRouteRouteImport.update({
    id: '/product-guarantees',
    path: '/product-guarantees',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellUnpaidInvoicesRouteRoute =
  customerShellUnpaidInvoicesRouteRouteImport.update({
    id: '/unpaid-invoices',
    path: '/unpaid-invoices',
    getParentRoute: () => customerShellRoute,
  } as any)
const redirectsBakActivitiesRouteRoute =
  redirectsBakActivitiesRouteRouteImport.update({
    id: '/(redirects)/bak/activities',
    path: '/bak/activities',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakEphemeralJobsRouteRoute =
  redirectsBakEphemeralJobsRouteRouteImport.update({
    id: '/(redirects)/bak/ephemeral-jobs',
    path: '/bak/ephemeral-jobs',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakHomeRouteRoute = redirectsBakHomeRouteRouteImport.update({
  id: '/(redirects)/bak/home',
  path: '/bak/home',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsBakMembershipsRouteRoute =
  redirectsBakMembershipsRouteRouteImport.update({
    id: '/(redirects)/bak/memberships',
    path: '/bak/memberships',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakMigrationRouteRoute =
  redirectsBakMigrationRouteRouteImport.update({
    id: '/(redirects)/bak/migration',
    path: '/bak/migration',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakNewSubscriptionRouteRoute =
  redirectsBakNewSubscriptionRouteRouteImport.update({
    id: '/(redirects)/bak/new-subscription',
    path: '/bak/new-subscription',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakOrganizationsRouteRoute =
  redirectsBakOrganizationsRouteRouteImport.update({
    id: '/(redirects)/bak/organizations',
    path: '/bak/organizations',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakSearchRouteRoute = redirectsBakSearchRouteRouteImport.update({
  id: '/(redirects)/bak/search',
  path: '/bak/search',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsBakTrackingDocRouteRoute =
  redirectsBakTrackingDocRouteRouteImport.update({
    id: '/(redirects)/bak/tracking-doc',
    path: '/bak/tracking-doc',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPaymentMethodsNewRouteRoute =
  redirectsPaymentMethodsNewRouteRouteImport.update({
    id: '/(redirects)/payment-methods/new',
    path: '/payment-methods/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const BoAdminIndexRoute = BoAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminConsumerStatusRouteRoute =
  BoAdminConsumerStatusRouteRouteImport.update({
    id: '/admin/consumer-status',
    path: '/admin/consumer-status',
    getParentRoute: () => BoRoute,
  } as any)
const BoAdminDebugRouteRoute = BoAdminDebugRouteRouteImport.update({
  id: '/admin/debug',
  path: '/admin/debug',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminImaRouteRoute = BoAdminImaRouteRouteImport.update({
  id: '/admin/ima',
  path: '/admin/ima',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminSystemPromptsRouteRoute =
  BoAdminSystemPromptsRouteRouteImport.update({
    id: '/admin/system-prompts',
    path: '/admin/system-prompts',
    getParentRoute: () => BoRoute,
  } as any)
const BoAdminTimeRouteRoute = BoAdminTimeRouteRouteImport.update({
  id: '/admin/time',
  path: '/admin/time',
  getParentRoute: () => BoRoute,
} as any)
const BoAnnouncementsIndexRoute = BoAnnouncementsIndexRouteImport.update({
  id: '/announcements/',
  path: '/announcements/',
  getParentRoute: () => BoRoute,
} as any)
const BoAnnouncementsNewRoute = BoAnnouncementsNewRouteImport.update({
  id: '/announcements/new',
  path: '/announcements/new',
  getParentRoute: () => BoRoute,
} as any)
const BoContractsIndexRoute = BoContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => BoRoute,
} as any)
const BoDashboardIndexRoute = BoDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => BoRoute,
} as any)
const BoDocumentationIndexRoute = BoDocumentationIndexRouteImport.update({
  id: '/documentation/',
  path: '/documentation/',
  getParentRoute: () => BoRoute,
} as any)
const BoDocumentationActivityConfigurationRouteRoute =
  BoDocumentationActivityConfigurationRouteRouteImport.update({
    id: '/documentation/activity-configuration',
    path: '/documentation/activity-configuration',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationActivitySpecificQuestionsRouteRoute =
  BoDocumentationActivitySpecificQuestionsRouteRouteImport.update({
    id: '/documentation/activity-specific-questions',
    path: '/documentation/activity-specific-questions',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationEmailsRouteRoute =
  BoDocumentationEmailsRouteRouteImport.update({
    id: '/documentation/emails',
    path: '/documentation/emails',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationEndorsementRulesRouteRoute =
  BoDocumentationEndorsementRulesRouteRouteImport.update({
    id: '/documentation/endorsement-rules',
    path: '/documentation/endorsement-rules',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationExclusionsRouteRoute =
  BoDocumentationExclusionsRouteRouteImport.update({
    id: '/documentation/exclusions',
    path: '/documentation/exclusions',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationGeneralTermsRouteRoute =
  BoDocumentationGeneralTermsRouteRouteImport.update({
    id: '/documentation/general-terms',
    path: '/documentation/general-terms',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationInjectableParamsRouteRoute =
  BoDocumentationInjectableParamsRouteRouteImport.update({
    id: '/documentation/injectable-params',
    path: '/documentation/injectable-params',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationInputDimensionsRouteRoute =
  BoDocumentationInputDimensionsRouteRouteImport.update({
    id: '/documentation/input-dimensions',
    path: '/documentation/input-dimensions',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationInvoicingBalanceRouteRoute =
  BoDocumentationInvoicingBalanceRouteRouteImport.update({
    id: '/documentation/invoicing-balance',
    path: '/documentation/invoicing-balance',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationProductsRouteRoute =
  BoDocumentationProductsRouteRouteImport.update({
    id: '/documentation/products',
    path: '/documentation/products',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationReimbursementRulesRouteRoute =
  BoDocumentationReimbursementRulesRouteRouteImport.update({
    id: '/documentation/reimbursement-rules',
    path: '/documentation/reimbursement-rules',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationRolesRouteRoute =
  BoDocumentationRolesRouteRouteImport.update({
    id: '/documentation/roles',
    path: '/documentation/roles',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationSearchRouteRoute =
  BoDocumentationSearchRouteRouteImport.update({
    id: '/documentation/search',
    path: '/documentation/search',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationSubscriptionFunnelTextsRouteRoute =
  BoDocumentationSubscriptionFunnelTextsRouteRouteImport.update({
    id: '/documentation/subscription-funnel-texts',
    path: '/documentation/subscription-funnel-texts',
    getParentRoute: () => BoRoute,
  } as any)
const BoExcludedSubscriptionsIndexRoute =
  BoExcludedSubscriptionsIndexRouteImport.update({
    id: '/excluded-subscriptions/',
    path: '/excluded-subscriptions/',
    getParentRoute: () => BoRoute,
  } as any)
const BoInvoicingInvoiceIdRouteRoute =
  BoInvoicingInvoiceIdRouteRouteImport.update({
    id: '/invoicing/$invoiceId',
    path: '/invoicing/$invoiceId',
    getParentRoute: () => BoRoute,
  } as any)
const BoInvoicingNegativeInvoicesRouteRoute =
  BoInvoicingNegativeInvoicesRouteRouteImport.update({
    id: '/invoicing/negative-invoices',
    path: '/invoicing/negative-invoices',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsIndexRoute = BoOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => BoRoute,
} as any)
const BoOrganizationsCreateRoute = BoOrganizationsCreateRouteImport.update({
  id: '/organizations/create',
  path: '/organizations/create',
  getParentRoute: () => BoRoute,
} as any)
const BoPasskeysIndexRoute = BoPasskeysIndexRouteImport.update({
  id: '/passkeys/',
  path: '/passkeys/',
  getParentRoute: () => BoRoute,
} as any)
const BoProductsIndexRoute = BoProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => BoRoute,
} as any)
const BoRenewalIndexRoute = BoRenewalIndexRouteImport.update({
  id: '/renewal/',
  path: '/renewal/',
  getParentRoute: () => BoRoute,
} as any)
const BoReviewTasksIndexRoute = BoReviewTasksIndexRouteImport.update({
  id: '/review-tasks/',
  path: '/review-tasks/',
  getParentRoute: () => BoRoute,
} as any)
const BoSettingsIndexRoute = BoSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => BoRoute,
} as any)
const BoSubscriptionsIndexRoute = BoSubscriptionsIndexRouteImport.update({
  id: '/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => BoRoute,
} as any)
const BoSubscriptionsGenerateRoute = BoSubscriptionsGenerateRouteImport.update({
  id: '/subscriptions/generate',
  path: '/subscriptions/generate',
  getParentRoute: () => BoRoute,
} as any)
const BoSubscriptionsGenerateFailedRoute =
  BoSubscriptionsGenerateFailedRouteImport.update({
    id: '/subscriptions/generate-failed',
    path: '/subscriptions/generate-failed',
    getParentRoute: () => BoRoute,
  } as any)
const BoSubscriptionsNewRouteRoute = BoSubscriptionsNewRouteRouteImport.update({
  id: '/subscriptions/new',
  path: '/subscriptions/new',
  getParentRoute: () => BoRoute,
} as any)
const BoToolsIndexRoute = BoToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BoToolsRouteRoute,
} as any)
const BoToolsGuaranteesTablesRouteRoute =
  BoToolsGuaranteesTablesRouteRouteImport.update({
    id: '/guarantees-tables',
    path: '/guarantees-tables',
    getParentRoute: () => BoToolsRouteRoute,
  } as any)
const BoUsersIndexRoute = BoUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => BoRoute,
} as any)
const BoUsersUserIdRouteRoute = BoUsersUserIdRouteRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => BoRoute,
} as any)
const FormSubscriptionIdFormIdRouteRoute =
  FormSubscriptionIdFormIdRouteRouteImport.update({
    id: '/form/$subscriptionId/$formId',
    path: '/form/$subscriptionId/$formId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ResourcesDocumentationInjectableParamsRouteRoute =
  ResourcesDocumentationInjectableParamsRouteRouteImport.update({
    id: '/documentation/injectable-params',
    path: '/documentation/injectable-params',
    getParentRoute: () => ResourcesRoute,
  } as any)
const SAttestationsTokenRouteRoute = SAttestationsTokenRouteRouteImport.update({
  id: '/s/attestations/$token',
  path: '/s/attestations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SCTokenRouteRoute = SCTokenRouteRouteImport.update({
  id: '/s/c/$token',
  path: '/s/c/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SEV2TokenRouteRoute = SEV2TokenRouteRouteImport.update({
  id: '/s/e-v2/$token',
  path: '/s/e-v2/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SETokenRouteRoute = SETokenRouteRouteImport.update({
  id: '/s/e/$token',
  path: '/s/e/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SHfTokenRouteRoute = SHfTokenRouteRouteImport.update({
  id: '/s/hf/$token',
  path: '/s/hf/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SQTokenRouteRoute = SQTokenRouteRouteImport.update({
  id: '/s/q/$token',
  path: '/s/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SRTokenRouteRoute = SRTokenRouteRouteImport.update({
  id: '/s/r/$token',
  path: '/s/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeSubscriptionIdStepIdRouteRoute =
  SubscribeSubscriptionIdStepIdRouteRouteImport.update({
    id: '/subscribe/$subscriptionId/$stepId',
    path: '/subscribe/$subscriptionId/$stepId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SubscribeRestaurantsV2IdentifyRouteRoute =
  SubscribeRestaurantsV2IdentifyRouteRouteImport.update({
    id: '/subscribe/restaurants-v2/identify',
    path: '/subscribe/restaurants-v2/identify',
    getParentRoute: () => rootRouteImport,
  } as any)
const customerShellContractsIndexRoute =
  customerShellContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellHealthInsuranceIndexRoute =
  customerShellHealthInsuranceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => customerShellHealthInsuranceRouteRoute,
  } as any)
const customerShellHealthInsuranceBeneficiariesRoute =
  customerShellHealthInsuranceBeneficiariesRouteImport.update({
    id: '/beneficiaries',
    path: '/beneficiaries',
    getParentRoute: () => customerShellHealthInsuranceRouteRoute,
  } as any)
const customerShellHealthInsuranceCpmsRoute =
  customerShellHealthInsuranceCpmsRouteImport.update({
    id: '/cpms',
    path: '/cpms',
    getParentRoute: () => customerShellHealthInsuranceRouteRoute,
  } as any)
const customerShellHealthInsuranceSanteclairRoute =
  customerShellHealthInsuranceSanteclairRouteImport.update({
    id: '/santeclair',
    path: '/santeclair',
    getParentRoute: () => customerShellHealthInsuranceRouteRoute,
  } as any)
const customerShellLegalAssistanceIndexRoute =
  customerShellLegalAssistanceIndexRouteImport.update({
    id: '/legal-assistance/',
    path: '/legal-assistance/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellPaymentMethodsIndexRoute =
  customerShellPaymentMethodsIndexRouteImport.update({
    id: '/payment-methods/',
    path: '/payment-methods/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellProductGuaranteesIndexRoute =
  customerShellProductGuaranteesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => customerShellProductGuaranteesRouteRoute,
  } as any)
const customerShellReferralsIndexRoute =
  customerShellReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellReportClaimIndexRoute =
  customerShellReportClaimIndexRouteImport.update({
    id: '/report-claim/',
    path: '/report-claim/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellUnpaidInvoicesIndexRoute =
  customerShellUnpaidInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => customerShellUnpaidInvoicesRouteRoute,
  } as any)
const customerShellUnpaidInvoicesPaymentRoute =
  customerShellUnpaidInvoicesPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => customerShellUnpaidInvoicesRouteRoute,
  } as any)
const redirectsBakAdminIndexRoute = redirectsBakAdminIndexRouteImport.update({
  id: '/(redirects)/bak/admin/',
  path: '/bak/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsBakAdminImaRouteRoute =
  redirectsBakAdminImaRouteRouteImport.update({
    id: '/(redirects)/bak/admin/ima',
    path: '/bak/admin/ima',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationIndexRoute =
  redirectsBakDocumentationIndexRouteImport.update({
    id: '/(redirects)/bak/documentation/',
    path: '/bak/documentation/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationActivitySpecificQuestionsRouteRoute =
  redirectsBakDocumentationActivitySpecificQuestionsRouteRouteImport.update({
    id: '/(redirects)/bak/documentation/activity-specific-questions',
    path: '/bak/documentation/activity-specific-questions',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationExclusionsRouteRoute =
  redirectsBakDocumentationExclusionsRouteRouteImport.update({
    id: '/(redirects)/bak/documentation/exclusions',
    path: '/bak/documentation/exclusions',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationGeneralTermsRouteRoute =
  redirectsBakDocumentationGeneralTermsRouteRouteImport.update({
    id: '/(redirects)/bak/documentation/general-terms',
    path: '/bak/documentation/general-terms',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationRolesRouteRoute =
  redirectsBakDocumentationRolesRouteRouteImport.update({
    id: '/(redirects)/bak/documentation/roles',
    path: '/bak/documentation/roles',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute =
  redirectsBakDocumentationSubscriptionFunnelTextsRouteRouteImport.update({
    id: '/(redirects)/bak/documentation/subscription-funnel-texts',
    path: '/bak/documentation/subscription-funnel-texts',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakInvoicingNegativeInvoicesListRouteRoute =
  redirectsBakInvoicingNegativeInvoicesListRouteRouteImport.update({
    id: '/(redirects)/bak/invoicing/negative-invoices-list',
    path: '/bak/invoicing/negative-invoices-list',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakPendingSubscriptionsIndexRoute =
  redirectsBakPendingSubscriptionsIndexRouteImport.update({
    id: '/(redirects)/bak/pending-subscriptions/',
    path: '/bak/pending-subscriptions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakUsersIndexRoute = redirectsBakUsersIndexRouteImport.update({
  id: '/(redirects)/bak/users/',
  path: '/bak/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsBakUsersUserIdRouteRoute =
  redirectsBakUsersUserIdRouteRouteImport.update({
    id: '/(redirects)/bak/users/$userId',
    path: '/bak/users/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBoEarningsIndexRoute =
  redirectsBoEarningsIndexRouteImport.update({
    id: '/(redirects)/bo/earnings/',
    path: '/bo/earnings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBoMembershipsIndexRoute =
  redirectsBoMembershipsIndexRouteImport.update({
    id: '/(redirects)/bo/memberships/',
    path: '/bo/memberships/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBoOrganizationDashboardIndexRoute =
  redirectsBoOrganizationDashboardIndexRouteImport.update({
    id: '/(redirects)/bo/organization-dashboard/',
    path: '/bo/organization-dashboard/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBoOrganizationHistoryIndexRoute =
  redirectsBoOrganizationHistoryIndexRouteImport.update({
    id: '/(redirects)/bo/organization-history/',
    path: '/bo/organization-history/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBoSlipsIndexRoute = redirectsBoSlipsIndexRouteImport.update({
  id: '/(redirects)/bo/slips/',
  path: '/bo/slips/',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectsPartnerOrganizationHomeRouteRoute =
  redirectsPartnerOrganizationHomeRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/home',
    path: '/partner/$organization/home',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationNewSubscriptionRouteRoute =
  redirectsPartnerOrganizationNewSubscriptionRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/new-subscription',
    path: '/partner/$organization/new-subscription',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationSearchRouteRoute =
  redirectsPartnerOrganizationSearchRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/search',
    path: '/partner/$organization/search',
    getParentRoute: () => rootRouteImport,
  } as any)
const BoAdminDataWarehouseIndexRoute =
  BoAdminDataWarehouseIndexRouteImport.update({
    id: '/admin/data-warehouse/',
    path: '/admin/data-warehouse/',
    getParentRoute: () => BoRoute,
  } as any)
const BoAdminDispatchersIndexRoute = BoAdminDispatchersIndexRouteImport.update({
  id: '/admin/dispatchers/',
  path: '/admin/dispatchers/',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminJobsIndexRoute = BoAdminJobsIndexRouteImport.update({
  id: '/admin/jobs/',
  path: '/admin/jobs/',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminReducersIndexRoute = BoAdminReducersIndexRouteImport.update({
  id: '/admin/reducers/',
  path: '/admin/reducers/',
  getParentRoute: () => BoRoute,
} as any)
const BoAiUnderwritingRulesIndexRoute =
  BoAiUnderwritingRulesIndexRouteImport.update({
    id: '/ai-underwriting/rules/',
    path: '/ai-underwriting/rules/',
    getParentRoute: () => BoRoute,
  } as any)
const BoAiEvaluationsIndexRoute = BoAiEvaluationsIndexRouteImport.update({
  id: '/ai/evaluations/',
  path: '/ai/evaluations/',
  getParentRoute: () => BoRoute,
} as any)
const BoAiExperimentsAgentIdRoute = BoAiExperimentsAgentIdRouteImport.update({
  id: '/ai/experiments/$agentId',
  path: '/ai/experiments/$agentId',
  getParentRoute: () => BoRoute,
} as any)
const BoAiReviewRunIdRoute = BoAiReviewRunIdRouteImport.update({
  id: '/ai/review/$runId',
  path: '/ai/review/$runId',
  getParentRoute: () => BoRoute,
} as any)
const BoAiRunsIndexRoute = BoAiRunsIndexRouteImport.update({
  id: '/ai/runs/',
  path: '/ai/runs/',
  getParentRoute: () => BoRoute,
} as any)
const BoAiRunsWorkflowIdRoute = BoAiRunsWorkflowIdRouteImport.update({
  id: '/ai/runs/$workflowId',
  path: '/ai/runs/$workflowId',
  getParentRoute: () => BoRoute,
} as any)
const BoAiWorkflowsIndexRoute = BoAiWorkflowsIndexRouteImport.update({
  id: '/ai/workflows/',
  path: '/ai/workflows/',
  getParentRoute: () => BoRoute,
} as any)
const BoAiWorkflowsWorkflowIdRoute = BoAiWorkflowsWorkflowIdRouteImport.update({
  id: '/ai/workflows/$workflowId',
  path: '/ai/workflows/$workflowId',
  getParentRoute: () => BoRoute,
} as any)
const BoAnnouncementsAnnouncementIdIndexRoute =
  BoAnnouncementsAnnouncementIdIndexRouteImport.update({
    id: '/announcements/$announcementId/',
    path: '/announcements/$announcementId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoChallengesChallengeIdSubscribeRoute =
  BoChallengesChallengeIdSubscribeRouteImport.update({
    id: '/challenges/$challengeId/subscribe',
    path: '/challenges/$challengeId/subscribe',
    getParentRoute: () => BoRoute,
  } as any)
const BoClaimsClaimIdIndexRoute = BoClaimsClaimIdIndexRouteImport.update({
  id: '/claims/$claimId/',
  path: '/claims/$claimId/',
  getParentRoute: () => BoRoute,
} as any)
const BoContractsSubscriptionIdIndexRoute =
  BoContractsSubscriptionIdIndexRouteImport.update({
    id: '/contracts/$subscriptionId/',
    path: '/contracts/$subscriptionId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdAttestationsRouteRoute =
  BoContractsSubscriptionIdAttestationsRouteRouteImport.update({
    id: '/contracts/$subscriptionId/attestations',
    path: '/contracts/$subscriptionId/attestations',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdBillingExemptionRouteRoute =
  BoContractsSubscriptionIdBillingExemptionRouteRouteImport.update({
    id: '/contracts/$subscriptionId/billing-exemption',
    path: '/contracts/$subscriptionId/billing-exemption',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdCpmsRouteRoute =
  BoContractsSubscriptionIdCpmsRouteRouteImport.update({
    id: '/contracts/$subscriptionId/cpms',
    path: '/contracts/$subscriptionId/cpms',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute =
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRouteImport.update(
    {
      id: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents',
      path: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents',
      getParentRoute: () => BoRoute,
    } as any,
  )
const BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute =
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRouteImport.update(
    {
      id: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents',
      path: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents',
      getParentRoute: () => BoRoute,
    } as any,
  )
const BoContractsSubscriptionIdStatusRouteRoute =
  BoContractsSubscriptionIdStatusRouteRouteImport.update({
    id: '/contracts/$subscriptionId/status',
    path: '/contracts/$subscriptionId/status',
    getParentRoute: () => BoRoute,
  } as any)
const BoDocumentationExclusionsIndexRoute =
  BoDocumentationExclusionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BoDocumentationExclusionsRouteRoute,
  } as any)
const BoDocumentationExclusionsConfigurationRoute =
  BoDocumentationExclusionsConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => BoDocumentationExclusionsRouteRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameIndexRoute =
  BoOrganizationsOrganizationTechnicalNameIndexRouteImport.update({
    id: '/organizations/$organizationTechnicalName/',
    path: '/organizations/$organizationTechnicalName/',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute =
  BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRouteImport.update({
    id: '/organizations/$organizationTechnicalName/advanced-settings',
    path: '/organizations/$organizationTechnicalName/advanced-settings',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameDashboardRoute =
  BoOrganizationsOrganizationTechnicalNameDashboardRouteImport.update({
    id: '/organizations/$organizationTechnicalName/dashboard',
    path: '/organizations/$organizationTechnicalName/dashboard',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute =
  BoOrganizationsOrganizationTechnicalNameHistoryRouteRouteImport.update({
    id: '/organizations/$organizationTechnicalName/history',
    path: '/organizations/$organizationTechnicalName/history',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameMembersRoute =
  BoOrganizationsOrganizationTechnicalNameMembersRouteImport.update({
    id: '/organizations/$organizationTechnicalName/members',
    path: '/organizations/$organizationTechnicalName/members',
    getParentRoute: () => BoRoute,
  } as any)
const BoOrganizationsOrganizationTechnicalNameSlipsRoute =
  BoOrganizationsOrganizationTechnicalNameSlipsRouteImport.update({
    id: '/organizations/$organizationTechnicalName/slips',
    path: '/organizations/$organizationTechnicalName/slips',
    getParentRoute: () => BoRoute,
  } as any)
const BoProductsProductGroupSlugIndexRoute =
  BoProductsProductGroupSlugIndexRouteImport.update({
    id: '/products/$productGroupSlug/',
    path: '/products/$productGroupSlug/',
    getParentRoute: () => BoRoute,
  } as any)
const BoReviewTasksTaskIdIndexRoute =
  BoReviewTasksTaskIdIndexRouteImport.update({
    id: '/review-tasks/$taskId/',
    path: '/review-tasks/$taskId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoSettingsMembersIndexRoute = BoSettingsMembersIndexRouteImport.update({
  id: '/settings/members/',
  path: '/settings/members/',
  getParentRoute: () => BoRoute,
} as any)
const BoSettingsPaymentDetailsIndexRoute =
  BoSettingsPaymentDetailsIndexRouteImport.update({
    id: '/settings/payment-details/',
    path: '/settings/payment-details/',
    getParentRoute: () => BoRoute,
  } as any)
const BoSettingsSlipsIndexRoute = BoSettingsSlipsIndexRouteImport.update({
  id: '/settings/slips/',
  path: '/settings/slips/',
  getParentRoute: () => BoRoute,
} as any)
const BoSubscriptionsSubscriptionIdIndexRoute =
  BoSubscriptionsSubscriptionIdIndexRouteImport.update({
    id: '/subscriptions/$subscriptionId/',
    path: '/subscriptions/$subscriptionId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute =
  BoSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport.update({
    id: '/subscriptions/$subscriptionId/detailed-sheet',
    path: '/subscriptions/$subscriptionId/detailed-sheet',
    getParentRoute: () => BoRoute,
  } as any)
const BoSubscriptionsSubscriptionIdHistoryRouteRoute =
  BoSubscriptionsSubscriptionIdHistoryRouteRouteImport.update({
    id: '/subscriptions/$subscriptionId/history',
    path: '/subscriptions/$subscriptionId/history',
    getParentRoute: () => BoRoute,
  } as any)
const BoSubscriptionsSubscriptionIdPaymentRouteRoute =
  BoSubscriptionsSubscriptionIdPaymentRouteRouteImport.update({
    id: '/subscriptions/$subscriptionId/payment',
    path: '/subscriptions/$subscriptionId/payment',
    getParentRoute: () => BoRoute,
  } as any)
const BoTroubleshootingSessionsSessionIdRouteRoute =
  BoTroubleshootingSessionsSessionIdRouteRouteImport.update({
    id: '/troubleshooting/sessions/$sessionId',
    path: '/troubleshooting/sessions/$sessionId',
    getParentRoute: () => BoRoute,
  } as any)
const BoUsersUserIdPaymentMethodsRouteRoute =
  BoUsersUserIdPaymentMethodsRouteRouteImport.update({
    id: '/users/$userId_/payment-methods',
    path: '/users/$userId/payment-methods',
    getParentRoute: () => BoRoute,
  } as any)
const BoUsersUserIdUnpaidInvoicesRouteRoute =
  BoUsersUserIdUnpaidInvoicesRouteRouteImport.update({
    id: '/users/$userId_/unpaid-invoices',
    path: '/users/$userId/unpaid-invoices',
    getParentRoute: () => BoRoute,
  } as any)
const SATokenIndexRoute = SATokenIndexRouteImport.update({
  id: '/s/a/$token/',
  path: '/s/a/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const SATokenProductRouteRoute = SATokenProductRouteRouteImport.update({
  id: '/s/a/$token/$product',
  path: '/s/a/$token/$product',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeSubscriptionIdStepIdIndexRoute =
  SubscribeSubscriptionIdStepIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SubscribeSubscriptionIdStepIdRouteRoute,
  } as any)
const customerShellContractsSubscriptionIdIndexRoute =
  customerShellContractsSubscriptionIdIndexRouteImport.update({
    id: '/contracts/$subscriptionId/',
    path: '/contracts/$subscriptionId/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute =
  customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRouteImport.update(
    {
      id: '/insurance-certificate-generator-real-estate-agents/$subscriptionId/',
      path: '/insurance-certificate-generator-real-estate-agents/$subscriptionId/',
      getParentRoute: () => customerShellRoute,
    } as any,
  )
const customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute =
  customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRouteImport.update(
    {
      id: '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/',
      path: '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/',
      getParentRoute: () => customerShellRoute,
    } as any,
  )
const customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute =
  customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteImport.update(
    {
      id: '/$subscriptionId/$productName',
      path: '/$subscriptionId/$productName',
      getParentRoute: () => customerShellProductGuaranteesRouteRoute,
    } as any,
  )
const redirectsBakClaimsClaimIdIndexRoute =
  redirectsBakClaimsClaimIdIndexRouteImport.update({
    id: '/(redirects)/bak/claims/$claimId/',
    path: '/bak/claims/$claimId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakContractsSubscriptionIdIndexRoute =
  redirectsBakContractsSubscriptionIdIndexRouteImport.update({
    id: '/(redirects)/bak/contracts/$subscriptionId/',
    path: '/bak/contracts/$subscriptionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakContractsSubscriptionIdInvoicingRouteRoute =
  redirectsBakContractsSubscriptionIdInvoicingRouteRouteImport.update({
    id: '/(redirects)/bak/contracts/$subscriptionId/invoicing',
    path: '/bak/contracts/$subscriptionId/invoicing',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute =
  redirectsBakContractsSubscriptionIdNewInvoiceRouteRouteImport.update({
    id: '/(redirects)/bak/contracts/$subscriptionId/new-invoice',
    path: '/bak/contracts/$subscriptionId/new-invoice',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakContractsSubscriptionIdStatusRouteRoute =
  redirectsBakContractsSubscriptionIdStatusRouteRouteImport.update({
    id: '/(redirects)/bak/contracts/$subscriptionId/status',
    path: '/bak/contracts/$subscriptionId/status',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute =
  redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRouteImport.update({
    id: '/(redirects)/bak/pending-subscriptions/$subscriptionId/history',
    path: '/bak/pending-subscriptions/$subscriptionId/history',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute =
  redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport.update({
    id: '/(redirects)/bak/pending-subscriptions/$subscriptionId/payment',
    path: '/bak/pending-subscriptions/$subscriptionId/payment',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakTroubleshootingSessionSessionIdRouteRoute =
  redirectsBakTroubleshootingSessionSessionIdRouteRouteImport.update({
    id: '/(redirects)/bak/troubleshooting/session/$sessionId',
    path: '/bak/troubleshooting/session/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute =
  redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRouteImport.update({
    id: '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/',
    path: '/bak/v2-pending-subscriptions/$subscriptionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute =
  redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport.update(
    {
      id: '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet',
      path: '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsPartnerOrganizationClaimsClaimIdRouteRoute =
  redirectsPartnerOrganizationClaimsClaimIdRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/claims/$claimId',
    path: '/partner/$organization/claims/$claimId',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute =
  redirectsPartnerOrganizationContractsSubscriptionIdRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/contracts/$subscriptionId',
    path: '/partner/$organization/contracts/$subscriptionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationPendingSubscriptionsIndexRoute =
  redirectsPartnerOrganizationPendingSubscriptionsIndexRouteImport.update({
    id: '/(redirects)/partner/$organization/pending-subscriptions/',
    path: '/partner/$organization/pending-subscriptions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationUsersIndexRoute =
  redirectsPartnerOrganizationUsersIndexRouteImport.update({
    id: '/(redirects)/partner/$organization/users/',
    path: '/partner/$organization/users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const redirectsPartnerOrganizationUsersUserIdRouteRoute =
  redirectsPartnerOrganizationUsersUserIdRouteRouteImport.update({
    id: '/(redirects)/partner/$organization/users/$userId',
    path: '/partner/$organization/users/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BoAdminJobsJobIdIndexRoute = BoAdminJobsJobIdIndexRouteImport.update({
  id: '/admin/jobs/$jobId/',
  path: '/admin/jobs/$jobId/',
  getParentRoute: () => BoRoute,
} as any)
const BoAdminReducersReducerNameIndexRoute =
  BoAdminReducersReducerNameIndexRouteImport.update({
    id: '/admin/reducers/$reducerName/',
    path: '/admin/reducers/$reducerName/',
    getParentRoute: () => BoRoute,
  } as any)
const BoAiEvaluationsWorkflowIdIndexRoute =
  BoAiEvaluationsWorkflowIdIndexRouteImport.update({
    id: '/ai/evaluations/$workflowId/',
    path: '/ai/evaluations/$workflowId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdInvoicesDebugRouteRoute =
  BoContractsSubscriptionIdInvoicesDebugRouteRouteImport.update({
    id: '/contracts/$subscriptionId/invoices/debug',
    path: '/contracts/$subscriptionId/invoices/debug',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdInvoicesNewRouteRoute =
  BoContractsSubscriptionIdInvoicesNewRouteRouteImport.update({
    id: '/contracts/$subscriptionId/invoices/new',
    path: '/contracts/$subscriptionId/invoices/new',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdPaymentMethodsNewRouteRoute =
  BoContractsSubscriptionIdPaymentMethodsNewRouteRouteImport.update({
    id: '/contracts/$subscriptionId/payment-methods/new',
    path: '/contracts/$subscriptionId/payment-methods/new',
    getParentRoute: () => BoRoute,
  } as any)
const BoUsersUserIdUnpaidInvoicesIndexRoute =
  BoUsersUserIdUnpaidInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BoUsersUserIdUnpaidInvoicesRouteRoute,
  } as any)
const BoUsersUserIdUnpaidInvoicesPaymentRouteRoute =
  BoUsersUserIdUnpaidInvoicesPaymentRouteRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => BoUsersUserIdUnpaidInvoicesRouteRoute,
  } as any)
const SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute =
  SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRouteImport.update({
    id: '/$detailType/$detailId',
    path: '/$detailType/$detailId',
    getParentRoute: () => SubscribeSubscriptionIdStepIdRouteRoute,
  } as any)
const customerShellContractsSubscriptionIdAttestationsIndexRoute =
  customerShellContractsSubscriptionIdAttestationsIndexRouteImport.update({
    id: '/contracts/$subscriptionId/attestations/',
    path: '/contracts/$subscriptionId/attestations/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute =
  customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRouteImport.update(
    {
      id: '/$guaranteeType',
      path: '/$guaranteeType',
      getParentRoute: () =>
        customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute,
    } as any,
  )
const customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute =
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteImport.update(
    {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId',
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute =
  customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRouteImport.update(
    {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion',
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute =
  redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRouteImport.update(
    {
      id: '/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId',
      path: '/bak/contracts/$subscriptionId/renewal/$endorsementId',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute =
  redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport.update(
    {
      id: '/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment',
      path: '/partner/$organization/pending-subscriptions/$subscriptionId/payment',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute =
  redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRouteImport.update(
    {
      id: '/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/',
      path: '/partner/$organization/v2-pending-subscriptions/$subscriptionId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BoAdminJobsJobIdConcurrencyKeyIndexRoute =
  BoAdminJobsJobIdConcurrencyKeyIndexRouteImport.update({
    id: '/admin/jobs/$jobId/$concurrencyKey/',
    path: '/admin/jobs/$jobId/$concurrencyKey/',
    getParentRoute: () => BoRoute,
  } as any)
const BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute =
  BoAiEvaluationsWorkflowIdDatasetsDatasetIdRouteImport.update({
    id: '/ai/evaluations/$workflowId/datasets/$datasetId',
    path: '/ai/evaluations/$workflowId/datasets/$datasetId',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute =
  BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRouteImport.update(
    {
      id: '/contracts/$subscriptionId/$endorsementType/$endorsementId/history',
      path: '/contracts/$subscriptionId/$endorsementType/$endorsementId/history',
      getParentRoute: () => BoRoute,
    } as any,
  )
const BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute =
  BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport.update(
    {
      id: '/contracts/$subscriptionId/detailed-sheet/versions/$versionId',
      path: '/contracts/$subscriptionId/detailed-sheet/versions/$versionId',
      getParentRoute: () => BoRoute,
    } as any,
  )
const BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute =
  BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRouteImport.update({
    id: '/contracts/$subscriptionId/endorsements/$endorsementId/',
    path: '/contracts/$subscriptionId/endorsements/$endorsementId/',
    getParentRoute: () => BoRoute,
  } as any)
const BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute =
  BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRouteImport.update(
    {
      id: '/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet',
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet',
      getParentRoute: () => BoRoute,
    } as any,
  )
const BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute =
  BoContractsSubscriptionIdRenewalsEndorsementIdIndexRouteImport.update({
    id: '/contracts/$subscriptionId/renewals/$endorsementId/',
    path: '/contracts/$subscriptionId/renewals/$endorsementId/',
    getParentRoute: () => BoRoute,
  } as any)
const customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute =
  customerShellContractsSubscriptionIdPaymentMethodsNewIndexRouteImport.update({
    id: '/contracts/$subscriptionId/payment-methods/new/',
    path: '/contracts/$subscriptionId/payment-methods/new/',
    getParentRoute: () => customerShellRoute,
  } as any)
const customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute =
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute,
    } as any,
  )
const customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute =
  customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRouteImport.update(
    {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/',
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute =
  redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport.update(
    {
      id: '/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId',
      path: '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute =
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRouteImport.update(
    {
      id: '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/',
      path: '/bak/contracts/$subscriptionId/endorsement/$endorsementId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute =
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRouteImport.update(
    {
      id: '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet',
      path: '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRouteRoute
  '/login': typeof LoginRouteRoute
  '/receive-quote': typeof ReceiveQuoteRouteRoute
  '/search': typeof SearchRouteRoute
  '/subscribe-no-possible-step': typeof SubscribeNoPossibleStepRouteRoute
  '/unsubscribe': typeof UnsubscribeRouteRoute
  '/bo': typeof BoRouteWithChildren
  '/chat': typeof ChatRoute
  '/resources': typeof ResourcesRouteWithChildren
  '/contract-guarantees': typeof redirectsContractGuaranteesRouteRoute
  '/payment-method-update': typeof redirectsPaymentMethodUpdateRouteRoute
  '/bo/activities': typeof BoActivitiesRouteRoute
  '/bo/activities-old': typeof BoActivitiesOldRouteRoute
  '/bo/ephemeral-jobs': typeof BoEphemeralJobsRouteRoute
  '/bo/generate-slips': typeof BoGenerateSlipsRouteRoute
  '/bo/guarantees-tables': typeof BoGuaranteesTablesRouteRoute
  '/bo/lourmel-sftp': typeof BoLourmelSftpRouteRoute
  '/bo/migration': typeof BoMigrationRouteRoute
  '/bo/referrals': typeof BoReferralsRouteRoute
  '/bo/scripts': typeof BoScriptsRouteRoute
  '/bo/search': typeof BoSearchRouteRoute
  '/bo/tools': typeof BoToolsRouteRouteWithChildren
  '/bo/tracking-doc': typeof BoTrackingDocRouteRoute
  '/payment/authentication': typeof PaymentAuthenticationRouteRoute
  '/r/$code': typeof RCodeRouteRoute
  '/subscribe-exclusion/$subscriptionId': typeof SubscribeExclusionSubscriptionIdRouteRoute
  '/subscribe/landing': typeof SubscribeLandingRouteRoute
  '/bo/': typeof BoIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/account': typeof customerShellAccountRouteRoute
  '/health-insurance': typeof customerShellHealthInsuranceRouteRouteWithChildren
  '/home': typeof customerShellHomeRouteRoute
  '/invoices': typeof customerShellInvoicesRouteRoute
  '/product-guarantees': typeof customerShellProductGuaranteesRouteRouteWithChildren
  '/unpaid-invoices': typeof customerShellUnpaidInvoicesRouteRouteWithChildren
  '/bak/activities': typeof redirectsBakActivitiesRouteRoute
  '/bak/ephemeral-jobs': typeof redirectsBakEphemeralJobsRouteRoute
  '/bak/home': typeof redirectsBakHomeRouteRoute
  '/bak/memberships': typeof redirectsBakMembershipsRouteRoute
  '/bak/migration': typeof redirectsBakMigrationRouteRoute
  '/bak/new-subscription': typeof redirectsBakNewSubscriptionRouteRoute
  '/bak/organizations': typeof redirectsBakOrganizationsRouteRoute
  '/bak/search': typeof redirectsBakSearchRouteRoute
  '/bak/tracking-doc': typeof redirectsBakTrackingDocRouteRoute
  '/payment-methods/new': typeof redirectsPaymentMethodsNewRouteRoute
  '/bo/admin/consumer-status': typeof BoAdminConsumerStatusRouteRoute
  '/bo/admin/debug': typeof BoAdminDebugRouteRoute
  '/bo/admin/ima': typeof BoAdminImaRouteRoute
  '/bo/admin/system-prompts': typeof BoAdminSystemPromptsRouteRoute
  '/bo/admin/time': typeof BoAdminTimeRouteRoute
  '/bo/documentation/activity-configuration': typeof BoDocumentationActivityConfigurationRouteRoute
  '/bo/documentation/activity-specific-questions': typeof BoDocumentationActivitySpecificQuestionsRouteRoute
  '/bo/documentation/emails': typeof BoDocumentationEmailsRouteRoute
  '/bo/documentation/endorsement-rules': typeof BoDocumentationEndorsementRulesRouteRoute
  '/bo/documentation/exclusions': typeof BoDocumentationExclusionsRouteRouteWithChildren
  '/bo/documentation/general-terms': typeof BoDocumentationGeneralTermsRouteRoute
  '/bo/documentation/injectable-params': typeof BoDocumentationInjectableParamsRouteRoute
  '/bo/documentation/input-dimensions': typeof BoDocumentationInputDimensionsRouteRoute
  '/bo/documentation/invoicing-balance': typeof BoDocumentationInvoicingBalanceRouteRoute
  '/bo/documentation/products': typeof BoDocumentationProductsRouteRoute
  '/bo/documentation/reimbursement-rules': typeof BoDocumentationReimbursementRulesRouteRoute
  '/bo/documentation/roles': typeof BoDocumentationRolesRouteRoute
  '/bo/documentation/search': typeof BoDocumentationSearchRouteRoute
  '/bo/documentation/subscription-funnel-texts': typeof BoDocumentationSubscriptionFunnelTextsRouteRoute
  '/bo/invoicing/$invoiceId': typeof BoInvoicingInvoiceIdRouteRoute
  '/bo/invoicing/negative-invoices': typeof BoInvoicingNegativeInvoicesRouteRoute
  '/bo/subscriptions/new': typeof BoSubscriptionsNewRouteRoute
  '/bo/tools/guarantees-tables': typeof BoToolsGuaranteesTablesRouteRoute
  '/bo/users/$userId': typeof BoUsersUserIdRouteRoute
  '/form/$subscriptionId/$formId': typeof FormSubscriptionIdFormIdRouteRoute
  '/resources/documentation/injectable-params': typeof ResourcesDocumentationInjectableParamsRouteRoute
  '/s/attestations/$token': typeof SAttestationsTokenRouteRoute
  '/s/c/$token': typeof SCTokenRouteRoute
  '/s/e-v2/$token': typeof SEV2TokenRouteRoute
  '/s/e/$token': typeof SETokenRouteRoute
  '/s/hf/$token': typeof SHfTokenRouteRoute
  '/s/q/$token': typeof SQTokenRouteRoute
  '/s/r/$token': typeof SRTokenRouteRoute
  '/subscribe/$subscriptionId/$stepId': typeof SubscribeSubscriptionIdStepIdRouteRouteWithChildren
  '/subscribe/restaurants-v2/identify': typeof SubscribeRestaurantsV2IdentifyRouteRoute
  '/bo/announcements/new': typeof BoAnnouncementsNewRoute
  '/bo/organizations/create': typeof BoOrganizationsCreateRoute
  '/bo/subscriptions/generate': typeof BoSubscriptionsGenerateRoute
  '/bo/subscriptions/generate-failed': typeof BoSubscriptionsGenerateFailedRoute
  '/bo/admin/': typeof BoAdminIndexRoute
  '/bo/announcements/': typeof BoAnnouncementsIndexRoute
  '/bo/contracts/': typeof BoContractsIndexRoute
  '/bo/dashboard/': typeof BoDashboardIndexRoute
  '/bo/documentation/': typeof BoDocumentationIndexRoute
  '/bo/excluded-subscriptions/': typeof BoExcludedSubscriptionsIndexRoute
  '/bo/organizations/': typeof BoOrganizationsIndexRoute
  '/bo/passkeys/': typeof BoPasskeysIndexRoute
  '/bo/products/': typeof BoProductsIndexRoute
  '/bo/renewal/': typeof BoRenewalIndexRoute
  '/bo/review-tasks/': typeof BoReviewTasksIndexRoute
  '/bo/settings/': typeof BoSettingsIndexRoute
  '/bo/subscriptions/': typeof BoSubscriptionsIndexRoute
  '/bo/tools/': typeof BoToolsIndexRoute
  '/bo/users/': typeof BoUsersIndexRoute
  '/bak/admin/ima': typeof redirectsBakAdminImaRouteRoute
  '/bak/documentation/activity-specific-questions': typeof redirectsBakDocumentationActivitySpecificQuestionsRouteRoute
  '/bak/documentation/exclusions': typeof redirectsBakDocumentationExclusionsRouteRoute
  '/bak/documentation/general-terms': typeof redirectsBakDocumentationGeneralTermsRouteRoute
  '/bak/documentation/roles': typeof redirectsBakDocumentationRolesRouteRoute
  '/bak/documentation/subscription-funnel-texts': typeof redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute
  '/bak/invoicing/negative-invoices-list': typeof redirectsBakInvoicingNegativeInvoicesListRouteRoute
  '/bak/users/$userId': typeof redirectsBakUsersUserIdRouteRoute
  '/partner/$organization/home': typeof redirectsPartnerOrganizationHomeRouteRoute
  '/partner/$organization/new-subscription': typeof redirectsPartnerOrganizationNewSubscriptionRouteRoute
  '/partner/$organization/search': typeof redirectsPartnerOrganizationSearchRouteRoute
  '/bo/contracts/$subscriptionId/attestations': typeof BoContractsSubscriptionIdAttestationsRouteRoute
  '/bo/contracts/$subscriptionId/billing-exemption': typeof BoContractsSubscriptionIdBillingExemptionRouteRoute
  '/bo/contracts/$subscriptionId/cpms': typeof BoContractsSubscriptionIdCpmsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute
  '/bo/contracts/$subscriptionId/status': typeof BoContractsSubscriptionIdStatusRouteRoute
  '/bo/organizations/$organizationTechnicalName/history': typeof BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/detailed-sheet': typeof BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/bo/subscriptions/$subscriptionId/history': typeof BoSubscriptionsSubscriptionIdHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/payment': typeof BoSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/troubleshooting/sessions/$sessionId': typeof BoTroubleshootingSessionsSessionIdRouteRoute
  '/bo/users/$userId/payment-methods': typeof BoUsersUserIdPaymentMethodsRouteRoute
  '/bo/users/$userId/unpaid-invoices': typeof BoUsersUserIdUnpaidInvoicesRouteRouteWithChildren
  '/s/a/$token/$product': typeof SATokenProductRouteRoute
  '/health-insurance/beneficiaries': typeof customerShellHealthInsuranceBeneficiariesRoute
  '/health-insurance/cpms': typeof customerShellHealthInsuranceCpmsRoute
  '/health-insurance/santeclair': typeof customerShellHealthInsuranceSanteclairRoute
  '/unpaid-invoices/payment': typeof customerShellUnpaidInvoicesPaymentRoute
  '/bo/ai/experiments/$agentId': typeof BoAiExperimentsAgentIdRoute
  '/bo/ai/review/$runId': typeof BoAiReviewRunIdRoute
  '/bo/ai/runs/$workflowId': typeof BoAiRunsWorkflowIdRoute
  '/bo/ai/workflows/$workflowId': typeof BoAiWorkflowsWorkflowIdRoute
  '/bo/challenges/$challengeId/subscribe': typeof BoChallengesChallengeIdSubscribeRoute
  '/bo/documentation/exclusions/configuration': typeof BoDocumentationExclusionsConfigurationRoute
  '/bo/organizations/$organizationTechnicalName/advanced-settings': typeof BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute
  '/bo/organizations/$organizationTechnicalName/dashboard': typeof BoOrganizationsOrganizationTechnicalNameDashboardRoute
  '/bo/organizations/$organizationTechnicalName/members': typeof BoOrganizationsOrganizationTechnicalNameMembersRoute
  '/bo/organizations/$organizationTechnicalName/slips': typeof BoOrganizationsOrganizationTechnicalNameSlipsRoute
  '/contracts/': typeof customerShellContractsIndexRoute
  '/health-insurance/': typeof customerShellHealthInsuranceIndexRoute
  '/legal-assistance/': typeof customerShellLegalAssistanceIndexRoute
  '/payment-methods/': typeof customerShellPaymentMethodsIndexRoute
  '/product-guarantees/': typeof customerShellProductGuaranteesIndexRoute
  '/referrals/': typeof customerShellReferralsIndexRoute
  '/report-claim/': typeof customerShellReportClaimIndexRoute
  '/unpaid-invoices/': typeof customerShellUnpaidInvoicesIndexRoute
  '/bak/admin/': typeof redirectsBakAdminIndexRoute
  '/bak/documentation/': typeof redirectsBakDocumentationIndexRoute
  '/bak/pending-subscriptions/': typeof redirectsBakPendingSubscriptionsIndexRoute
  '/bak/users/': typeof redirectsBakUsersIndexRoute
  '/bo/earnings/': typeof redirectsBoEarningsIndexRoute
  '/bo/memberships/': typeof redirectsBoMembershipsIndexRoute
  '/bo/organization-dashboard/': typeof redirectsBoOrganizationDashboardIndexRoute
  '/bo/organization-history/': typeof redirectsBoOrganizationHistoryIndexRoute
  '/bo/slips/': typeof redirectsBoSlipsIndexRoute
  '/bo/admin/data-warehouse/': typeof BoAdminDataWarehouseIndexRoute
  '/bo/admin/dispatchers/': typeof BoAdminDispatchersIndexRoute
  '/bo/admin/jobs/': typeof BoAdminJobsIndexRoute
  '/bo/admin/reducers/': typeof BoAdminReducersIndexRoute
  '/bo/ai-underwriting/rules/': typeof BoAiUnderwritingRulesIndexRoute
  '/bo/ai/evaluations/': typeof BoAiEvaluationsIndexRoute
  '/bo/ai/runs/': typeof BoAiRunsIndexRoute
  '/bo/ai/workflows/': typeof BoAiWorkflowsIndexRoute
  '/bo/announcements/$announcementId/': typeof BoAnnouncementsAnnouncementIdIndexRoute
  '/bo/claims/$claimId/': typeof BoClaimsClaimIdIndexRoute
  '/bo/contracts/$subscriptionId/': typeof BoContractsSubscriptionIdIndexRoute
  '/bo/documentation/exclusions/': typeof BoDocumentationExclusionsIndexRoute
  '/bo/organizations/$organizationTechnicalName/': typeof BoOrganizationsOrganizationTechnicalNameIndexRoute
  '/bo/products/$productGroupSlug/': typeof BoProductsProductGroupSlugIndexRoute
  '/bo/review-tasks/$taskId/': typeof BoReviewTasksTaskIdIndexRoute
  '/bo/settings/members/': typeof BoSettingsMembersIndexRoute
  '/bo/settings/payment-details/': typeof BoSettingsPaymentDetailsIndexRoute
  '/bo/settings/slips/': typeof BoSettingsSlipsIndexRoute
  '/bo/subscriptions/$subscriptionId/': typeof BoSubscriptionsSubscriptionIdIndexRoute
  '/s/a/$token/': typeof SATokenIndexRoute
  '/subscribe/$subscriptionId/$stepId/': typeof SubscribeSubscriptionIdStepIdIndexRoute
  '/product-guarantees/$subscriptionId/$productName': typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren
  '/bak/contracts/$subscriptionId/invoicing': typeof redirectsBakContractsSubscriptionIdInvoicingRouteRoute
  '/bak/contracts/$subscriptionId/new-invoice': typeof redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute
  '/bak/contracts/$subscriptionId/status': typeof redirectsBakContractsSubscriptionIdStatusRouteRoute
  '/bak/pending-subscriptions/$subscriptionId/history': typeof redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute
  '/bak/pending-subscriptions/$subscriptionId/payment': typeof redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bak/troubleshooting/session/$sessionId': typeof redirectsBakTroubleshootingSessionSessionIdRouteRoute
  '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/partner/$organization/claims/$claimId': typeof redirectsPartnerOrganizationClaimsClaimIdRouteRoute
  '/partner/$organization/contracts/$subscriptionId': typeof redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute
  '/partner/$organization/users/$userId': typeof redirectsPartnerOrganizationUsersUserIdRouteRoute
  '/bo/contracts/$subscriptionId/invoices/debug': typeof BoContractsSubscriptionIdInvoicesDebugRouteRoute
  '/bo/contracts/$subscriptionId/invoices/new': typeof BoContractsSubscriptionIdInvoicesNewRouteRoute
  '/bo/contracts/$subscriptionId/payment-methods/new': typeof BoContractsSubscriptionIdPaymentMethodsNewRouteRoute
  '/bo/users/$userId/unpaid-invoices/payment': typeof BoUsersUserIdUnpaidInvoicesPaymentRouteRoute
  '/subscribe/$subscriptionId/$stepId/$detailType/$detailId': typeof SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute
  '/contracts/$subscriptionId/': typeof customerShellContractsSubscriptionIdIndexRoute
  '/insurance-certificate-generator-real-estate-agents/$subscriptionId/': typeof customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute
  '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/': typeof customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute
  '/bak/claims/$claimId/': typeof redirectsBakClaimsClaimIdIndexRoute
  '/bak/contracts/$subscriptionId/': typeof redirectsBakContractsSubscriptionIdIndexRoute
  '/bak/v2-pending-subscriptions/$subscriptionId/': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/partner/$organization/pending-subscriptions/': typeof redirectsPartnerOrganizationPendingSubscriptionsIndexRoute
  '/partner/$organization/users/': typeof redirectsPartnerOrganizationUsersIndexRoute
  '/bo/admin/jobs/$jobId/': typeof BoAdminJobsJobIdIndexRoute
  '/bo/admin/reducers/$reducerName/': typeof BoAdminReducersReducerNameIndexRoute
  '/bo/ai/evaluations/$workflowId/': typeof BoAiEvaluationsWorkflowIdIndexRoute
  '/bo/users/$userId/unpaid-invoices/': typeof BoUsersUserIdUnpaidInvoicesIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteWithChildren
  '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute
  '/bak/contracts/$subscriptionId/renewal/$endorsementId': typeof redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute
  '/partner/$organization/pending-subscriptions/$subscriptionId/payment': typeof redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history': typeof BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute
  '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute
  '/product-guarantees/$subscriptionId/$productName/$guaranteeType': typeof customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute
  '/bo/ai/evaluations/$workflowId/datasets/$datasetId': typeof BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute
  '/contracts/$subscriptionId/attestations/': typeof customerShellContractsSubscriptionIdAttestationsIndexRoute
  '/partner/$organization/v2-pending-subscriptions/$subscriptionId/': typeof redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/bo/admin/jobs/$jobId/$concurrencyKey/': typeof BoAdminJobsJobIdConcurrencyKeyIndexRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId/': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute
  '/bo/contracts/$subscriptionId/renewals/$endorsementId/': typeof BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute
  '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute
  '/contracts/$subscriptionId/payment-methods/new/': typeof customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute
  '/bak/contracts/$subscriptionId/endorsement/$endorsementId/': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRouteRoute
  '/login': typeof LoginRouteRoute
  '/receive-quote': typeof ReceiveQuoteRouteRoute
  '/search': typeof SearchRouteRoute
  '/subscribe-no-possible-step': typeof SubscribeNoPossibleStepRouteRoute
  '/unsubscribe': typeof UnsubscribeRouteRoute
  '/chat': typeof ChatRoute
  '/contract-guarantees': typeof redirectsContractGuaranteesRouteRoute
  '/payment-method-update': typeof redirectsPaymentMethodUpdateRouteRoute
  '/bo/activities': typeof BoActivitiesRouteRoute
  '/bo/activities-old': typeof BoActivitiesOldRouteRoute
  '/bo/ephemeral-jobs': typeof BoEphemeralJobsRouteRoute
  '/bo/generate-slips': typeof BoGenerateSlipsRouteRoute
  '/bo/guarantees-tables': typeof BoGuaranteesTablesRouteRoute
  '/bo/lourmel-sftp': typeof BoLourmelSftpRouteRoute
  '/bo/migration': typeof BoMigrationRouteRoute
  '/bo/referrals': typeof BoReferralsRouteRoute
  '/bo/scripts': typeof BoScriptsRouteRoute
  '/bo/search': typeof BoSearchRouteRoute
  '/bo/tracking-doc': typeof BoTrackingDocRouteRoute
  '/payment/authentication': typeof PaymentAuthenticationRouteRoute
  '/r/$code': typeof RCodeRouteRoute
  '/subscribe-exclusion/$subscriptionId': typeof SubscribeExclusionSubscriptionIdRouteRoute
  '/subscribe/landing': typeof SubscribeLandingRouteRoute
  '/bo': typeof BoIndexRoute
  '/resources': typeof ResourcesIndexRoute
  '/account': typeof customerShellAccountRouteRoute
  '/home': typeof customerShellHomeRouteRoute
  '/invoices': typeof customerShellInvoicesRouteRoute
  '/bak/activities': typeof redirectsBakActivitiesRouteRoute
  '/bak/ephemeral-jobs': typeof redirectsBakEphemeralJobsRouteRoute
  '/bak/home': typeof redirectsBakHomeRouteRoute
  '/bak/memberships': typeof redirectsBakMembershipsRouteRoute
  '/bak/migration': typeof redirectsBakMigrationRouteRoute
  '/bak/new-subscription': typeof redirectsBakNewSubscriptionRouteRoute
  '/bak/organizations': typeof redirectsBakOrganizationsRouteRoute
  '/bak/search': typeof redirectsBakSearchRouteRoute
  '/bak/tracking-doc': typeof redirectsBakTrackingDocRouteRoute
  '/payment-methods/new': typeof redirectsPaymentMethodsNewRouteRoute
  '/bo/admin/consumer-status': typeof BoAdminConsumerStatusRouteRoute
  '/bo/admin/debug': typeof BoAdminDebugRouteRoute
  '/bo/admin/ima': typeof BoAdminImaRouteRoute
  '/bo/admin/system-prompts': typeof BoAdminSystemPromptsRouteRoute
  '/bo/admin/time': typeof BoAdminTimeRouteRoute
  '/bo/documentation/activity-configuration': typeof BoDocumentationActivityConfigurationRouteRoute
  '/bo/documentation/activity-specific-questions': typeof BoDocumentationActivitySpecificQuestionsRouteRoute
  '/bo/documentation/emails': typeof BoDocumentationEmailsRouteRoute
  '/bo/documentation/endorsement-rules': typeof BoDocumentationEndorsementRulesRouteRoute
  '/bo/documentation/general-terms': typeof BoDocumentationGeneralTermsRouteRoute
  '/bo/documentation/injectable-params': typeof BoDocumentationInjectableParamsRouteRoute
  '/bo/documentation/input-dimensions': typeof BoDocumentationInputDimensionsRouteRoute
  '/bo/documentation/invoicing-balance': typeof BoDocumentationInvoicingBalanceRouteRoute
  '/bo/documentation/products': typeof BoDocumentationProductsRouteRoute
  '/bo/documentation/reimbursement-rules': typeof BoDocumentationReimbursementRulesRouteRoute
  '/bo/documentation/roles': typeof BoDocumentationRolesRouteRoute
  '/bo/documentation/search': typeof BoDocumentationSearchRouteRoute
  '/bo/documentation/subscription-funnel-texts': typeof BoDocumentationSubscriptionFunnelTextsRouteRoute
  '/bo/invoicing/$invoiceId': typeof BoInvoicingInvoiceIdRouteRoute
  '/bo/invoicing/negative-invoices': typeof BoInvoicingNegativeInvoicesRouteRoute
  '/bo/subscriptions/new': typeof BoSubscriptionsNewRouteRoute
  '/bo/tools/guarantees-tables': typeof BoToolsGuaranteesTablesRouteRoute
  '/bo/users/$userId': typeof BoUsersUserIdRouteRoute
  '/form/$subscriptionId/$formId': typeof FormSubscriptionIdFormIdRouteRoute
  '/resources/documentation/injectable-params': typeof ResourcesDocumentationInjectableParamsRouteRoute
  '/s/attestations/$token': typeof SAttestationsTokenRouteRoute
  '/s/c/$token': typeof SCTokenRouteRoute
  '/s/e-v2/$token': typeof SEV2TokenRouteRoute
  '/s/e/$token': typeof SETokenRouteRoute
  '/s/hf/$token': typeof SHfTokenRouteRoute
  '/s/q/$token': typeof SQTokenRouteRoute
  '/s/r/$token': typeof SRTokenRouteRoute
  '/subscribe/restaurants-v2/identify': typeof SubscribeRestaurantsV2IdentifyRouteRoute
  '/bo/announcements/new': typeof BoAnnouncementsNewRoute
  '/bo/organizations/create': typeof BoOrganizationsCreateRoute
  '/bo/subscriptions/generate': typeof BoSubscriptionsGenerateRoute
  '/bo/subscriptions/generate-failed': typeof BoSubscriptionsGenerateFailedRoute
  '/bo/admin': typeof BoAdminIndexRoute
  '/bo/announcements': typeof BoAnnouncementsIndexRoute
  '/bo/contracts': typeof BoContractsIndexRoute
  '/bo/dashboard': typeof BoDashboardIndexRoute
  '/bo/documentation': typeof BoDocumentationIndexRoute
  '/bo/excluded-subscriptions': typeof BoExcludedSubscriptionsIndexRoute
  '/bo/organizations': typeof BoOrganizationsIndexRoute
  '/bo/passkeys': typeof BoPasskeysIndexRoute
  '/bo/products': typeof BoProductsIndexRoute
  '/bo/renewal': typeof BoRenewalIndexRoute
  '/bo/review-tasks': typeof BoReviewTasksIndexRoute
  '/bo/settings': typeof BoSettingsIndexRoute
  '/bo/subscriptions': typeof BoSubscriptionsIndexRoute
  '/bo/tools': typeof BoToolsIndexRoute
  '/bo/users': typeof BoUsersIndexRoute
  '/bak/admin/ima': typeof redirectsBakAdminImaRouteRoute
  '/bak/documentation/activity-specific-questions': typeof redirectsBakDocumentationActivitySpecificQuestionsRouteRoute
  '/bak/documentation/exclusions': typeof redirectsBakDocumentationExclusionsRouteRoute
  '/bak/documentation/general-terms': typeof redirectsBakDocumentationGeneralTermsRouteRoute
  '/bak/documentation/roles': typeof redirectsBakDocumentationRolesRouteRoute
  '/bak/documentation/subscription-funnel-texts': typeof redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute
  '/bak/invoicing/negative-invoices-list': typeof redirectsBakInvoicingNegativeInvoicesListRouteRoute
  '/bak/users/$userId': typeof redirectsBakUsersUserIdRouteRoute
  '/partner/$organization/home': typeof redirectsPartnerOrganizationHomeRouteRoute
  '/partner/$organization/new-subscription': typeof redirectsPartnerOrganizationNewSubscriptionRouteRoute
  '/partner/$organization/search': typeof redirectsPartnerOrganizationSearchRouteRoute
  '/bo/contracts/$subscriptionId/attestations': typeof BoContractsSubscriptionIdAttestationsRouteRoute
  '/bo/contracts/$subscriptionId/billing-exemption': typeof BoContractsSubscriptionIdBillingExemptionRouteRoute
  '/bo/contracts/$subscriptionId/cpms': typeof BoContractsSubscriptionIdCpmsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute
  '/bo/contracts/$subscriptionId/status': typeof BoContractsSubscriptionIdStatusRouteRoute
  '/bo/organizations/$organizationTechnicalName/history': typeof BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/detailed-sheet': typeof BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/bo/subscriptions/$subscriptionId/history': typeof BoSubscriptionsSubscriptionIdHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/payment': typeof BoSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/troubleshooting/sessions/$sessionId': typeof BoTroubleshootingSessionsSessionIdRouteRoute
  '/bo/users/$userId/payment-methods': typeof BoUsersUserIdPaymentMethodsRouteRoute
  '/s/a/$token/$product': typeof SATokenProductRouteRoute
  '/health-insurance/beneficiaries': typeof customerShellHealthInsuranceBeneficiariesRoute
  '/health-insurance/cpms': typeof customerShellHealthInsuranceCpmsRoute
  '/health-insurance/santeclair': typeof customerShellHealthInsuranceSanteclairRoute
  '/unpaid-invoices/payment': typeof customerShellUnpaidInvoicesPaymentRoute
  '/bo/ai/experiments/$agentId': typeof BoAiExperimentsAgentIdRoute
  '/bo/ai/review/$runId': typeof BoAiReviewRunIdRoute
  '/bo/ai/runs/$workflowId': typeof BoAiRunsWorkflowIdRoute
  '/bo/ai/workflows/$workflowId': typeof BoAiWorkflowsWorkflowIdRoute
  '/bo/challenges/$challengeId/subscribe': typeof BoChallengesChallengeIdSubscribeRoute
  '/bo/documentation/exclusions/configuration': typeof BoDocumentationExclusionsConfigurationRoute
  '/bo/organizations/$organizationTechnicalName/advanced-settings': typeof BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute
  '/bo/organizations/$organizationTechnicalName/dashboard': typeof BoOrganizationsOrganizationTechnicalNameDashboardRoute
  '/bo/organizations/$organizationTechnicalName/members': typeof BoOrganizationsOrganizationTechnicalNameMembersRoute
  '/bo/organizations/$organizationTechnicalName/slips': typeof BoOrganizationsOrganizationTechnicalNameSlipsRoute
  '/contracts': typeof customerShellContractsIndexRoute
  '/health-insurance': typeof customerShellHealthInsuranceIndexRoute
  '/legal-assistance': typeof customerShellLegalAssistanceIndexRoute
  '/payment-methods': typeof customerShellPaymentMethodsIndexRoute
  '/product-guarantees': typeof customerShellProductGuaranteesIndexRoute
  '/referrals': typeof customerShellReferralsIndexRoute
  '/report-claim': typeof customerShellReportClaimIndexRoute
  '/unpaid-invoices': typeof customerShellUnpaidInvoicesIndexRoute
  '/bak/admin': typeof redirectsBakAdminIndexRoute
  '/bak/documentation': typeof redirectsBakDocumentationIndexRoute
  '/bak/pending-subscriptions': typeof redirectsBakPendingSubscriptionsIndexRoute
  '/bak/users': typeof redirectsBakUsersIndexRoute
  '/bo/earnings': typeof redirectsBoEarningsIndexRoute
  '/bo/memberships': typeof redirectsBoMembershipsIndexRoute
  '/bo/organization-dashboard': typeof redirectsBoOrganizationDashboardIndexRoute
  '/bo/organization-history': typeof redirectsBoOrganizationHistoryIndexRoute
  '/bo/slips': typeof redirectsBoSlipsIndexRoute
  '/bo/admin/data-warehouse': typeof BoAdminDataWarehouseIndexRoute
  '/bo/admin/dispatchers': typeof BoAdminDispatchersIndexRoute
  '/bo/admin/jobs': typeof BoAdminJobsIndexRoute
  '/bo/admin/reducers': typeof BoAdminReducersIndexRoute
  '/bo/ai-underwriting/rules': typeof BoAiUnderwritingRulesIndexRoute
  '/bo/ai/evaluations': typeof BoAiEvaluationsIndexRoute
  '/bo/ai/runs': typeof BoAiRunsIndexRoute
  '/bo/ai/workflows': typeof BoAiWorkflowsIndexRoute
  '/bo/announcements/$announcementId': typeof BoAnnouncementsAnnouncementIdIndexRoute
  '/bo/claims/$claimId': typeof BoClaimsClaimIdIndexRoute
  '/bo/contracts/$subscriptionId': typeof BoContractsSubscriptionIdIndexRoute
  '/bo/documentation/exclusions': typeof BoDocumentationExclusionsIndexRoute
  '/bo/organizations/$organizationTechnicalName': typeof BoOrganizationsOrganizationTechnicalNameIndexRoute
  '/bo/products/$productGroupSlug': typeof BoProductsProductGroupSlugIndexRoute
  '/bo/review-tasks/$taskId': typeof BoReviewTasksTaskIdIndexRoute
  '/bo/settings/members': typeof BoSettingsMembersIndexRoute
  '/bo/settings/payment-details': typeof BoSettingsPaymentDetailsIndexRoute
  '/bo/settings/slips': typeof BoSettingsSlipsIndexRoute
  '/bo/subscriptions/$subscriptionId': typeof BoSubscriptionsSubscriptionIdIndexRoute
  '/s/a/$token': typeof SATokenIndexRoute
  '/subscribe/$subscriptionId/$stepId': typeof SubscribeSubscriptionIdStepIdIndexRoute
  '/product-guarantees/$subscriptionId/$productName': typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren
  '/bak/contracts/$subscriptionId/invoicing': typeof redirectsBakContractsSubscriptionIdInvoicingRouteRoute
  '/bak/contracts/$subscriptionId/new-invoice': typeof redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute
  '/bak/contracts/$subscriptionId/status': typeof redirectsBakContractsSubscriptionIdStatusRouteRoute
  '/bak/pending-subscriptions/$subscriptionId/history': typeof redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute
  '/bak/pending-subscriptions/$subscriptionId/payment': typeof redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bak/troubleshooting/session/$sessionId': typeof redirectsBakTroubleshootingSessionSessionIdRouteRoute
  '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/partner/$organization/claims/$claimId': typeof redirectsPartnerOrganizationClaimsClaimIdRouteRoute
  '/partner/$organization/contracts/$subscriptionId': typeof redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute
  '/partner/$organization/users/$userId': typeof redirectsPartnerOrganizationUsersUserIdRouteRoute
  '/bo/contracts/$subscriptionId/invoices/debug': typeof BoContractsSubscriptionIdInvoicesDebugRouteRoute
  '/bo/contracts/$subscriptionId/invoices/new': typeof BoContractsSubscriptionIdInvoicesNewRouteRoute
  '/bo/contracts/$subscriptionId/payment-methods/new': typeof BoContractsSubscriptionIdPaymentMethodsNewRouteRoute
  '/bo/users/$userId/unpaid-invoices/payment': typeof BoUsersUserIdUnpaidInvoicesPaymentRouteRoute
  '/subscribe/$subscriptionId/$stepId/$detailType/$detailId': typeof SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute
  '/contracts/$subscriptionId': typeof customerShellContractsSubscriptionIdIndexRoute
  '/insurance-certificate-generator-real-estate-agents/$subscriptionId': typeof customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute
  '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId': typeof customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute
  '/bak/claims/$claimId': typeof redirectsBakClaimsClaimIdIndexRoute
  '/bak/contracts/$subscriptionId': typeof redirectsBakContractsSubscriptionIdIndexRoute
  '/bak/v2-pending-subscriptions/$subscriptionId': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/partner/$organization/pending-subscriptions': typeof redirectsPartnerOrganizationPendingSubscriptionsIndexRoute
  '/partner/$organization/users': typeof redirectsPartnerOrganizationUsersIndexRoute
  '/bo/admin/jobs/$jobId': typeof BoAdminJobsJobIdIndexRoute
  '/bo/admin/reducers/$reducerName': typeof BoAdminReducersReducerNameIndexRoute
  '/bo/ai/evaluations/$workflowId': typeof BoAiEvaluationsWorkflowIdIndexRoute
  '/bo/users/$userId/unpaid-invoices': typeof BoUsersUserIdUnpaidInvoicesIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute
  '/bak/contracts/$subscriptionId/renewal/$endorsementId': typeof redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute
  '/partner/$organization/pending-subscriptions/$subscriptionId/payment': typeof redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history': typeof BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute
  '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute
  '/product-guarantees/$subscriptionId/$productName/$guaranteeType': typeof customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute
  '/bo/ai/evaluations/$workflowId/datasets/$datasetId': typeof BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute
  '/contracts/$subscriptionId/attestations': typeof customerShellContractsSubscriptionIdAttestationsIndexRoute
  '/partner/$organization/v2-pending-subscriptions/$subscriptionId': typeof redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/bo/admin/jobs/$jobId/$concurrencyKey': typeof BoAdminJobsJobIdConcurrencyKeyIndexRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute
  '/bo/contracts/$subscriptionId/renewals/$endorsementId': typeof BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute
  '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute
  '/contracts/$subscriptionId/payment-methods/new': typeof customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute
  '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute
  '/bak/contracts/$subscriptionId/endorsement/$endorsementId': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRouteRoute
  '/login': typeof LoginRouteRoute
  '/receive-quote': typeof ReceiveQuoteRouteRoute
  '/search': typeof SearchRouteRoute
  '/subscribe-no-possible-step': typeof SubscribeNoPossibleStepRouteRoute
  '/unsubscribe': typeof UnsubscribeRouteRoute
  '/bo': typeof BoRouteWithChildren
  '/chat': typeof ChatRoute
  '/resources': typeof ResourcesRouteWithChildren
  '/(redirects)/contract-guarantees': typeof redirectsContractGuaranteesRouteRoute
  '/(redirects)/payment-method-update': typeof redirectsPaymentMethodUpdateRouteRoute
  '/bo/activities': typeof BoActivitiesRouteRoute
  '/bo/activities-old': typeof BoActivitiesOldRouteRoute
  '/bo/ephemeral-jobs': typeof BoEphemeralJobsRouteRoute
  '/bo/generate-slips': typeof BoGenerateSlipsRouteRoute
  '/bo/guarantees-tables': typeof BoGuaranteesTablesRouteRoute
  '/bo/lourmel-sftp': typeof BoLourmelSftpRouteRoute
  '/bo/migration': typeof BoMigrationRouteRoute
  '/bo/referrals': typeof BoReferralsRouteRoute
  '/bo/scripts': typeof BoScriptsRouteRoute
  '/bo/search': typeof BoSearchRouteRoute
  '/bo/tools': typeof BoToolsRouteRouteWithChildren
  '/bo/tracking-doc': typeof BoTrackingDocRouteRoute
  '/payment/authentication': typeof PaymentAuthenticationRouteRoute
  '/r/$code': typeof RCodeRouteRoute
  '/subscribe-exclusion/$subscriptionId': typeof SubscribeExclusionSubscriptionIdRouteRoute
  '/subscribe/landing': typeof SubscribeLandingRouteRoute
  '/(customer)/_shell': typeof customerShellRouteWithChildren
  '/bo/': typeof BoIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/(customer)/_shell/account': typeof customerShellAccountRouteRoute
  '/(customer)/_shell/health-insurance': typeof customerShellHealthInsuranceRouteRouteWithChildren
  '/(customer)/_shell/home': typeof customerShellHomeRouteRoute
  '/(customer)/_shell/invoices': typeof customerShellInvoicesRouteRoute
  '/(customer)/_shell/product-guarantees': typeof customerShellProductGuaranteesRouteRouteWithChildren
  '/(customer)/_shell/unpaid-invoices': typeof customerShellUnpaidInvoicesRouteRouteWithChildren
  '/(redirects)/bak/activities': typeof redirectsBakActivitiesRouteRoute
  '/(redirects)/bak/ephemeral-jobs': typeof redirectsBakEphemeralJobsRouteRoute
  '/(redirects)/bak/home': typeof redirectsBakHomeRouteRoute
  '/(redirects)/bak/memberships': typeof redirectsBakMembershipsRouteRoute
  '/(redirects)/bak/migration': typeof redirectsBakMigrationRouteRoute
  '/(redirects)/bak/new-subscription': typeof redirectsBakNewSubscriptionRouteRoute
  '/(redirects)/bak/organizations': typeof redirectsBakOrganizationsRouteRoute
  '/(redirects)/bak/search': typeof redirectsBakSearchRouteRoute
  '/(redirects)/bak/tracking-doc': typeof redirectsBakTrackingDocRouteRoute
  '/(redirects)/payment-methods/new': typeof redirectsPaymentMethodsNewRouteRoute
  '/bo/admin/consumer-status': typeof BoAdminConsumerStatusRouteRoute
  '/bo/admin/debug': typeof BoAdminDebugRouteRoute
  '/bo/admin/ima': typeof BoAdminImaRouteRoute
  '/bo/admin/system-prompts': typeof BoAdminSystemPromptsRouteRoute
  '/bo/admin/time': typeof BoAdminTimeRouteRoute
  '/bo/documentation/activity-configuration': typeof BoDocumentationActivityConfigurationRouteRoute
  '/bo/documentation/activity-specific-questions': typeof BoDocumentationActivitySpecificQuestionsRouteRoute
  '/bo/documentation/emails': typeof BoDocumentationEmailsRouteRoute
  '/bo/documentation/endorsement-rules': typeof BoDocumentationEndorsementRulesRouteRoute
  '/bo/documentation/exclusions': typeof BoDocumentationExclusionsRouteRouteWithChildren
  '/bo/documentation/general-terms': typeof BoDocumentationGeneralTermsRouteRoute
  '/bo/documentation/injectable-params': typeof BoDocumentationInjectableParamsRouteRoute
  '/bo/documentation/input-dimensions': typeof BoDocumentationInputDimensionsRouteRoute
  '/bo/documentation/invoicing-balance': typeof BoDocumentationInvoicingBalanceRouteRoute
  '/bo/documentation/products': typeof BoDocumentationProductsRouteRoute
  '/bo/documentation/reimbursement-rules': typeof BoDocumentationReimbursementRulesRouteRoute
  '/bo/documentation/roles': typeof BoDocumentationRolesRouteRoute
  '/bo/documentation/search': typeof BoDocumentationSearchRouteRoute
  '/bo/documentation/subscription-funnel-texts': typeof BoDocumentationSubscriptionFunnelTextsRouteRoute
  '/bo/invoicing/$invoiceId': typeof BoInvoicingInvoiceIdRouteRoute
  '/bo/invoicing/negative-invoices': typeof BoInvoicingNegativeInvoicesRouteRoute
  '/bo/subscriptions/new': typeof BoSubscriptionsNewRouteRoute
  '/bo/tools/guarantees-tables': typeof BoToolsGuaranteesTablesRouteRoute
  '/bo/users/$userId': typeof BoUsersUserIdRouteRoute
  '/form/$subscriptionId/$formId': typeof FormSubscriptionIdFormIdRouteRoute
  '/resources/documentation/injectable-params': typeof ResourcesDocumentationInjectableParamsRouteRoute
  '/s/attestations/$token': typeof SAttestationsTokenRouteRoute
  '/s/c/$token': typeof SCTokenRouteRoute
  '/s/e-v2/$token': typeof SEV2TokenRouteRoute
  '/s/e/$token': typeof SETokenRouteRoute
  '/s/hf/$token': typeof SHfTokenRouteRoute
  '/s/q/$token': typeof SQTokenRouteRoute
  '/s/r/$token': typeof SRTokenRouteRoute
  '/subscribe/$subscriptionId/$stepId': typeof SubscribeSubscriptionIdStepIdRouteRouteWithChildren
  '/subscribe/restaurants-v2/identify': typeof SubscribeRestaurantsV2IdentifyRouteRoute
  '/bo/announcements/new': typeof BoAnnouncementsNewRoute
  '/bo/organizations/create': typeof BoOrganizationsCreateRoute
  '/bo/subscriptions/generate': typeof BoSubscriptionsGenerateRoute
  '/bo/subscriptions/generate-failed': typeof BoSubscriptionsGenerateFailedRoute
  '/bo/admin/': typeof BoAdminIndexRoute
  '/bo/announcements/': typeof BoAnnouncementsIndexRoute
  '/bo/contracts/': typeof BoContractsIndexRoute
  '/bo/dashboard/': typeof BoDashboardIndexRoute
  '/bo/documentation/': typeof BoDocumentationIndexRoute
  '/bo/excluded-subscriptions/': typeof BoExcludedSubscriptionsIndexRoute
  '/bo/organizations/': typeof BoOrganizationsIndexRoute
  '/bo/passkeys/': typeof BoPasskeysIndexRoute
  '/bo/products/': typeof BoProductsIndexRoute
  '/bo/renewal/': typeof BoRenewalIndexRoute
  '/bo/review-tasks/': typeof BoReviewTasksIndexRoute
  '/bo/settings/': typeof BoSettingsIndexRoute
  '/bo/subscriptions/': typeof BoSubscriptionsIndexRoute
  '/bo/tools/': typeof BoToolsIndexRoute
  '/bo/users/': typeof BoUsersIndexRoute
  '/(redirects)/bak/admin/ima': typeof redirectsBakAdminImaRouteRoute
  '/(redirects)/bak/documentation/activity-specific-questions': typeof redirectsBakDocumentationActivitySpecificQuestionsRouteRoute
  '/(redirects)/bak/documentation/exclusions': typeof redirectsBakDocumentationExclusionsRouteRoute
  '/(redirects)/bak/documentation/general-terms': typeof redirectsBakDocumentationGeneralTermsRouteRoute
  '/(redirects)/bak/documentation/roles': typeof redirectsBakDocumentationRolesRouteRoute
  '/(redirects)/bak/documentation/subscription-funnel-texts': typeof redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute
  '/(redirects)/bak/invoicing/negative-invoices-list': typeof redirectsBakInvoicingNegativeInvoicesListRouteRoute
  '/(redirects)/bak/users/$userId': typeof redirectsBakUsersUserIdRouteRoute
  '/(redirects)/partner/$organization/home': typeof redirectsPartnerOrganizationHomeRouteRoute
  '/(redirects)/partner/$organization/new-subscription': typeof redirectsPartnerOrganizationNewSubscriptionRouteRoute
  '/(redirects)/partner/$organization/search': typeof redirectsPartnerOrganizationSearchRouteRoute
  '/bo/contracts/$subscriptionId/attestations': typeof BoContractsSubscriptionIdAttestationsRouteRoute
  '/bo/contracts/$subscriptionId/billing-exemption': typeof BoContractsSubscriptionIdBillingExemptionRouteRoute
  '/bo/contracts/$subscriptionId/cpms': typeof BoContractsSubscriptionIdCpmsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents': typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute
  '/bo/contracts/$subscriptionId/status': typeof BoContractsSubscriptionIdStatusRouteRoute
  '/bo/organizations/$organizationTechnicalName/history': typeof BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/detailed-sheet': typeof BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/bo/subscriptions/$subscriptionId/history': typeof BoSubscriptionsSubscriptionIdHistoryRouteRoute
  '/bo/subscriptions/$subscriptionId/payment': typeof BoSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/troubleshooting/sessions/$sessionId': typeof BoTroubleshootingSessionsSessionIdRouteRoute
  '/bo/users/$userId_/payment-methods': typeof BoUsersUserIdPaymentMethodsRouteRoute
  '/bo/users/$userId_/unpaid-invoices': typeof BoUsersUserIdUnpaidInvoicesRouteRouteWithChildren
  '/s/a/$token/$product': typeof SATokenProductRouteRoute
  '/(customer)/_shell/health-insurance/beneficiaries': typeof customerShellHealthInsuranceBeneficiariesRoute
  '/(customer)/_shell/health-insurance/cpms': typeof customerShellHealthInsuranceCpmsRoute
  '/(customer)/_shell/health-insurance/santeclair': typeof customerShellHealthInsuranceSanteclairRoute
  '/(customer)/_shell/unpaid-invoices/payment': typeof customerShellUnpaidInvoicesPaymentRoute
  '/bo/ai/experiments/$agentId': typeof BoAiExperimentsAgentIdRoute
  '/bo/ai/review/$runId': typeof BoAiReviewRunIdRoute
  '/bo/ai/runs/$workflowId': typeof BoAiRunsWorkflowIdRoute
  '/bo/ai/workflows/$workflowId': typeof BoAiWorkflowsWorkflowIdRoute
  '/bo/challenges/$challengeId/subscribe': typeof BoChallengesChallengeIdSubscribeRoute
  '/bo/documentation/exclusions/configuration': typeof BoDocumentationExclusionsConfigurationRoute
  '/bo/organizations/$organizationTechnicalName/advanced-settings': typeof BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute
  '/bo/organizations/$organizationTechnicalName/dashboard': typeof BoOrganizationsOrganizationTechnicalNameDashboardRoute
  '/bo/organizations/$organizationTechnicalName/members': typeof BoOrganizationsOrganizationTechnicalNameMembersRoute
  '/bo/organizations/$organizationTechnicalName/slips': typeof BoOrganizationsOrganizationTechnicalNameSlipsRoute
  '/(customer)/_shell/contracts/': typeof customerShellContractsIndexRoute
  '/(customer)/_shell/health-insurance/': typeof customerShellHealthInsuranceIndexRoute
  '/(customer)/_shell/legal-assistance/': typeof customerShellLegalAssistanceIndexRoute
  '/(customer)/_shell/payment-methods/': typeof customerShellPaymentMethodsIndexRoute
  '/(customer)/_shell/product-guarantees/': typeof customerShellProductGuaranteesIndexRoute
  '/(customer)/_shell/referrals/': typeof customerShellReferralsIndexRoute
  '/(customer)/_shell/report-claim/': typeof customerShellReportClaimIndexRoute
  '/(customer)/_shell/unpaid-invoices/': typeof customerShellUnpaidInvoicesIndexRoute
  '/(redirects)/bak/admin/': typeof redirectsBakAdminIndexRoute
  '/(redirects)/bak/documentation/': typeof redirectsBakDocumentationIndexRoute
  '/(redirects)/bak/pending-subscriptions/': typeof redirectsBakPendingSubscriptionsIndexRoute
  '/(redirects)/bak/users/': typeof redirectsBakUsersIndexRoute
  '/(redirects)/bo/earnings/': typeof redirectsBoEarningsIndexRoute
  '/(redirects)/bo/memberships/': typeof redirectsBoMembershipsIndexRoute
  '/(redirects)/bo/organization-dashboard/': typeof redirectsBoOrganizationDashboardIndexRoute
  '/(redirects)/bo/organization-history/': typeof redirectsBoOrganizationHistoryIndexRoute
  '/(redirects)/bo/slips/': typeof redirectsBoSlipsIndexRoute
  '/bo/admin/data-warehouse/': typeof BoAdminDataWarehouseIndexRoute
  '/bo/admin/dispatchers/': typeof BoAdminDispatchersIndexRoute
  '/bo/admin/jobs/': typeof BoAdminJobsIndexRoute
  '/bo/admin/reducers/': typeof BoAdminReducersIndexRoute
  '/bo/ai-underwriting/rules/': typeof BoAiUnderwritingRulesIndexRoute
  '/bo/ai/evaluations/': typeof BoAiEvaluationsIndexRoute
  '/bo/ai/runs/': typeof BoAiRunsIndexRoute
  '/bo/ai/workflows/': typeof BoAiWorkflowsIndexRoute
  '/bo/announcements/$announcementId/': typeof BoAnnouncementsAnnouncementIdIndexRoute
  '/bo/claims/$claimId/': typeof BoClaimsClaimIdIndexRoute
  '/bo/contracts/$subscriptionId/': typeof BoContractsSubscriptionIdIndexRoute
  '/bo/documentation/exclusions/': typeof BoDocumentationExclusionsIndexRoute
  '/bo/organizations/$organizationTechnicalName/': typeof BoOrganizationsOrganizationTechnicalNameIndexRoute
  '/bo/products/$productGroupSlug/': typeof BoProductsProductGroupSlugIndexRoute
  '/bo/review-tasks/$taskId/': typeof BoReviewTasksTaskIdIndexRoute
  '/bo/settings/members/': typeof BoSettingsMembersIndexRoute
  '/bo/settings/payment-details/': typeof BoSettingsPaymentDetailsIndexRoute
  '/bo/settings/slips/': typeof BoSettingsSlipsIndexRoute
  '/bo/subscriptions/$subscriptionId/': typeof BoSubscriptionsSubscriptionIdIndexRoute
  '/s/a/$token/': typeof SATokenIndexRoute
  '/subscribe/$subscriptionId/$stepId/': typeof SubscribeSubscriptionIdStepIdIndexRoute
  '/(customer)/_shell/product-guarantees/$subscriptionId/$productName': typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren
  '/(redirects)/bak/contracts/$subscriptionId/invoicing': typeof redirectsBakContractsSubscriptionIdInvoicingRouteRoute
  '/(redirects)/bak/contracts/$subscriptionId/new-invoice': typeof redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute
  '/(redirects)/bak/contracts/$subscriptionId/status': typeof redirectsBakContractsSubscriptionIdStatusRouteRoute
  '/(redirects)/bak/pending-subscriptions/$subscriptionId/history': typeof redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute
  '/(redirects)/bak/pending-subscriptions/$subscriptionId/payment': typeof redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/(redirects)/bak/troubleshooting/session/$sessionId': typeof redirectsBakTroubleshootingSessionSessionIdRouteRoute
  '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  '/(redirects)/partner/$organization/claims/$claimId': typeof redirectsPartnerOrganizationClaimsClaimIdRouteRoute
  '/(redirects)/partner/$organization/contracts/$subscriptionId': typeof redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute
  '/(redirects)/partner/$organization/users/$userId': typeof redirectsPartnerOrganizationUsersUserIdRouteRoute
  '/bo/contracts/$subscriptionId/invoices/debug': typeof BoContractsSubscriptionIdInvoicesDebugRouteRoute
  '/bo/contracts/$subscriptionId/invoices/new': typeof BoContractsSubscriptionIdInvoicesNewRouteRoute
  '/bo/contracts/$subscriptionId/payment-methods/new': typeof BoContractsSubscriptionIdPaymentMethodsNewRouteRoute
  '/bo/users/$userId_/unpaid-invoices/payment': typeof BoUsersUserIdUnpaidInvoicesPaymentRouteRoute
  '/subscribe/$subscriptionId/$stepId/$detailType/$detailId': typeof SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute
  '/(customer)/_shell/contracts/$subscriptionId/': typeof customerShellContractsSubscriptionIdIndexRoute
  '/(customer)/_shell/insurance-certificate-generator-real-estate-agents/$subscriptionId/': typeof customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute
  '/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/': typeof customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute
  '/(redirects)/bak/claims/$claimId/': typeof redirectsBakClaimsClaimIdIndexRoute
  '/(redirects)/bak/contracts/$subscriptionId/': typeof redirectsBakContractsSubscriptionIdIndexRoute
  '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/': typeof redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/(redirects)/partner/$organization/pending-subscriptions/': typeof redirectsPartnerOrganizationPendingSubscriptionsIndexRoute
  '/(redirects)/partner/$organization/users/': typeof redirectsPartnerOrganizationUsersIndexRoute
  '/bo/admin/jobs/$jobId/': typeof BoAdminJobsJobIdIndexRoute
  '/bo/admin/reducers/$reducerName/': typeof BoAdminReducersReducerNameIndexRoute
  '/bo/ai/evaluations/$workflowId/': typeof BoAiEvaluationsWorkflowIdIndexRoute
  '/bo/users/$userId_/unpaid-invoices/': typeof BoUsersUserIdUnpaidInvoicesIndexRoute
  '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteWithChildren
  '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute
  '/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId': typeof redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute
  '/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment': typeof redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history': typeof BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute
  '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute
  '/(customer)/_shell/product-guarantees/$subscriptionId/$productName/$guaranteeType': typeof customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute
  '/bo/ai/evaluations/$workflowId/datasets/$datasetId': typeof BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute
  '/(customer)/_shell/contracts/$subscriptionId/attestations/': typeof customerShellContractsSubscriptionIdAttestationsIndexRoute
  '/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/': typeof redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute
  '/bo/admin/jobs/$jobId/$concurrencyKey/': typeof BoAdminJobsJobIdConcurrencyKeyIndexRoute
  '/bo/contracts/$subscriptionId/endorsements/$endorsementId/': typeof BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute
  '/bo/contracts/$subscriptionId/renewals/$endorsementId/': typeof BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute
  '/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId': typeof redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute
  '/(customer)/_shell/contracts/$subscriptionId/payment-methods/new/': typeof customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute
  '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute
  '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/': typeof customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute
  '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/': typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/login'
    | '/receive-quote'
    | '/search'
    | '/subscribe-no-possible-step'
    | '/unsubscribe'
    | '/bo'
    | '/chat'
    | '/resources'
    | '/contract-guarantees'
    | '/payment-method-update'
    | '/bo/activities'
    | '/bo/activities-old'
    | '/bo/ephemeral-jobs'
    | '/bo/generate-slips'
    | '/bo/guarantees-tables'
    | '/bo/lourmel-sftp'
    | '/bo/migration'
    | '/bo/referrals'
    | '/bo/scripts'
    | '/bo/search'
    | '/bo/tools'
    | '/bo/tracking-doc'
    | '/payment/authentication'
    | '/r/$code'
    | '/subscribe-exclusion/$subscriptionId'
    | '/subscribe/landing'
    | '/bo/'
    | '/resources/'
    | '/account'
    | '/health-insurance'
    | '/home'
    | '/invoices'
    | '/product-guarantees'
    | '/unpaid-invoices'
    | '/bak/activities'
    | '/bak/ephemeral-jobs'
    | '/bak/home'
    | '/bak/memberships'
    | '/bak/migration'
    | '/bak/new-subscription'
    | '/bak/organizations'
    | '/bak/search'
    | '/bak/tracking-doc'
    | '/payment-methods/new'
    | '/bo/admin/consumer-status'
    | '/bo/admin/debug'
    | '/bo/admin/ima'
    | '/bo/admin/system-prompts'
    | '/bo/admin/time'
    | '/bo/documentation/activity-configuration'
    | '/bo/documentation/activity-specific-questions'
    | '/bo/documentation/emails'
    | '/bo/documentation/endorsement-rules'
    | '/bo/documentation/exclusions'
    | '/bo/documentation/general-terms'
    | '/bo/documentation/injectable-params'
    | '/bo/documentation/input-dimensions'
    | '/bo/documentation/invoicing-balance'
    | '/bo/documentation/products'
    | '/bo/documentation/reimbursement-rules'
    | '/bo/documentation/roles'
    | '/bo/documentation/search'
    | '/bo/documentation/subscription-funnel-texts'
    | '/bo/invoicing/$invoiceId'
    | '/bo/invoicing/negative-invoices'
    | '/bo/subscriptions/new'
    | '/bo/tools/guarantees-tables'
    | '/bo/users/$userId'
    | '/form/$subscriptionId/$formId'
    | '/resources/documentation/injectable-params'
    | '/s/attestations/$token'
    | '/s/c/$token'
    | '/s/e-v2/$token'
    | '/s/e/$token'
    | '/s/hf/$token'
    | '/s/q/$token'
    | '/s/r/$token'
    | '/subscribe/$subscriptionId/$stepId'
    | '/subscribe/restaurants-v2/identify'
    | '/bo/announcements/new'
    | '/bo/organizations/create'
    | '/bo/subscriptions/generate'
    | '/bo/subscriptions/generate-failed'
    | '/bo/admin/'
    | '/bo/announcements/'
    | '/bo/contracts/'
    | '/bo/dashboard/'
    | '/bo/documentation/'
    | '/bo/excluded-subscriptions/'
    | '/bo/organizations/'
    | '/bo/passkeys/'
    | '/bo/products/'
    | '/bo/renewal/'
    | '/bo/review-tasks/'
    | '/bo/settings/'
    | '/bo/subscriptions/'
    | '/bo/tools/'
    | '/bo/users/'
    | '/bak/admin/ima'
    | '/bak/documentation/activity-specific-questions'
    | '/bak/documentation/exclusions'
    | '/bak/documentation/general-terms'
    | '/bak/documentation/roles'
    | '/bak/documentation/subscription-funnel-texts'
    | '/bak/invoicing/negative-invoices-list'
    | '/bak/users/$userId'
    | '/partner/$organization/home'
    | '/partner/$organization/new-subscription'
    | '/partner/$organization/search'
    | '/bo/contracts/$subscriptionId/attestations'
    | '/bo/contracts/$subscriptionId/billing-exemption'
    | '/bo/contracts/$subscriptionId/cpms'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
    | '/bo/contracts/$subscriptionId/status'
    | '/bo/organizations/$organizationTechnicalName/history'
    | '/bo/subscriptions/$subscriptionId/detailed-sheet'
    | '/bo/subscriptions/$subscriptionId/history'
    | '/bo/subscriptions/$subscriptionId/payment'
    | '/bo/troubleshooting/sessions/$sessionId'
    | '/bo/users/$userId/payment-methods'
    | '/bo/users/$userId/unpaid-invoices'
    | '/s/a/$token/$product'
    | '/health-insurance/beneficiaries'
    | '/health-insurance/cpms'
    | '/health-insurance/santeclair'
    | '/unpaid-invoices/payment'
    | '/bo/ai/experiments/$agentId'
    | '/bo/ai/review/$runId'
    | '/bo/ai/runs/$workflowId'
    | '/bo/ai/workflows/$workflowId'
    | '/bo/challenges/$challengeId/subscribe'
    | '/bo/documentation/exclusions/configuration'
    | '/bo/organizations/$organizationTechnicalName/advanced-settings'
    | '/bo/organizations/$organizationTechnicalName/dashboard'
    | '/bo/organizations/$organizationTechnicalName/members'
    | '/bo/organizations/$organizationTechnicalName/slips'
    | '/contracts/'
    | '/health-insurance/'
    | '/legal-assistance/'
    | '/payment-methods/'
    | '/product-guarantees/'
    | '/referrals/'
    | '/report-claim/'
    | '/unpaid-invoices/'
    | '/bak/admin/'
    | '/bak/documentation/'
    | '/bak/pending-subscriptions/'
    | '/bak/users/'
    | '/bo/earnings/'
    | '/bo/memberships/'
    | '/bo/organization-dashboard/'
    | '/bo/organization-history/'
    | '/bo/slips/'
    | '/bo/admin/data-warehouse/'
    | '/bo/admin/dispatchers/'
    | '/bo/admin/jobs/'
    | '/bo/admin/reducers/'
    | '/bo/ai-underwriting/rules/'
    | '/bo/ai/evaluations/'
    | '/bo/ai/runs/'
    | '/bo/ai/workflows/'
    | '/bo/announcements/$announcementId/'
    | '/bo/claims/$claimId/'
    | '/bo/contracts/$subscriptionId/'
    | '/bo/documentation/exclusions/'
    | '/bo/organizations/$organizationTechnicalName/'
    | '/bo/products/$productGroupSlug/'
    | '/bo/review-tasks/$taskId/'
    | '/bo/settings/members/'
    | '/bo/settings/payment-details/'
    | '/bo/settings/slips/'
    | '/bo/subscriptions/$subscriptionId/'
    | '/s/a/$token/'
    | '/subscribe/$subscriptionId/$stepId/'
    | '/product-guarantees/$subscriptionId/$productName'
    | '/bak/contracts/$subscriptionId/invoicing'
    | '/bak/contracts/$subscriptionId/new-invoice'
    | '/bak/contracts/$subscriptionId/status'
    | '/bak/pending-subscriptions/$subscriptionId/history'
    | '/bak/pending-subscriptions/$subscriptionId/payment'
    | '/bak/troubleshooting/session/$sessionId'
    | '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
    | '/partner/$organization/claims/$claimId'
    | '/partner/$organization/contracts/$subscriptionId'
    | '/partner/$organization/users/$userId'
    | '/bo/contracts/$subscriptionId/invoices/debug'
    | '/bo/contracts/$subscriptionId/invoices/new'
    | '/bo/contracts/$subscriptionId/payment-methods/new'
    | '/bo/users/$userId/unpaid-invoices/payment'
    | '/subscribe/$subscriptionId/$stepId/$detailType/$detailId'
    | '/contracts/$subscriptionId/'
    | '/insurance-certificate-generator-real-estate-agents/$subscriptionId/'
    | '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/'
    | '/bak/claims/$claimId/'
    | '/bak/contracts/$subscriptionId/'
    | '/bak/v2-pending-subscriptions/$subscriptionId/'
    | '/partner/$organization/pending-subscriptions/'
    | '/partner/$organization/users/'
    | '/bo/admin/jobs/$jobId/'
    | '/bo/admin/reducers/$reducerName/'
    | '/bo/ai/evaluations/$workflowId/'
    | '/bo/users/$userId/unpaid-invoices/'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
    | '/bak/contracts/$subscriptionId/renewal/$endorsementId'
    | '/partner/$organization/pending-subscriptions/$subscriptionId/payment'
    | '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
    | '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
    | '/product-guarantees/$subscriptionId/$productName/$guaranteeType'
    | '/bo/ai/evaluations/$workflowId/datasets/$datasetId'
    | '/contracts/$subscriptionId/attestations/'
    | '/partner/$organization/v2-pending-subscriptions/$subscriptionId/'
    | '/bo/admin/jobs/$jobId/$concurrencyKey/'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId/'
    | '/bo/contracts/$subscriptionId/renewals/$endorsementId/'
    | '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
    | '/contracts/$subscriptionId/payment-methods/new/'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/'
    | '/bak/contracts/$subscriptionId/endorsement/$endorsementId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/login'
    | '/receive-quote'
    | '/search'
    | '/subscribe-no-possible-step'
    | '/unsubscribe'
    | '/chat'
    | '/contract-guarantees'
    | '/payment-method-update'
    | '/bo/activities'
    | '/bo/activities-old'
    | '/bo/ephemeral-jobs'
    | '/bo/generate-slips'
    | '/bo/guarantees-tables'
    | '/bo/lourmel-sftp'
    | '/bo/migration'
    | '/bo/referrals'
    | '/bo/scripts'
    | '/bo/search'
    | '/bo/tracking-doc'
    | '/payment/authentication'
    | '/r/$code'
    | '/subscribe-exclusion/$subscriptionId'
    | '/subscribe/landing'
    | '/bo'
    | '/resources'
    | '/account'
    | '/home'
    | '/invoices'
    | '/bak/activities'
    | '/bak/ephemeral-jobs'
    | '/bak/home'
    | '/bak/memberships'
    | '/bak/migration'
    | '/bak/new-subscription'
    | '/bak/organizations'
    | '/bak/search'
    | '/bak/tracking-doc'
    | '/payment-methods/new'
    | '/bo/admin/consumer-status'
    | '/bo/admin/debug'
    | '/bo/admin/ima'
    | '/bo/admin/system-prompts'
    | '/bo/admin/time'
    | '/bo/documentation/activity-configuration'
    | '/bo/documentation/activity-specific-questions'
    | '/bo/documentation/emails'
    | '/bo/documentation/endorsement-rules'
    | '/bo/documentation/general-terms'
    | '/bo/documentation/injectable-params'
    | '/bo/documentation/input-dimensions'
    | '/bo/documentation/invoicing-balance'
    | '/bo/documentation/products'
    | '/bo/documentation/reimbursement-rules'
    | '/bo/documentation/roles'
    | '/bo/documentation/search'
    | '/bo/documentation/subscription-funnel-texts'
    | '/bo/invoicing/$invoiceId'
    | '/bo/invoicing/negative-invoices'
    | '/bo/subscriptions/new'
    | '/bo/tools/guarantees-tables'
    | '/bo/users/$userId'
    | '/form/$subscriptionId/$formId'
    | '/resources/documentation/injectable-params'
    | '/s/attestations/$token'
    | '/s/c/$token'
    | '/s/e-v2/$token'
    | '/s/e/$token'
    | '/s/hf/$token'
    | '/s/q/$token'
    | '/s/r/$token'
    | '/subscribe/restaurants-v2/identify'
    | '/bo/announcements/new'
    | '/bo/organizations/create'
    | '/bo/subscriptions/generate'
    | '/bo/subscriptions/generate-failed'
    | '/bo/admin'
    | '/bo/announcements'
    | '/bo/contracts'
    | '/bo/dashboard'
    | '/bo/documentation'
    | '/bo/excluded-subscriptions'
    | '/bo/organizations'
    | '/bo/passkeys'
    | '/bo/products'
    | '/bo/renewal'
    | '/bo/review-tasks'
    | '/bo/settings'
    | '/bo/subscriptions'
    | '/bo/tools'
    | '/bo/users'
    | '/bak/admin/ima'
    | '/bak/documentation/activity-specific-questions'
    | '/bak/documentation/exclusions'
    | '/bak/documentation/general-terms'
    | '/bak/documentation/roles'
    | '/bak/documentation/subscription-funnel-texts'
    | '/bak/invoicing/negative-invoices-list'
    | '/bak/users/$userId'
    | '/partner/$organization/home'
    | '/partner/$organization/new-subscription'
    | '/partner/$organization/search'
    | '/bo/contracts/$subscriptionId/attestations'
    | '/bo/contracts/$subscriptionId/billing-exemption'
    | '/bo/contracts/$subscriptionId/cpms'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
    | '/bo/contracts/$subscriptionId/status'
    | '/bo/organizations/$organizationTechnicalName/history'
    | '/bo/subscriptions/$subscriptionId/detailed-sheet'
    | '/bo/subscriptions/$subscriptionId/history'
    | '/bo/subscriptions/$subscriptionId/payment'
    | '/bo/troubleshooting/sessions/$sessionId'
    | '/bo/users/$userId/payment-methods'
    | '/s/a/$token/$product'
    | '/health-insurance/beneficiaries'
    | '/health-insurance/cpms'
    | '/health-insurance/santeclair'
    | '/unpaid-invoices/payment'
    | '/bo/ai/experiments/$agentId'
    | '/bo/ai/review/$runId'
    | '/bo/ai/runs/$workflowId'
    | '/bo/ai/workflows/$workflowId'
    | '/bo/challenges/$challengeId/subscribe'
    | '/bo/documentation/exclusions/configuration'
    | '/bo/organizations/$organizationTechnicalName/advanced-settings'
    | '/bo/organizations/$organizationTechnicalName/dashboard'
    | '/bo/organizations/$organizationTechnicalName/members'
    | '/bo/organizations/$organizationTechnicalName/slips'
    | '/contracts'
    | '/health-insurance'
    | '/legal-assistance'
    | '/payment-methods'
    | '/product-guarantees'
    | '/referrals'
    | '/report-claim'
    | '/unpaid-invoices'
    | '/bak/admin'
    | '/bak/documentation'
    | '/bak/pending-subscriptions'
    | '/bak/users'
    | '/bo/earnings'
    | '/bo/memberships'
    | '/bo/organization-dashboard'
    | '/bo/organization-history'
    | '/bo/slips'
    | '/bo/admin/data-warehouse'
    | '/bo/admin/dispatchers'
    | '/bo/admin/jobs'
    | '/bo/admin/reducers'
    | '/bo/ai-underwriting/rules'
    | '/bo/ai/evaluations'
    | '/bo/ai/runs'
    | '/bo/ai/workflows'
    | '/bo/announcements/$announcementId'
    | '/bo/claims/$claimId'
    | '/bo/contracts/$subscriptionId'
    | '/bo/documentation/exclusions'
    | '/bo/organizations/$organizationTechnicalName'
    | '/bo/products/$productGroupSlug'
    | '/bo/review-tasks/$taskId'
    | '/bo/settings/members'
    | '/bo/settings/payment-details'
    | '/bo/settings/slips'
    | '/bo/subscriptions/$subscriptionId'
    | '/s/a/$token'
    | '/subscribe/$subscriptionId/$stepId'
    | '/product-guarantees/$subscriptionId/$productName'
    | '/bak/contracts/$subscriptionId/invoicing'
    | '/bak/contracts/$subscriptionId/new-invoice'
    | '/bak/contracts/$subscriptionId/status'
    | '/bak/pending-subscriptions/$subscriptionId/history'
    | '/bak/pending-subscriptions/$subscriptionId/payment'
    | '/bak/troubleshooting/session/$sessionId'
    | '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
    | '/partner/$organization/claims/$claimId'
    | '/partner/$organization/contracts/$subscriptionId'
    | '/partner/$organization/users/$userId'
    | '/bo/contracts/$subscriptionId/invoices/debug'
    | '/bo/contracts/$subscriptionId/invoices/new'
    | '/bo/contracts/$subscriptionId/payment-methods/new'
    | '/bo/users/$userId/unpaid-invoices/payment'
    | '/subscribe/$subscriptionId/$stepId/$detailType/$detailId'
    | '/contracts/$subscriptionId'
    | '/insurance-certificate-generator-real-estate-agents/$subscriptionId'
    | '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId'
    | '/bak/claims/$claimId'
    | '/bak/contracts/$subscriptionId'
    | '/bak/v2-pending-subscriptions/$subscriptionId'
    | '/partner/$organization/pending-subscriptions'
    | '/partner/$organization/users'
    | '/bo/admin/jobs/$jobId'
    | '/bo/admin/reducers/$reducerName'
    | '/bo/ai/evaluations/$workflowId'
    | '/bo/users/$userId/unpaid-invoices'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
    | '/bak/contracts/$subscriptionId/renewal/$endorsementId'
    | '/partner/$organization/pending-subscriptions/$subscriptionId/payment'
    | '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
    | '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
    | '/product-guarantees/$subscriptionId/$productName/$guaranteeType'
    | '/bo/ai/evaluations/$workflowId/datasets/$datasetId'
    | '/contracts/$subscriptionId/attestations'
    | '/partner/$organization/v2-pending-subscriptions/$subscriptionId'
    | '/bo/admin/jobs/$jobId/$concurrencyKey'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId'
    | '/bo/contracts/$subscriptionId/renewals/$endorsementId'
    | '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
    | '/contracts/$subscriptionId/payment-methods/new'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
    | '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result'
    | '/bak/contracts/$subscriptionId/endorsement/$endorsementId'
  id:
    | '__root__'
    | '/'
    | '/impersonate'
    | '/login'
    | '/receive-quote'
    | '/search'
    | '/subscribe-no-possible-step'
    | '/unsubscribe'
    | '/bo'
    | '/chat'
    | '/resources'
    | '/(redirects)/contract-guarantees'
    | '/(redirects)/payment-method-update'
    | '/bo/activities'
    | '/bo/activities-old'
    | '/bo/ephemeral-jobs'
    | '/bo/generate-slips'
    | '/bo/guarantees-tables'
    | '/bo/lourmel-sftp'
    | '/bo/migration'
    | '/bo/referrals'
    | '/bo/scripts'
    | '/bo/search'
    | '/bo/tools'
    | '/bo/tracking-doc'
    | '/payment/authentication'
    | '/r/$code'
    | '/subscribe-exclusion/$subscriptionId'
    | '/subscribe/landing'
    | '/(customer)/_shell'
    | '/bo/'
    | '/resources/'
    | '/(customer)/_shell/account'
    | '/(customer)/_shell/health-insurance'
    | '/(customer)/_shell/home'
    | '/(customer)/_shell/invoices'
    | '/(customer)/_shell/product-guarantees'
    | '/(customer)/_shell/unpaid-invoices'
    | '/(redirects)/bak/activities'
    | '/(redirects)/bak/ephemeral-jobs'
    | '/(redirects)/bak/home'
    | '/(redirects)/bak/memberships'
    | '/(redirects)/bak/migration'
    | '/(redirects)/bak/new-subscription'
    | '/(redirects)/bak/organizations'
    | '/(redirects)/bak/search'
    | '/(redirects)/bak/tracking-doc'
    | '/(redirects)/payment-methods/new'
    | '/bo/admin/consumer-status'
    | '/bo/admin/debug'
    | '/bo/admin/ima'
    | '/bo/admin/system-prompts'
    | '/bo/admin/time'
    | '/bo/documentation/activity-configuration'
    | '/bo/documentation/activity-specific-questions'
    | '/bo/documentation/emails'
    | '/bo/documentation/endorsement-rules'
    | '/bo/documentation/exclusions'
    | '/bo/documentation/general-terms'
    | '/bo/documentation/injectable-params'
    | '/bo/documentation/input-dimensions'
    | '/bo/documentation/invoicing-balance'
    | '/bo/documentation/products'
    | '/bo/documentation/reimbursement-rules'
    | '/bo/documentation/roles'
    | '/bo/documentation/search'
    | '/bo/documentation/subscription-funnel-texts'
    | '/bo/invoicing/$invoiceId'
    | '/bo/invoicing/negative-invoices'
    | '/bo/subscriptions/new'
    | '/bo/tools/guarantees-tables'
    | '/bo/users/$userId'
    | '/form/$subscriptionId/$formId'
    | '/resources/documentation/injectable-params'
    | '/s/attestations/$token'
    | '/s/c/$token'
    | '/s/e-v2/$token'
    | '/s/e/$token'
    | '/s/hf/$token'
    | '/s/q/$token'
    | '/s/r/$token'
    | '/subscribe/$subscriptionId/$stepId'
    | '/subscribe/restaurants-v2/identify'
    | '/bo/announcements/new'
    | '/bo/organizations/create'
    | '/bo/subscriptions/generate'
    | '/bo/subscriptions/generate-failed'
    | '/bo/admin/'
    | '/bo/announcements/'
    | '/bo/contracts/'
    | '/bo/dashboard/'
    | '/bo/documentation/'
    | '/bo/excluded-subscriptions/'
    | '/bo/organizations/'
    | '/bo/passkeys/'
    | '/bo/products/'
    | '/bo/renewal/'
    | '/bo/review-tasks/'
    | '/bo/settings/'
    | '/bo/subscriptions/'
    | '/bo/tools/'
    | '/bo/users/'
    | '/(redirects)/bak/admin/ima'
    | '/(redirects)/bak/documentation/activity-specific-questions'
    | '/(redirects)/bak/documentation/exclusions'
    | '/(redirects)/bak/documentation/general-terms'
    | '/(redirects)/bak/documentation/roles'
    | '/(redirects)/bak/documentation/subscription-funnel-texts'
    | '/(redirects)/bak/invoicing/negative-invoices-list'
    | '/(redirects)/bak/users/$userId'
    | '/(redirects)/partner/$organization/home'
    | '/(redirects)/partner/$organization/new-subscription'
    | '/(redirects)/partner/$organization/search'
    | '/bo/contracts/$subscriptionId/attestations'
    | '/bo/contracts/$subscriptionId/billing-exemption'
    | '/bo/contracts/$subscriptionId/cpms'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
    | '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
    | '/bo/contracts/$subscriptionId/status'
    | '/bo/organizations/$organizationTechnicalName/history'
    | '/bo/subscriptions/$subscriptionId/detailed-sheet'
    | '/bo/subscriptions/$subscriptionId/history'
    | '/bo/subscriptions/$subscriptionId/payment'
    | '/bo/troubleshooting/sessions/$sessionId'
    | '/bo/users/$userId_/payment-methods'
    | '/bo/users/$userId_/unpaid-invoices'
    | '/s/a/$token/$product'
    | '/(customer)/_shell/health-insurance/beneficiaries'
    | '/(customer)/_shell/health-insurance/cpms'
    | '/(customer)/_shell/health-insurance/santeclair'
    | '/(customer)/_shell/unpaid-invoices/payment'
    | '/bo/ai/experiments/$agentId'
    | '/bo/ai/review/$runId'
    | '/bo/ai/runs/$workflowId'
    | '/bo/ai/workflows/$workflowId'
    | '/bo/challenges/$challengeId/subscribe'
    | '/bo/documentation/exclusions/configuration'
    | '/bo/organizations/$organizationTechnicalName/advanced-settings'
    | '/bo/organizations/$organizationTechnicalName/dashboard'
    | '/bo/organizations/$organizationTechnicalName/members'
    | '/bo/organizations/$organizationTechnicalName/slips'
    | '/(customer)/_shell/contracts/'
    | '/(customer)/_shell/health-insurance/'
    | '/(customer)/_shell/legal-assistance/'
    | '/(customer)/_shell/payment-methods/'
    | '/(customer)/_shell/product-guarantees/'
    | '/(customer)/_shell/referrals/'
    | '/(customer)/_shell/report-claim/'
    | '/(customer)/_shell/unpaid-invoices/'
    | '/(redirects)/bak/admin/'
    | '/(redirects)/bak/documentation/'
    | '/(redirects)/bak/pending-subscriptions/'
    | '/(redirects)/bak/users/'
    | '/(redirects)/bo/earnings/'
    | '/(redirects)/bo/memberships/'
    | '/(redirects)/bo/organization-dashboard/'
    | '/(redirects)/bo/organization-history/'
    | '/(redirects)/bo/slips/'
    | '/bo/admin/data-warehouse/'
    | '/bo/admin/dispatchers/'
    | '/bo/admin/jobs/'
    | '/bo/admin/reducers/'
    | '/bo/ai-underwriting/rules/'
    | '/bo/ai/evaluations/'
    | '/bo/ai/runs/'
    | '/bo/ai/workflows/'
    | '/bo/announcements/$announcementId/'
    | '/bo/claims/$claimId/'
    | '/bo/contracts/$subscriptionId/'
    | '/bo/documentation/exclusions/'
    | '/bo/organizations/$organizationTechnicalName/'
    | '/bo/products/$productGroupSlug/'
    | '/bo/review-tasks/$taskId/'
    | '/bo/settings/members/'
    | '/bo/settings/payment-details/'
    | '/bo/settings/slips/'
    | '/bo/subscriptions/$subscriptionId/'
    | '/s/a/$token/'
    | '/subscribe/$subscriptionId/$stepId/'
    | '/(customer)/_shell/product-guarantees/$subscriptionId/$productName'
    | '/(redirects)/bak/contracts/$subscriptionId/invoicing'
    | '/(redirects)/bak/contracts/$subscriptionId/new-invoice'
    | '/(redirects)/bak/contracts/$subscriptionId/status'
    | '/(redirects)/bak/pending-subscriptions/$subscriptionId/history'
    | '/(redirects)/bak/pending-subscriptions/$subscriptionId/payment'
    | '/(redirects)/bak/troubleshooting/session/$sessionId'
    | '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
    | '/(redirects)/partner/$organization/claims/$claimId'
    | '/(redirects)/partner/$organization/contracts/$subscriptionId'
    | '/(redirects)/partner/$organization/users/$userId'
    | '/bo/contracts/$subscriptionId/invoices/debug'
    | '/bo/contracts/$subscriptionId/invoices/new'
    | '/bo/contracts/$subscriptionId/payment-methods/new'
    | '/bo/users/$userId_/unpaid-invoices/payment'
    | '/subscribe/$subscriptionId/$stepId/$detailType/$detailId'
    | '/(customer)/_shell/contracts/$subscriptionId/'
    | '/(customer)/_shell/insurance-certificate-generator-real-estate-agents/$subscriptionId/'
    | '/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/'
    | '/(redirects)/bak/claims/$claimId/'
    | '/(redirects)/bak/contracts/$subscriptionId/'
    | '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/'
    | '/(redirects)/partner/$organization/pending-subscriptions/'
    | '/(redirects)/partner/$organization/users/'
    | '/bo/admin/jobs/$jobId/'
    | '/bo/admin/reducers/$reducerName/'
    | '/bo/ai/evaluations/$workflowId/'
    | '/bo/users/$userId_/unpaid-invoices/'
    | '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
    | '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
    | '/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId'
    | '/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment'
    | '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
    | '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
    | '/(customer)/_shell/product-guarantees/$subscriptionId/$productName/$guaranteeType'
    | '/bo/ai/evaluations/$workflowId/datasets/$datasetId'
    | '/(customer)/_shell/contracts/$subscriptionId/attestations/'
    | '/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/'
    | '/bo/admin/jobs/$jobId/$concurrencyKey/'
    | '/bo/contracts/$subscriptionId/endorsements/$endorsementId/'
    | '/bo/contracts/$subscriptionId/renewals/$endorsementId/'
    | '/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
    | '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
    | '/(customer)/_shell/contracts/$subscriptionId/payment-methods/new/'
    | '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/'
    | '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/'
    | '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImpersonateRouteRoute: typeof ImpersonateRouteRoute
  LoginRouteRoute: typeof LoginRouteRoute
  ReceiveQuoteRouteRoute: typeof ReceiveQuoteRouteRoute
  SearchRouteRoute: typeof SearchRouteRoute
  SubscribeNoPossibleStepRouteRoute: typeof SubscribeNoPossibleStepRouteRoute
  UnsubscribeRouteRoute: typeof UnsubscribeRouteRoute
  BoRoute: typeof BoRouteWithChildren
  ChatRoute: typeof ChatRoute
  ResourcesRoute: typeof ResourcesRouteWithChildren
  redirectsContractGuaranteesRouteRoute: typeof redirectsContractGuaranteesRouteRoute
  redirectsPaymentMethodUpdateRouteRoute: typeof redirectsPaymentMethodUpdateRouteRoute
  PaymentAuthenticationRouteRoute: typeof PaymentAuthenticationRouteRoute
  RCodeRouteRoute: typeof RCodeRouteRoute
  SubscribeExclusionSubscriptionIdRouteRoute: typeof SubscribeExclusionSubscriptionIdRouteRoute
  SubscribeLandingRouteRoute: typeof SubscribeLandingRouteRoute
  customerShellRoute: typeof customerShellRouteWithChildren
  redirectsBakActivitiesRouteRoute: typeof redirectsBakActivitiesRouteRoute
  redirectsBakEphemeralJobsRouteRoute: typeof redirectsBakEphemeralJobsRouteRoute
  redirectsBakHomeRouteRoute: typeof redirectsBakHomeRouteRoute
  redirectsBakMembershipsRouteRoute: typeof redirectsBakMembershipsRouteRoute
  redirectsBakMigrationRouteRoute: typeof redirectsBakMigrationRouteRoute
  redirectsBakNewSubscriptionRouteRoute: typeof redirectsBakNewSubscriptionRouteRoute
  redirectsBakOrganizationsRouteRoute: typeof redirectsBakOrganizationsRouteRoute
  redirectsBakSearchRouteRoute: typeof redirectsBakSearchRouteRoute
  redirectsBakTrackingDocRouteRoute: typeof redirectsBakTrackingDocRouteRoute
  redirectsPaymentMethodsNewRouteRoute: typeof redirectsPaymentMethodsNewRouteRoute
  FormSubscriptionIdFormIdRouteRoute: typeof FormSubscriptionIdFormIdRouteRoute
  SAttestationsTokenRouteRoute: typeof SAttestationsTokenRouteRoute
  SCTokenRouteRoute: typeof SCTokenRouteRoute
  SEV2TokenRouteRoute: typeof SEV2TokenRouteRoute
  SETokenRouteRoute: typeof SETokenRouteRoute
  SHfTokenRouteRoute: typeof SHfTokenRouteRoute
  SQTokenRouteRoute: typeof SQTokenRouteRoute
  SRTokenRouteRoute: typeof SRTokenRouteRoute
  SubscribeSubscriptionIdStepIdRouteRoute: typeof SubscribeSubscriptionIdStepIdRouteRouteWithChildren
  SubscribeRestaurantsV2IdentifyRouteRoute: typeof SubscribeRestaurantsV2IdentifyRouteRoute
  redirectsBakAdminImaRouteRoute: typeof redirectsBakAdminImaRouteRoute
  redirectsBakDocumentationActivitySpecificQuestionsRouteRoute: typeof redirectsBakDocumentationActivitySpecificQuestionsRouteRoute
  redirectsBakDocumentationExclusionsRouteRoute: typeof redirectsBakDocumentationExclusionsRouteRoute
  redirectsBakDocumentationGeneralTermsRouteRoute: typeof redirectsBakDocumentationGeneralTermsRouteRoute
  redirectsBakDocumentationRolesRouteRoute: typeof redirectsBakDocumentationRolesRouteRoute
  redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute: typeof redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute
  redirectsBakInvoicingNegativeInvoicesListRouteRoute: typeof redirectsBakInvoicingNegativeInvoicesListRouteRoute
  redirectsBakUsersUserIdRouteRoute: typeof redirectsBakUsersUserIdRouteRoute
  redirectsPartnerOrganizationHomeRouteRoute: typeof redirectsPartnerOrganizationHomeRouteRoute
  redirectsPartnerOrganizationNewSubscriptionRouteRoute: typeof redirectsPartnerOrganizationNewSubscriptionRouteRoute
  redirectsPartnerOrganizationSearchRouteRoute: typeof redirectsPartnerOrganizationSearchRouteRoute
  SATokenProductRouteRoute: typeof SATokenProductRouteRoute
  redirectsBakAdminIndexRoute: typeof redirectsBakAdminIndexRoute
  redirectsBakDocumentationIndexRoute: typeof redirectsBakDocumentationIndexRoute
  redirectsBakPendingSubscriptionsIndexRoute: typeof redirectsBakPendingSubscriptionsIndexRoute
  redirectsBakUsersIndexRoute: typeof redirectsBakUsersIndexRoute
  redirectsBoEarningsIndexRoute: typeof redirectsBoEarningsIndexRoute
  redirectsBoMembershipsIndexRoute: typeof redirectsBoMembershipsIndexRoute
  redirectsBoOrganizationDashboardIndexRoute: typeof redirectsBoOrganizationDashboardIndexRoute
  redirectsBoOrganizationHistoryIndexRoute: typeof redirectsBoOrganizationHistoryIndexRoute
  redirectsBoSlipsIndexRoute: typeof redirectsBoSlipsIndexRoute
  SATokenIndexRoute: typeof SATokenIndexRoute
  redirectsBakContractsSubscriptionIdInvoicingRouteRoute: typeof redirectsBakContractsSubscriptionIdInvoicingRouteRoute
  redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute: typeof redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute
  redirectsBakContractsSubscriptionIdStatusRouteRoute: typeof redirectsBakContractsSubscriptionIdStatusRouteRoute
  redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute: typeof redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute
  redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute: typeof redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  redirectsBakTroubleshootingSessionSessionIdRouteRoute: typeof redirectsBakTroubleshootingSessionSessionIdRouteRoute
  redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute: typeof redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  redirectsPartnerOrganizationClaimsClaimIdRouteRoute: typeof redirectsPartnerOrganizationClaimsClaimIdRouteRoute
  redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute: typeof redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute
  redirectsPartnerOrganizationUsersUserIdRouteRoute: typeof redirectsPartnerOrganizationUsersUserIdRouteRoute
  redirectsBakClaimsClaimIdIndexRoute: typeof redirectsBakClaimsClaimIdIndexRoute
  redirectsBakContractsSubscriptionIdIndexRoute: typeof redirectsBakContractsSubscriptionIdIndexRoute
  redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute: typeof redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute
  redirectsPartnerOrganizationPendingSubscriptionsIndexRoute: typeof redirectsPartnerOrganizationPendingSubscriptionsIndexRoute
  redirectsPartnerOrganizationUsersIndexRoute: typeof redirectsPartnerOrganizationUsersIndexRoute
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteWithChildren
  customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute
  redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute: typeof redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute
  redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute: typeof redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute
  redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute: typeof redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute
  redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute: typeof redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute: typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute
  customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute: typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo': {
      id: '/bo'
      path: '/bo'
      fullPath: '/bo'
      preLoaderRoute: typeof BoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receive-quote': {
      id: '/receive-quote'
      path: '/receive-quote'
      fullPath: '/receive-quote'
      preLoaderRoute: typeof ReceiveQuoteRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe-no-possible-step': {
      id: '/subscribe-no-possible-step'
      path: '/subscribe-no-possible-step'
      fullPath: '/subscribe-no-possible-step'
      preLoaderRoute: typeof SubscribeNoPossibleStepRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(customer)/_shell': {
      id: '/(customer)/_shell'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof customerShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/contract-guarantees': {
      id: '/(redirects)/contract-guarantees'
      path: '/contract-guarantees'
      fullPath: '/contract-guarantees'
      preLoaderRoute: typeof redirectsContractGuaranteesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/payment-method-update': {
      id: '/(redirects)/payment-method-update'
      path: '/payment-method-update'
      fullPath: '/payment-method-update'
      preLoaderRoute: typeof redirectsPaymentMethodUpdateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo/': {
      id: '/bo/'
      path: '/'
      fullPath: '/bo/'
      preLoaderRoute: typeof BoIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/activities': {
      id: '/bo/activities'
      path: '/activities'
      fullPath: '/bo/activities'
      preLoaderRoute: typeof BoActivitiesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/activities-old': {
      id: '/bo/activities-old'
      path: '/activities-old'
      fullPath: '/bo/activities-old'
      preLoaderRoute: typeof BoActivitiesOldRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ephemeral-jobs': {
      id: '/bo/ephemeral-jobs'
      path: '/ephemeral-jobs'
      fullPath: '/bo/ephemeral-jobs'
      preLoaderRoute: typeof BoEphemeralJobsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/generate-slips': {
      id: '/bo/generate-slips'
      path: '/generate-slips'
      fullPath: '/bo/generate-slips'
      preLoaderRoute: typeof BoGenerateSlipsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/guarantees-tables': {
      id: '/bo/guarantees-tables'
      path: '/guarantees-tables'
      fullPath: '/bo/guarantees-tables'
      preLoaderRoute: typeof BoGuaranteesTablesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/lourmel-sftp': {
      id: '/bo/lourmel-sftp'
      path: '/lourmel-sftp'
      fullPath: '/bo/lourmel-sftp'
      preLoaderRoute: typeof BoLourmelSftpRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/migration': {
      id: '/bo/migration'
      path: '/migration'
      fullPath: '/bo/migration'
      preLoaderRoute: typeof BoMigrationRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/referrals': {
      id: '/bo/referrals'
      path: '/referrals'
      fullPath: '/bo/referrals'
      preLoaderRoute: typeof BoReferralsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/scripts': {
      id: '/bo/scripts'
      path: '/scripts'
      fullPath: '/bo/scripts'
      preLoaderRoute: typeof BoScriptsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/search': {
      id: '/bo/search'
      path: '/search'
      fullPath: '/bo/search'
      preLoaderRoute: typeof BoSearchRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/tools': {
      id: '/bo/tools'
      path: '/tools'
      fullPath: '/bo/tools'
      preLoaderRoute: typeof BoToolsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/tracking-doc': {
      id: '/bo/tracking-doc'
      path: '/tracking-doc'
      fullPath: '/bo/tracking-doc'
      preLoaderRoute: typeof BoTrackingDocRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/payment/authentication': {
      id: '/payment/authentication'
      path: '/payment/authentication'
      fullPath: '/payment/authentication'
      preLoaderRoute: typeof PaymentAuthenticationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$code': {
      id: '/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof RCodeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/': {
      id: '/resources/'
      path: '/'
      fullPath: '/resources/'
      preLoaderRoute: typeof ResourcesIndexRouteImport
      parentRoute: typeof ResourcesRoute
    }
    '/subscribe-exclusion/$subscriptionId': {
      id: '/subscribe-exclusion/$subscriptionId'
      path: '/subscribe-exclusion/$subscriptionId'
      fullPath: '/subscribe-exclusion/$subscriptionId'
      preLoaderRoute: typeof SubscribeExclusionSubscriptionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/landing': {
      id: '/subscribe/landing'
      path: '/subscribe/landing'
      fullPath: '/subscribe/landing'
      preLoaderRoute: typeof SubscribeLandingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(customer)/_shell/account': {
      id: '/(customer)/_shell/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof customerShellAccountRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/health-insurance': {
      id: '/(customer)/_shell/health-insurance'
      path: '/health-insurance'
      fullPath: '/health-insurance'
      preLoaderRoute: typeof customerShellHealthInsuranceRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/home': {
      id: '/(customer)/_shell/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof customerShellHomeRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/invoices': {
      id: '/(customer)/_shell/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof customerShellInvoicesRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/product-guarantees': {
      id: '/(customer)/_shell/product-guarantees'
      path: '/product-guarantees'
      fullPath: '/product-guarantees'
      preLoaderRoute: typeof customerShellProductGuaranteesRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/unpaid-invoices': {
      id: '/(customer)/_shell/unpaid-invoices'
      path: '/unpaid-invoices'
      fullPath: '/unpaid-invoices'
      preLoaderRoute: typeof customerShellUnpaidInvoicesRouteRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(redirects)/bak/activities': {
      id: '/(redirects)/bak/activities'
      path: '/bak/activities'
      fullPath: '/bak/activities'
      preLoaderRoute: typeof redirectsBakActivitiesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/ephemeral-jobs': {
      id: '/(redirects)/bak/ephemeral-jobs'
      path: '/bak/ephemeral-jobs'
      fullPath: '/bak/ephemeral-jobs'
      preLoaderRoute: typeof redirectsBakEphemeralJobsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/home': {
      id: '/(redirects)/bak/home'
      path: '/bak/home'
      fullPath: '/bak/home'
      preLoaderRoute: typeof redirectsBakHomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/memberships': {
      id: '/(redirects)/bak/memberships'
      path: '/bak/memberships'
      fullPath: '/bak/memberships'
      preLoaderRoute: typeof redirectsBakMembershipsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/migration': {
      id: '/(redirects)/bak/migration'
      path: '/bak/migration'
      fullPath: '/bak/migration'
      preLoaderRoute: typeof redirectsBakMigrationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/new-subscription': {
      id: '/(redirects)/bak/new-subscription'
      path: '/bak/new-subscription'
      fullPath: '/bak/new-subscription'
      preLoaderRoute: typeof redirectsBakNewSubscriptionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/organizations': {
      id: '/(redirects)/bak/organizations'
      path: '/bak/organizations'
      fullPath: '/bak/organizations'
      preLoaderRoute: typeof redirectsBakOrganizationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/search': {
      id: '/(redirects)/bak/search'
      path: '/bak/search'
      fullPath: '/bak/search'
      preLoaderRoute: typeof redirectsBakSearchRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/tracking-doc': {
      id: '/(redirects)/bak/tracking-doc'
      path: '/bak/tracking-doc'
      fullPath: '/bak/tracking-doc'
      preLoaderRoute: typeof redirectsBakTrackingDocRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/payment-methods/new': {
      id: '/(redirects)/payment-methods/new'
      path: '/payment-methods/new'
      fullPath: '/payment-methods/new'
      preLoaderRoute: typeof redirectsPaymentMethodsNewRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo/admin/': {
      id: '/bo/admin/'
      path: '/admin'
      fullPath: '/bo/admin/'
      preLoaderRoute: typeof BoAdminIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/consumer-status': {
      id: '/bo/admin/consumer-status'
      path: '/admin/consumer-status'
      fullPath: '/bo/admin/consumer-status'
      preLoaderRoute: typeof BoAdminConsumerStatusRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/debug': {
      id: '/bo/admin/debug'
      path: '/admin/debug'
      fullPath: '/bo/admin/debug'
      preLoaderRoute: typeof BoAdminDebugRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/ima': {
      id: '/bo/admin/ima'
      path: '/admin/ima'
      fullPath: '/bo/admin/ima'
      preLoaderRoute: typeof BoAdminImaRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/system-prompts': {
      id: '/bo/admin/system-prompts'
      path: '/admin/system-prompts'
      fullPath: '/bo/admin/system-prompts'
      preLoaderRoute: typeof BoAdminSystemPromptsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/time': {
      id: '/bo/admin/time'
      path: '/admin/time'
      fullPath: '/bo/admin/time'
      preLoaderRoute: typeof BoAdminTimeRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/announcements/': {
      id: '/bo/announcements/'
      path: '/announcements'
      fullPath: '/bo/announcements/'
      preLoaderRoute: typeof BoAnnouncementsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/announcements/new': {
      id: '/bo/announcements/new'
      path: '/announcements/new'
      fullPath: '/bo/announcements/new'
      preLoaderRoute: typeof BoAnnouncementsNewRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/': {
      id: '/bo/contracts/'
      path: '/contracts'
      fullPath: '/bo/contracts/'
      preLoaderRoute: typeof BoContractsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/dashboard/': {
      id: '/bo/dashboard/'
      path: '/dashboard'
      fullPath: '/bo/dashboard/'
      preLoaderRoute: typeof BoDashboardIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/': {
      id: '/bo/documentation/'
      path: '/documentation'
      fullPath: '/bo/documentation/'
      preLoaderRoute: typeof BoDocumentationIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/activity-configuration': {
      id: '/bo/documentation/activity-configuration'
      path: '/documentation/activity-configuration'
      fullPath: '/bo/documentation/activity-configuration'
      preLoaderRoute: typeof BoDocumentationActivityConfigurationRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/activity-specific-questions': {
      id: '/bo/documentation/activity-specific-questions'
      path: '/documentation/activity-specific-questions'
      fullPath: '/bo/documentation/activity-specific-questions'
      preLoaderRoute: typeof BoDocumentationActivitySpecificQuestionsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/emails': {
      id: '/bo/documentation/emails'
      path: '/documentation/emails'
      fullPath: '/bo/documentation/emails'
      preLoaderRoute: typeof BoDocumentationEmailsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/endorsement-rules': {
      id: '/bo/documentation/endorsement-rules'
      path: '/documentation/endorsement-rules'
      fullPath: '/bo/documentation/endorsement-rules'
      preLoaderRoute: typeof BoDocumentationEndorsementRulesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/exclusions': {
      id: '/bo/documentation/exclusions'
      path: '/documentation/exclusions'
      fullPath: '/bo/documentation/exclusions'
      preLoaderRoute: typeof BoDocumentationExclusionsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/general-terms': {
      id: '/bo/documentation/general-terms'
      path: '/documentation/general-terms'
      fullPath: '/bo/documentation/general-terms'
      preLoaderRoute: typeof BoDocumentationGeneralTermsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/injectable-params': {
      id: '/bo/documentation/injectable-params'
      path: '/documentation/injectable-params'
      fullPath: '/bo/documentation/injectable-params'
      preLoaderRoute: typeof BoDocumentationInjectableParamsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/input-dimensions': {
      id: '/bo/documentation/input-dimensions'
      path: '/documentation/input-dimensions'
      fullPath: '/bo/documentation/input-dimensions'
      preLoaderRoute: typeof BoDocumentationInputDimensionsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/invoicing-balance': {
      id: '/bo/documentation/invoicing-balance'
      path: '/documentation/invoicing-balance'
      fullPath: '/bo/documentation/invoicing-balance'
      preLoaderRoute: typeof BoDocumentationInvoicingBalanceRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/products': {
      id: '/bo/documentation/products'
      path: '/documentation/products'
      fullPath: '/bo/documentation/products'
      preLoaderRoute: typeof BoDocumentationProductsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/reimbursement-rules': {
      id: '/bo/documentation/reimbursement-rules'
      path: '/documentation/reimbursement-rules'
      fullPath: '/bo/documentation/reimbursement-rules'
      preLoaderRoute: typeof BoDocumentationReimbursementRulesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/roles': {
      id: '/bo/documentation/roles'
      path: '/documentation/roles'
      fullPath: '/bo/documentation/roles'
      preLoaderRoute: typeof BoDocumentationRolesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/search': {
      id: '/bo/documentation/search'
      path: '/documentation/search'
      fullPath: '/bo/documentation/search'
      preLoaderRoute: typeof BoDocumentationSearchRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/subscription-funnel-texts': {
      id: '/bo/documentation/subscription-funnel-texts'
      path: '/documentation/subscription-funnel-texts'
      fullPath: '/bo/documentation/subscription-funnel-texts'
      preLoaderRoute: typeof BoDocumentationSubscriptionFunnelTextsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/excluded-subscriptions/': {
      id: '/bo/excluded-subscriptions/'
      path: '/excluded-subscriptions'
      fullPath: '/bo/excluded-subscriptions/'
      preLoaderRoute: typeof BoExcludedSubscriptionsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/invoicing/$invoiceId': {
      id: '/bo/invoicing/$invoiceId'
      path: '/invoicing/$invoiceId'
      fullPath: '/bo/invoicing/$invoiceId'
      preLoaderRoute: typeof BoInvoicingInvoiceIdRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/invoicing/negative-invoices': {
      id: '/bo/invoicing/negative-invoices'
      path: '/invoicing/negative-invoices'
      fullPath: '/bo/invoicing/negative-invoices'
      preLoaderRoute: typeof BoInvoicingNegativeInvoicesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/': {
      id: '/bo/organizations/'
      path: '/organizations'
      fullPath: '/bo/organizations/'
      preLoaderRoute: typeof BoOrganizationsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/create': {
      id: '/bo/organizations/create'
      path: '/organizations/create'
      fullPath: '/bo/organizations/create'
      preLoaderRoute: typeof BoOrganizationsCreateRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/passkeys/': {
      id: '/bo/passkeys/'
      path: '/passkeys'
      fullPath: '/bo/passkeys/'
      preLoaderRoute: typeof BoPasskeysIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/products/': {
      id: '/bo/products/'
      path: '/products'
      fullPath: '/bo/products/'
      preLoaderRoute: typeof BoProductsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/renewal/': {
      id: '/bo/renewal/'
      path: '/renewal'
      fullPath: '/bo/renewal/'
      preLoaderRoute: typeof BoRenewalIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/review-tasks/': {
      id: '/bo/review-tasks/'
      path: '/review-tasks'
      fullPath: '/bo/review-tasks/'
      preLoaderRoute: typeof BoReviewTasksIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/settings/': {
      id: '/bo/settings/'
      path: '/settings'
      fullPath: '/bo/settings/'
      preLoaderRoute: typeof BoSettingsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/': {
      id: '/bo/subscriptions/'
      path: '/subscriptions'
      fullPath: '/bo/subscriptions/'
      preLoaderRoute: typeof BoSubscriptionsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/generate': {
      id: '/bo/subscriptions/generate'
      path: '/subscriptions/generate'
      fullPath: '/bo/subscriptions/generate'
      preLoaderRoute: typeof BoSubscriptionsGenerateRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/generate-failed': {
      id: '/bo/subscriptions/generate-failed'
      path: '/subscriptions/generate-failed'
      fullPath: '/bo/subscriptions/generate-failed'
      preLoaderRoute: typeof BoSubscriptionsGenerateFailedRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/new': {
      id: '/bo/subscriptions/new'
      path: '/subscriptions/new'
      fullPath: '/bo/subscriptions/new'
      preLoaderRoute: typeof BoSubscriptionsNewRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/tools/': {
      id: '/bo/tools/'
      path: '/'
      fullPath: '/bo/tools/'
      preLoaderRoute: typeof BoToolsIndexRouteImport
      parentRoute: typeof BoToolsRouteRoute
    }
    '/bo/tools/guarantees-tables': {
      id: '/bo/tools/guarantees-tables'
      path: '/guarantees-tables'
      fullPath: '/bo/tools/guarantees-tables'
      preLoaderRoute: typeof BoToolsGuaranteesTablesRouteRouteImport
      parentRoute: typeof BoToolsRouteRoute
    }
    '/bo/users/': {
      id: '/bo/users/'
      path: '/users'
      fullPath: '/bo/users/'
      preLoaderRoute: typeof BoUsersIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/users/$userId': {
      id: '/bo/users/$userId'
      path: '/users/$userId'
      fullPath: '/bo/users/$userId'
      preLoaderRoute: typeof BoUsersUserIdRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/form/$subscriptionId/$formId': {
      id: '/form/$subscriptionId/$formId'
      path: '/form/$subscriptionId/$formId'
      fullPath: '/form/$subscriptionId/$formId'
      preLoaderRoute: typeof FormSubscriptionIdFormIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/documentation/injectable-params': {
      id: '/resources/documentation/injectable-params'
      path: '/documentation/injectable-params'
      fullPath: '/resources/documentation/injectable-params'
      preLoaderRoute: typeof ResourcesDocumentationInjectableParamsRouteRouteImport
      parentRoute: typeof ResourcesRoute
    }
    '/s/attestations/$token': {
      id: '/s/attestations/$token'
      path: '/s/attestations/$token'
      fullPath: '/s/attestations/$token'
      preLoaderRoute: typeof SAttestationsTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/c/$token': {
      id: '/s/c/$token'
      path: '/s/c/$token'
      fullPath: '/s/c/$token'
      preLoaderRoute: typeof SCTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/e-v2/$token': {
      id: '/s/e-v2/$token'
      path: '/s/e-v2/$token'
      fullPath: '/s/e-v2/$token'
      preLoaderRoute: typeof SEV2TokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/e/$token': {
      id: '/s/e/$token'
      path: '/s/e/$token'
      fullPath: '/s/e/$token'
      preLoaderRoute: typeof SETokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/hf/$token': {
      id: '/s/hf/$token'
      path: '/s/hf/$token'
      fullPath: '/s/hf/$token'
      preLoaderRoute: typeof SHfTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/q/$token': {
      id: '/s/q/$token'
      path: '/s/q/$token'
      fullPath: '/s/q/$token'
      preLoaderRoute: typeof SQTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/r/$token': {
      id: '/s/r/$token'
      path: '/s/r/$token'
      fullPath: '/s/r/$token'
      preLoaderRoute: typeof SRTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/$subscriptionId/$stepId': {
      id: '/subscribe/$subscriptionId/$stepId'
      path: '/subscribe/$subscriptionId/$stepId'
      fullPath: '/subscribe/$subscriptionId/$stepId'
      preLoaderRoute: typeof SubscribeSubscriptionIdStepIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/restaurants-v2/identify': {
      id: '/subscribe/restaurants-v2/identify'
      path: '/subscribe/restaurants-v2/identify'
      fullPath: '/subscribe/restaurants-v2/identify'
      preLoaderRoute: typeof SubscribeRestaurantsV2IdentifyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(customer)/_shell/contracts/': {
      id: '/(customer)/_shell/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof customerShellContractsIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/health-insurance/': {
      id: '/(customer)/_shell/health-insurance/'
      path: '/'
      fullPath: '/health-insurance/'
      preLoaderRoute: typeof customerShellHealthInsuranceIndexRouteImport
      parentRoute: typeof customerShellHealthInsuranceRouteRoute
    }
    '/(customer)/_shell/health-insurance/beneficiaries': {
      id: '/(customer)/_shell/health-insurance/beneficiaries'
      path: '/beneficiaries'
      fullPath: '/health-insurance/beneficiaries'
      preLoaderRoute: typeof customerShellHealthInsuranceBeneficiariesRouteImport
      parentRoute: typeof customerShellHealthInsuranceRouteRoute
    }
    '/(customer)/_shell/health-insurance/cpms': {
      id: '/(customer)/_shell/health-insurance/cpms'
      path: '/cpms'
      fullPath: '/health-insurance/cpms'
      preLoaderRoute: typeof customerShellHealthInsuranceCpmsRouteImport
      parentRoute: typeof customerShellHealthInsuranceRouteRoute
    }
    '/(customer)/_shell/health-insurance/santeclair': {
      id: '/(customer)/_shell/health-insurance/santeclair'
      path: '/santeclair'
      fullPath: '/health-insurance/santeclair'
      preLoaderRoute: typeof customerShellHealthInsuranceSanteclairRouteImport
      parentRoute: typeof customerShellHealthInsuranceRouteRoute
    }
    '/(customer)/_shell/legal-assistance/': {
      id: '/(customer)/_shell/legal-assistance/'
      path: '/legal-assistance'
      fullPath: '/legal-assistance/'
      preLoaderRoute: typeof customerShellLegalAssistanceIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/payment-methods/': {
      id: '/(customer)/_shell/payment-methods/'
      path: '/payment-methods'
      fullPath: '/payment-methods/'
      preLoaderRoute: typeof customerShellPaymentMethodsIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/product-guarantees/': {
      id: '/(customer)/_shell/product-guarantees/'
      path: '/'
      fullPath: '/product-guarantees/'
      preLoaderRoute: typeof customerShellProductGuaranteesIndexRouteImport
      parentRoute: typeof customerShellProductGuaranteesRouteRoute
    }
    '/(customer)/_shell/referrals/': {
      id: '/(customer)/_shell/referrals/'
      path: '/referrals'
      fullPath: '/referrals/'
      preLoaderRoute: typeof customerShellReferralsIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/report-claim/': {
      id: '/(customer)/_shell/report-claim/'
      path: '/report-claim'
      fullPath: '/report-claim/'
      preLoaderRoute: typeof customerShellReportClaimIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/unpaid-invoices/': {
      id: '/(customer)/_shell/unpaid-invoices/'
      path: '/'
      fullPath: '/unpaid-invoices/'
      preLoaderRoute: typeof customerShellUnpaidInvoicesIndexRouteImport
      parentRoute: typeof customerShellUnpaidInvoicesRouteRoute
    }
    '/(customer)/_shell/unpaid-invoices/payment': {
      id: '/(customer)/_shell/unpaid-invoices/payment'
      path: '/payment'
      fullPath: '/unpaid-invoices/payment'
      preLoaderRoute: typeof customerShellUnpaidInvoicesPaymentRouteImport
      parentRoute: typeof customerShellUnpaidInvoicesRouteRoute
    }
    '/(redirects)/bak/admin/': {
      id: '/(redirects)/bak/admin/'
      path: '/bak/admin'
      fullPath: '/bak/admin/'
      preLoaderRoute: typeof redirectsBakAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/admin/ima': {
      id: '/(redirects)/bak/admin/ima'
      path: '/bak/admin/ima'
      fullPath: '/bak/admin/ima'
      preLoaderRoute: typeof redirectsBakAdminImaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/': {
      id: '/(redirects)/bak/documentation/'
      path: '/bak/documentation'
      fullPath: '/bak/documentation/'
      preLoaderRoute: typeof redirectsBakDocumentationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/activity-specific-questions': {
      id: '/(redirects)/bak/documentation/activity-specific-questions'
      path: '/bak/documentation/activity-specific-questions'
      fullPath: '/bak/documentation/activity-specific-questions'
      preLoaderRoute: typeof redirectsBakDocumentationActivitySpecificQuestionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/exclusions': {
      id: '/(redirects)/bak/documentation/exclusions'
      path: '/bak/documentation/exclusions'
      fullPath: '/bak/documentation/exclusions'
      preLoaderRoute: typeof redirectsBakDocumentationExclusionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/general-terms': {
      id: '/(redirects)/bak/documentation/general-terms'
      path: '/bak/documentation/general-terms'
      fullPath: '/bak/documentation/general-terms'
      preLoaderRoute: typeof redirectsBakDocumentationGeneralTermsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/roles': {
      id: '/(redirects)/bak/documentation/roles'
      path: '/bak/documentation/roles'
      fullPath: '/bak/documentation/roles'
      preLoaderRoute: typeof redirectsBakDocumentationRolesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/documentation/subscription-funnel-texts': {
      id: '/(redirects)/bak/documentation/subscription-funnel-texts'
      path: '/bak/documentation/subscription-funnel-texts'
      fullPath: '/bak/documentation/subscription-funnel-texts'
      preLoaderRoute: typeof redirectsBakDocumentationSubscriptionFunnelTextsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/invoicing/negative-invoices-list': {
      id: '/(redirects)/bak/invoicing/negative-invoices-list'
      path: '/bak/invoicing/negative-invoices-list'
      fullPath: '/bak/invoicing/negative-invoices-list'
      preLoaderRoute: typeof redirectsBakInvoicingNegativeInvoicesListRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/pending-subscriptions/': {
      id: '/(redirects)/bak/pending-subscriptions/'
      path: '/bak/pending-subscriptions'
      fullPath: '/bak/pending-subscriptions/'
      preLoaderRoute: typeof redirectsBakPendingSubscriptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/users/': {
      id: '/(redirects)/bak/users/'
      path: '/bak/users'
      fullPath: '/bak/users/'
      preLoaderRoute: typeof redirectsBakUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/users/$userId': {
      id: '/(redirects)/bak/users/$userId'
      path: '/bak/users/$userId'
      fullPath: '/bak/users/$userId'
      preLoaderRoute: typeof redirectsBakUsersUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bo/earnings/': {
      id: '/(redirects)/bo/earnings/'
      path: '/bo/earnings'
      fullPath: '/bo/earnings/'
      preLoaderRoute: typeof redirectsBoEarningsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bo/memberships/': {
      id: '/(redirects)/bo/memberships/'
      path: '/bo/memberships'
      fullPath: '/bo/memberships/'
      preLoaderRoute: typeof redirectsBoMembershipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bo/organization-dashboard/': {
      id: '/(redirects)/bo/organization-dashboard/'
      path: '/bo/organization-dashboard'
      fullPath: '/bo/organization-dashboard/'
      preLoaderRoute: typeof redirectsBoOrganizationDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bo/organization-history/': {
      id: '/(redirects)/bo/organization-history/'
      path: '/bo/organization-history'
      fullPath: '/bo/organization-history/'
      preLoaderRoute: typeof redirectsBoOrganizationHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bo/slips/': {
      id: '/(redirects)/bo/slips/'
      path: '/bo/slips'
      fullPath: '/bo/slips/'
      preLoaderRoute: typeof redirectsBoSlipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/home': {
      id: '/(redirects)/partner/$organization/home'
      path: '/partner/$organization/home'
      fullPath: '/partner/$organization/home'
      preLoaderRoute: typeof redirectsPartnerOrganizationHomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/new-subscription': {
      id: '/(redirects)/partner/$organization/new-subscription'
      path: '/partner/$organization/new-subscription'
      fullPath: '/partner/$organization/new-subscription'
      preLoaderRoute: typeof redirectsPartnerOrganizationNewSubscriptionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/search': {
      id: '/(redirects)/partner/$organization/search'
      path: '/partner/$organization/search'
      fullPath: '/partner/$organization/search'
      preLoaderRoute: typeof redirectsPartnerOrganizationSearchRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo/admin/data-warehouse/': {
      id: '/bo/admin/data-warehouse/'
      path: '/admin/data-warehouse'
      fullPath: '/bo/admin/data-warehouse/'
      preLoaderRoute: typeof BoAdminDataWarehouseIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/dispatchers/': {
      id: '/bo/admin/dispatchers/'
      path: '/admin/dispatchers'
      fullPath: '/bo/admin/dispatchers/'
      preLoaderRoute: typeof BoAdminDispatchersIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/jobs/': {
      id: '/bo/admin/jobs/'
      path: '/admin/jobs'
      fullPath: '/bo/admin/jobs/'
      preLoaderRoute: typeof BoAdminJobsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/reducers/': {
      id: '/bo/admin/reducers/'
      path: '/admin/reducers'
      fullPath: '/bo/admin/reducers/'
      preLoaderRoute: typeof BoAdminReducersIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai-underwriting/rules/': {
      id: '/bo/ai-underwriting/rules/'
      path: '/ai-underwriting/rules'
      fullPath: '/bo/ai-underwriting/rules/'
      preLoaderRoute: typeof BoAiUnderwritingRulesIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/evaluations/': {
      id: '/bo/ai/evaluations/'
      path: '/ai/evaluations'
      fullPath: '/bo/ai/evaluations/'
      preLoaderRoute: typeof BoAiEvaluationsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/experiments/$agentId': {
      id: '/bo/ai/experiments/$agentId'
      path: '/ai/experiments/$agentId'
      fullPath: '/bo/ai/experiments/$agentId'
      preLoaderRoute: typeof BoAiExperimentsAgentIdRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/review/$runId': {
      id: '/bo/ai/review/$runId'
      path: '/ai/review/$runId'
      fullPath: '/bo/ai/review/$runId'
      preLoaderRoute: typeof BoAiReviewRunIdRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/runs/': {
      id: '/bo/ai/runs/'
      path: '/ai/runs'
      fullPath: '/bo/ai/runs/'
      preLoaderRoute: typeof BoAiRunsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/runs/$workflowId': {
      id: '/bo/ai/runs/$workflowId'
      path: '/ai/runs/$workflowId'
      fullPath: '/bo/ai/runs/$workflowId'
      preLoaderRoute: typeof BoAiRunsWorkflowIdRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/workflows/': {
      id: '/bo/ai/workflows/'
      path: '/ai/workflows'
      fullPath: '/bo/ai/workflows/'
      preLoaderRoute: typeof BoAiWorkflowsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/workflows/$workflowId': {
      id: '/bo/ai/workflows/$workflowId'
      path: '/ai/workflows/$workflowId'
      fullPath: '/bo/ai/workflows/$workflowId'
      preLoaderRoute: typeof BoAiWorkflowsWorkflowIdRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/announcements/$announcementId/': {
      id: '/bo/announcements/$announcementId/'
      path: '/announcements/$announcementId'
      fullPath: '/bo/announcements/$announcementId/'
      preLoaderRoute: typeof BoAnnouncementsAnnouncementIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/challenges/$challengeId/subscribe': {
      id: '/bo/challenges/$challengeId/subscribe'
      path: '/challenges/$challengeId/subscribe'
      fullPath: '/bo/challenges/$challengeId/subscribe'
      preLoaderRoute: typeof BoChallengesChallengeIdSubscribeRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/claims/$claimId/': {
      id: '/bo/claims/$claimId/'
      path: '/claims/$claimId'
      fullPath: '/bo/claims/$claimId/'
      preLoaderRoute: typeof BoClaimsClaimIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/': {
      id: '/bo/contracts/$subscriptionId/'
      path: '/contracts/$subscriptionId'
      fullPath: '/bo/contracts/$subscriptionId/'
      preLoaderRoute: typeof BoContractsSubscriptionIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/attestations': {
      id: '/bo/contracts/$subscriptionId/attestations'
      path: '/contracts/$subscriptionId/attestations'
      fullPath: '/bo/contracts/$subscriptionId/attestations'
      preLoaderRoute: typeof BoContractsSubscriptionIdAttestationsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/billing-exemption': {
      id: '/bo/contracts/$subscriptionId/billing-exemption'
      path: '/contracts/$subscriptionId/billing-exemption'
      fullPath: '/bo/contracts/$subscriptionId/billing-exemption'
      preLoaderRoute: typeof BoContractsSubscriptionIdBillingExemptionRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/cpms': {
      id: '/bo/contracts/$subscriptionId/cpms'
      path: '/contracts/$subscriptionId/cpms'
      fullPath: '/bo/contracts/$subscriptionId/cpms'
      preLoaderRoute: typeof BoContractsSubscriptionIdCpmsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents': {
      id: '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
      path: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
      fullPath: '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-agents'
      preLoaderRoute: typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents': {
      id: '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
      path: '/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
      fullPath: '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents'
      preLoaderRoute: typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/status': {
      id: '/bo/contracts/$subscriptionId/status'
      path: '/contracts/$subscriptionId/status'
      fullPath: '/bo/contracts/$subscriptionId/status'
      preLoaderRoute: typeof BoContractsSubscriptionIdStatusRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/documentation/exclusions/': {
      id: '/bo/documentation/exclusions/'
      path: '/'
      fullPath: '/bo/documentation/exclusions/'
      preLoaderRoute: typeof BoDocumentationExclusionsIndexRouteImport
      parentRoute: typeof BoDocumentationExclusionsRouteRoute
    }
    '/bo/documentation/exclusions/configuration': {
      id: '/bo/documentation/exclusions/configuration'
      path: '/configuration'
      fullPath: '/bo/documentation/exclusions/configuration'
      preLoaderRoute: typeof BoDocumentationExclusionsConfigurationRouteImport
      parentRoute: typeof BoDocumentationExclusionsRouteRoute
    }
    '/bo/organizations/$organizationTechnicalName/': {
      id: '/bo/organizations/$organizationTechnicalName/'
      path: '/organizations/$organizationTechnicalName'
      fullPath: '/bo/organizations/$organizationTechnicalName/'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/$organizationTechnicalName/advanced-settings': {
      id: '/bo/organizations/$organizationTechnicalName/advanced-settings'
      path: '/organizations/$organizationTechnicalName/advanced-settings'
      fullPath: '/bo/organizations/$organizationTechnicalName/advanced-settings'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/$organizationTechnicalName/dashboard': {
      id: '/bo/organizations/$organizationTechnicalName/dashboard'
      path: '/organizations/$organizationTechnicalName/dashboard'
      fullPath: '/bo/organizations/$organizationTechnicalName/dashboard'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameDashboardRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/$organizationTechnicalName/history': {
      id: '/bo/organizations/$organizationTechnicalName/history'
      path: '/organizations/$organizationTechnicalName/history'
      fullPath: '/bo/organizations/$organizationTechnicalName/history'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameHistoryRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/$organizationTechnicalName/members': {
      id: '/bo/organizations/$organizationTechnicalName/members'
      path: '/organizations/$organizationTechnicalName/members'
      fullPath: '/bo/organizations/$organizationTechnicalName/members'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameMembersRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/organizations/$organizationTechnicalName/slips': {
      id: '/bo/organizations/$organizationTechnicalName/slips'
      path: '/organizations/$organizationTechnicalName/slips'
      fullPath: '/bo/organizations/$organizationTechnicalName/slips'
      preLoaderRoute: typeof BoOrganizationsOrganizationTechnicalNameSlipsRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/products/$productGroupSlug/': {
      id: '/bo/products/$productGroupSlug/'
      path: '/products/$productGroupSlug'
      fullPath: '/bo/products/$productGroupSlug/'
      preLoaderRoute: typeof BoProductsProductGroupSlugIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/review-tasks/$taskId/': {
      id: '/bo/review-tasks/$taskId/'
      path: '/review-tasks/$taskId'
      fullPath: '/bo/review-tasks/$taskId/'
      preLoaderRoute: typeof BoReviewTasksTaskIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/settings/members/': {
      id: '/bo/settings/members/'
      path: '/settings/members'
      fullPath: '/bo/settings/members/'
      preLoaderRoute: typeof BoSettingsMembersIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/settings/payment-details/': {
      id: '/bo/settings/payment-details/'
      path: '/settings/payment-details'
      fullPath: '/bo/settings/payment-details/'
      preLoaderRoute: typeof BoSettingsPaymentDetailsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/settings/slips/': {
      id: '/bo/settings/slips/'
      path: '/settings/slips'
      fullPath: '/bo/settings/slips/'
      preLoaderRoute: typeof BoSettingsSlipsIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/$subscriptionId/': {
      id: '/bo/subscriptions/$subscriptionId/'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/bo/subscriptions/$subscriptionId/'
      preLoaderRoute: typeof BoSubscriptionsSubscriptionIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/$subscriptionId/detailed-sheet': {
      id: '/bo/subscriptions/$subscriptionId/detailed-sheet'
      path: '/subscriptions/$subscriptionId/detailed-sheet'
      fullPath: '/bo/subscriptions/$subscriptionId/detailed-sheet'
      preLoaderRoute: typeof BoSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/$subscriptionId/history': {
      id: '/bo/subscriptions/$subscriptionId/history'
      path: '/subscriptions/$subscriptionId/history'
      fullPath: '/bo/subscriptions/$subscriptionId/history'
      preLoaderRoute: typeof BoSubscriptionsSubscriptionIdHistoryRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/subscriptions/$subscriptionId/payment': {
      id: '/bo/subscriptions/$subscriptionId/payment'
      path: '/subscriptions/$subscriptionId/payment'
      fullPath: '/bo/subscriptions/$subscriptionId/payment'
      preLoaderRoute: typeof BoSubscriptionsSubscriptionIdPaymentRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/troubleshooting/sessions/$sessionId': {
      id: '/bo/troubleshooting/sessions/$sessionId'
      path: '/troubleshooting/sessions/$sessionId'
      fullPath: '/bo/troubleshooting/sessions/$sessionId'
      preLoaderRoute: typeof BoTroubleshootingSessionsSessionIdRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/users/$userId_/payment-methods': {
      id: '/bo/users/$userId_/payment-methods'
      path: '/users/$userId/payment-methods'
      fullPath: '/bo/users/$userId/payment-methods'
      preLoaderRoute: typeof BoUsersUserIdPaymentMethodsRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/users/$userId_/unpaid-invoices': {
      id: '/bo/users/$userId_/unpaid-invoices'
      path: '/users/$userId/unpaid-invoices'
      fullPath: '/bo/users/$userId/unpaid-invoices'
      preLoaderRoute: typeof BoUsersUserIdUnpaidInvoicesRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/s/a/$token/': {
      id: '/s/a/$token/'
      path: '/s/a/$token'
      fullPath: '/s/a/$token/'
      preLoaderRoute: typeof SATokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/a/$token/$product': {
      id: '/s/a/$token/$product'
      path: '/s/a/$token/$product'
      fullPath: '/s/a/$token/$product'
      preLoaderRoute: typeof SATokenProductRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe/$subscriptionId/$stepId/': {
      id: '/subscribe/$subscriptionId/$stepId/'
      path: '/'
      fullPath: '/subscribe/$subscriptionId/$stepId/'
      preLoaderRoute: typeof SubscribeSubscriptionIdStepIdIndexRouteImport
      parentRoute: typeof SubscribeSubscriptionIdStepIdRouteRoute
    }
    '/(customer)/_shell/contracts/$subscriptionId/': {
      id: '/(customer)/_shell/contracts/$subscriptionId/'
      path: '/contracts/$subscriptionId'
      fullPath: '/contracts/$subscriptionId/'
      preLoaderRoute: typeof customerShellContractsSubscriptionIdIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/insurance-certificate-generator-real-estate-agents/$subscriptionId/': {
      id: '/(customer)/_shell/insurance-certificate-generator-real-estate-agents/$subscriptionId/'
      path: '/insurance-certificate-generator-real-estate-agents/$subscriptionId'
      fullPath: '/insurance-certificate-generator-real-estate-agents/$subscriptionId/'
      preLoaderRoute: typeof customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/': {
      id: '/(customer)/_shell/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/'
      path: '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId'
      fullPath: '/insurance-certificate-generator-real-estate-sales-agents/$subscriptionId/'
      preLoaderRoute: typeof customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/product-guarantees/$subscriptionId/$productName': {
      id: '/(customer)/_shell/product-guarantees/$subscriptionId/$productName'
      path: '/$subscriptionId/$productName'
      fullPath: '/product-guarantees/$subscriptionId/$productName'
      preLoaderRoute: typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteImport
      parentRoute: typeof customerShellProductGuaranteesRouteRoute
    }
    '/(redirects)/bak/claims/$claimId/': {
      id: '/(redirects)/bak/claims/$claimId/'
      path: '/bak/claims/$claimId'
      fullPath: '/bak/claims/$claimId/'
      preLoaderRoute: typeof redirectsBakClaimsClaimIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/': {
      id: '/(redirects)/bak/contracts/$subscriptionId/'
      path: '/bak/contracts/$subscriptionId'
      fullPath: '/bak/contracts/$subscriptionId/'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/invoicing': {
      id: '/(redirects)/bak/contracts/$subscriptionId/invoicing'
      path: '/bak/contracts/$subscriptionId/invoicing'
      fullPath: '/bak/contracts/$subscriptionId/invoicing'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdInvoicingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/new-invoice': {
      id: '/(redirects)/bak/contracts/$subscriptionId/new-invoice'
      path: '/bak/contracts/$subscriptionId/new-invoice'
      fullPath: '/bak/contracts/$subscriptionId/new-invoice'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdNewInvoiceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/status': {
      id: '/(redirects)/bak/contracts/$subscriptionId/status'
      path: '/bak/contracts/$subscriptionId/status'
      fullPath: '/bak/contracts/$subscriptionId/status'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdStatusRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/pending-subscriptions/$subscriptionId/history': {
      id: '/(redirects)/bak/pending-subscriptions/$subscriptionId/history'
      path: '/bak/pending-subscriptions/$subscriptionId/history'
      fullPath: '/bak/pending-subscriptions/$subscriptionId/history'
      preLoaderRoute: typeof redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/pending-subscriptions/$subscriptionId/payment': {
      id: '/(redirects)/bak/pending-subscriptions/$subscriptionId/payment'
      path: '/bak/pending-subscriptions/$subscriptionId/payment'
      fullPath: '/bak/pending-subscriptions/$subscriptionId/payment'
      preLoaderRoute: typeof redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/troubleshooting/session/$sessionId': {
      id: '/(redirects)/bak/troubleshooting/session/$sessionId'
      path: '/bak/troubleshooting/session/$sessionId'
      fullPath: '/bak/troubleshooting/session/$sessionId'
      preLoaderRoute: typeof redirectsBakTroubleshootingSessionSessionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/': {
      id: '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/'
      path: '/bak/v2-pending-subscriptions/$subscriptionId'
      fullPath: '/bak/v2-pending-subscriptions/$subscriptionId/'
      preLoaderRoute: typeof redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet': {
      id: '/(redirects)/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
      path: '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
      fullPath: '/bak/v2-pending-subscriptions/$subscriptionId/detailed-sheet'
      preLoaderRoute: typeof redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/claims/$claimId': {
      id: '/(redirects)/partner/$organization/claims/$claimId'
      path: '/partner/$organization/claims/$claimId'
      fullPath: '/partner/$organization/claims/$claimId'
      preLoaderRoute: typeof redirectsPartnerOrganizationClaimsClaimIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/contracts/$subscriptionId': {
      id: '/(redirects)/partner/$organization/contracts/$subscriptionId'
      path: '/partner/$organization/contracts/$subscriptionId'
      fullPath: '/partner/$organization/contracts/$subscriptionId'
      preLoaderRoute: typeof redirectsPartnerOrganizationContractsSubscriptionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/pending-subscriptions/': {
      id: '/(redirects)/partner/$organization/pending-subscriptions/'
      path: '/partner/$organization/pending-subscriptions'
      fullPath: '/partner/$organization/pending-subscriptions/'
      preLoaderRoute: typeof redirectsPartnerOrganizationPendingSubscriptionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/users/': {
      id: '/(redirects)/partner/$organization/users/'
      path: '/partner/$organization/users'
      fullPath: '/partner/$organization/users/'
      preLoaderRoute: typeof redirectsPartnerOrganizationUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/users/$userId': {
      id: '/(redirects)/partner/$organization/users/$userId'
      path: '/partner/$organization/users/$userId'
      fullPath: '/partner/$organization/users/$userId'
      preLoaderRoute: typeof redirectsPartnerOrganizationUsersUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo/admin/jobs/$jobId/': {
      id: '/bo/admin/jobs/$jobId/'
      path: '/admin/jobs/$jobId'
      fullPath: '/bo/admin/jobs/$jobId/'
      preLoaderRoute: typeof BoAdminJobsJobIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/admin/reducers/$reducerName/': {
      id: '/bo/admin/reducers/$reducerName/'
      path: '/admin/reducers/$reducerName'
      fullPath: '/bo/admin/reducers/$reducerName/'
      preLoaderRoute: typeof BoAdminReducersReducerNameIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/evaluations/$workflowId/': {
      id: '/bo/ai/evaluations/$workflowId/'
      path: '/ai/evaluations/$workflowId'
      fullPath: '/bo/ai/evaluations/$workflowId/'
      preLoaderRoute: typeof BoAiEvaluationsWorkflowIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/invoices/debug': {
      id: '/bo/contracts/$subscriptionId/invoices/debug'
      path: '/contracts/$subscriptionId/invoices/debug'
      fullPath: '/bo/contracts/$subscriptionId/invoices/debug'
      preLoaderRoute: typeof BoContractsSubscriptionIdInvoicesDebugRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/invoices/new': {
      id: '/bo/contracts/$subscriptionId/invoices/new'
      path: '/contracts/$subscriptionId/invoices/new'
      fullPath: '/bo/contracts/$subscriptionId/invoices/new'
      preLoaderRoute: typeof BoContractsSubscriptionIdInvoicesNewRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/payment-methods/new': {
      id: '/bo/contracts/$subscriptionId/payment-methods/new'
      path: '/contracts/$subscriptionId/payment-methods/new'
      fullPath: '/bo/contracts/$subscriptionId/payment-methods/new'
      preLoaderRoute: typeof BoContractsSubscriptionIdPaymentMethodsNewRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/users/$userId_/unpaid-invoices/': {
      id: '/bo/users/$userId_/unpaid-invoices/'
      path: '/'
      fullPath: '/bo/users/$userId/unpaid-invoices/'
      preLoaderRoute: typeof BoUsersUserIdUnpaidInvoicesIndexRouteImport
      parentRoute: typeof BoUsersUserIdUnpaidInvoicesRouteRoute
    }
    '/bo/users/$userId_/unpaid-invoices/payment': {
      id: '/bo/users/$userId_/unpaid-invoices/payment'
      path: '/payment'
      fullPath: '/bo/users/$userId/unpaid-invoices/payment'
      preLoaderRoute: typeof BoUsersUserIdUnpaidInvoicesPaymentRouteRouteImport
      parentRoute: typeof BoUsersUserIdUnpaidInvoicesRouteRoute
    }
    '/subscribe/$subscriptionId/$stepId/$detailType/$detailId': {
      id: '/subscribe/$subscriptionId/$stepId/$detailType/$detailId'
      path: '/$detailType/$detailId'
      fullPath: '/subscribe/$subscriptionId/$stepId/$detailType/$detailId'
      preLoaderRoute: typeof SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRouteImport
      parentRoute: typeof SubscribeSubscriptionIdStepIdRouteRoute
    }
    '/(customer)/_shell/contracts/$subscriptionId/attestations/': {
      id: '/(customer)/_shell/contracts/$subscriptionId/attestations/'
      path: '/contracts/$subscriptionId/attestations'
      fullPath: '/contracts/$subscriptionId/attestations/'
      preLoaderRoute: typeof customerShellContractsSubscriptionIdAttestationsIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/_shell/product-guarantees/$subscriptionId/$productName/$guaranteeType': {
      id: '/(customer)/_shell/product-guarantees/$subscriptionId/$productName/$guaranteeType'
      path: '/$guaranteeType'
      fullPath: '/product-guarantees/$subscriptionId/$productName/$guaranteeType'
      preLoaderRoute: typeof customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRouteImport
      parentRoute: typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute
    }
    '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId': {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
      fullPath: '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId'
      preLoaderRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion': {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
      fullPath: '/contracts/$subscriptionId/endorsements/$endorsementId/exclusion'
      preLoaderRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId': {
      id: '/(redirects)/bak/contracts/$subscriptionId/renewal/$endorsementId'
      path: '/bak/contracts/$subscriptionId/renewal/$endorsementId'
      fullPath: '/bak/contracts/$subscriptionId/renewal/$endorsementId'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment': {
      id: '/(redirects)/partner/$organization/pending-subscriptions/$subscriptionId/payment'
      path: '/partner/$organization/pending-subscriptions/$subscriptionId/payment'
      fullPath: '/partner/$organization/pending-subscriptions/$subscriptionId/payment'
      preLoaderRoute: typeof redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/': {
      id: '/(redirects)/partner/$organization/v2-pending-subscriptions/$subscriptionId/'
      path: '/partner/$organization/v2-pending-subscriptions/$subscriptionId'
      fullPath: '/partner/$organization/v2-pending-subscriptions/$subscriptionId/'
      preLoaderRoute: typeof redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bo/admin/jobs/$jobId/$concurrencyKey/': {
      id: '/bo/admin/jobs/$jobId/$concurrencyKey/'
      path: '/admin/jobs/$jobId/$concurrencyKey'
      fullPath: '/bo/admin/jobs/$jobId/$concurrencyKey/'
      preLoaderRoute: typeof BoAdminJobsJobIdConcurrencyKeyIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/ai/evaluations/$workflowId/datasets/$datasetId': {
      id: '/bo/ai/evaluations/$workflowId/datasets/$datasetId'
      path: '/ai/evaluations/$workflowId/datasets/$datasetId'
      fullPath: '/bo/ai/evaluations/$workflowId/datasets/$datasetId'
      preLoaderRoute: typeof BoAiEvaluationsWorkflowIdDatasetsDatasetIdRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history': {
      id: '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
      path: '/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
      fullPath: '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history'
      preLoaderRoute: typeof BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId': {
      id: '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      path: '/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      fullPath: '/bo/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      preLoaderRoute: typeof BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/endorsements/$endorsementId/': {
      id: '/bo/contracts/$subscriptionId/endorsements/$endorsementId/'
      path: '/contracts/$subscriptionId/endorsements/$endorsementId'
      fullPath: '/bo/contracts/$subscriptionId/endorsements/$endorsementId/'
      preLoaderRoute: typeof BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet': {
      id: '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
      fullPath: '/bo/contracts/$subscriptionId/endorsements/$endorsementId/detailed-sheet'
      preLoaderRoute: typeof BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRouteImport
      parentRoute: typeof BoRoute
    }
    '/bo/contracts/$subscriptionId/renewals/$endorsementId/': {
      id: '/bo/contracts/$subscriptionId/renewals/$endorsementId/'
      path: '/contracts/$subscriptionId/renewals/$endorsementId'
      fullPath: '/bo/contracts/$subscriptionId/renewals/$endorsementId/'
      preLoaderRoute: typeof BoContractsSubscriptionIdRenewalsEndorsementIdIndexRouteImport
      parentRoute: typeof BoRoute
    }
    '/(customer)/_shell/contracts/$subscriptionId/payment-methods/new/': {
      id: '/(customer)/_shell/contracts/$subscriptionId/payment-methods/new/'
      path: '/contracts/$subscriptionId/payment-methods/new'
      fullPath: '/contracts/$subscriptionId/payment-methods/new/'
      preLoaderRoute: typeof customerShellContractsSubscriptionIdPaymentMethodsNewIndexRouteImport
      parentRoute: typeof customerShellRoute
    }
    '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/': {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/'
      path: '/'
      fullPath: '/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/'
      preLoaderRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRouteImport
      parentRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute
    }
    '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/': {
      id: '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/'
      path: '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result'
      fullPath: '/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/'
      preLoaderRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId': {
      id: '/(redirects)/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      path: '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      fullPath: '/bak/contracts/$subscriptionId/detailed-sheet/versions/$versionId'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/': {
      id: '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/'
      path: '/bak/contracts/$subscriptionId/endorsement/$endorsementId'
      fullPath: '/bak/contracts/$subscriptionId/endorsement/$endorsementId/'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet': {
      id: '/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
      path: '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
      fullPath: '/bak/contracts/$subscriptionId/endorsement/$endorsementId/detailed-sheet'
      preLoaderRoute: typeof redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BoToolsRouteRouteChildren {
  BoToolsGuaranteesTablesRouteRoute: typeof BoToolsGuaranteesTablesRouteRoute
  BoToolsIndexRoute: typeof BoToolsIndexRoute
}

const BoToolsRouteRouteChildren: BoToolsRouteRouteChildren = {
  BoToolsGuaranteesTablesRouteRoute: BoToolsGuaranteesTablesRouteRoute,
  BoToolsIndexRoute: BoToolsIndexRoute,
}

const BoToolsRouteRouteWithChildren = BoToolsRouteRoute._addFileChildren(
  BoToolsRouteRouteChildren,
)

interface BoDocumentationExclusionsRouteRouteChildren {
  BoDocumentationExclusionsConfigurationRoute: typeof BoDocumentationExclusionsConfigurationRoute
  BoDocumentationExclusionsIndexRoute: typeof BoDocumentationExclusionsIndexRoute
}

const BoDocumentationExclusionsRouteRouteChildren: BoDocumentationExclusionsRouteRouteChildren =
  {
    BoDocumentationExclusionsConfigurationRoute:
      BoDocumentationExclusionsConfigurationRoute,
    BoDocumentationExclusionsIndexRoute: BoDocumentationExclusionsIndexRoute,
  }

const BoDocumentationExclusionsRouteRouteWithChildren =
  BoDocumentationExclusionsRouteRoute._addFileChildren(
    BoDocumentationExclusionsRouteRouteChildren,
  )

interface BoUsersUserIdUnpaidInvoicesRouteRouteChildren {
  BoUsersUserIdUnpaidInvoicesPaymentRouteRoute: typeof BoUsersUserIdUnpaidInvoicesPaymentRouteRoute
  BoUsersUserIdUnpaidInvoicesIndexRoute: typeof BoUsersUserIdUnpaidInvoicesIndexRoute
}

const BoUsersUserIdUnpaidInvoicesRouteRouteChildren: BoUsersUserIdUnpaidInvoicesRouteRouteChildren =
  {
    BoUsersUserIdUnpaidInvoicesPaymentRouteRoute:
      BoUsersUserIdUnpaidInvoicesPaymentRouteRoute,
    BoUsersUserIdUnpaidInvoicesIndexRoute:
      BoUsersUserIdUnpaidInvoicesIndexRoute,
  }

const BoUsersUserIdUnpaidInvoicesRouteRouteWithChildren =
  BoUsersUserIdUnpaidInvoicesRouteRoute._addFileChildren(
    BoUsersUserIdUnpaidInvoicesRouteRouteChildren,
  )

interface BoRouteChildren {
  BoActivitiesRouteRoute: typeof BoActivitiesRouteRoute
  BoActivitiesOldRouteRoute: typeof BoActivitiesOldRouteRoute
  BoEphemeralJobsRouteRoute: typeof BoEphemeralJobsRouteRoute
  BoGenerateSlipsRouteRoute: typeof BoGenerateSlipsRouteRoute
  BoGuaranteesTablesRouteRoute: typeof BoGuaranteesTablesRouteRoute
  BoLourmelSftpRouteRoute: typeof BoLourmelSftpRouteRoute
  BoMigrationRouteRoute: typeof BoMigrationRouteRoute
  BoReferralsRouteRoute: typeof BoReferralsRouteRoute
  BoScriptsRouteRoute: typeof BoScriptsRouteRoute
  BoSearchRouteRoute: typeof BoSearchRouteRoute
  BoToolsRouteRoute: typeof BoToolsRouteRouteWithChildren
  BoTrackingDocRouteRoute: typeof BoTrackingDocRouteRoute
  BoIndexRoute: typeof BoIndexRoute
  BoAdminConsumerStatusRouteRoute: typeof BoAdminConsumerStatusRouteRoute
  BoAdminDebugRouteRoute: typeof BoAdminDebugRouteRoute
  BoAdminImaRouteRoute: typeof BoAdminImaRouteRoute
  BoAdminSystemPromptsRouteRoute: typeof BoAdminSystemPromptsRouteRoute
  BoAdminTimeRouteRoute: typeof BoAdminTimeRouteRoute
  BoDocumentationActivityConfigurationRouteRoute: typeof BoDocumentationActivityConfigurationRouteRoute
  BoDocumentationActivitySpecificQuestionsRouteRoute: typeof BoDocumentationActivitySpecificQuestionsRouteRoute
  BoDocumentationEmailsRouteRoute: typeof BoDocumentationEmailsRouteRoute
  BoDocumentationEndorsementRulesRouteRoute: typeof BoDocumentationEndorsementRulesRouteRoute
  BoDocumentationExclusionsRouteRoute: typeof BoDocumentationExclusionsRouteRouteWithChildren
  BoDocumentationGeneralTermsRouteRoute: typeof BoDocumentationGeneralTermsRouteRoute
  BoDocumentationInjectableParamsRouteRoute: typeof BoDocumentationInjectableParamsRouteRoute
  BoDocumentationInputDimensionsRouteRoute: typeof BoDocumentationInputDimensionsRouteRoute
  BoDocumentationInvoicingBalanceRouteRoute: typeof BoDocumentationInvoicingBalanceRouteRoute
  BoDocumentationProductsRouteRoute: typeof BoDocumentationProductsRouteRoute
  BoDocumentationReimbursementRulesRouteRoute: typeof BoDocumentationReimbursementRulesRouteRoute
  BoDocumentationRolesRouteRoute: typeof BoDocumentationRolesRouteRoute
  BoDocumentationSearchRouteRoute: typeof BoDocumentationSearchRouteRoute
  BoDocumentationSubscriptionFunnelTextsRouteRoute: typeof BoDocumentationSubscriptionFunnelTextsRouteRoute
  BoInvoicingInvoiceIdRouteRoute: typeof BoInvoicingInvoiceIdRouteRoute
  BoInvoicingNegativeInvoicesRouteRoute: typeof BoInvoicingNegativeInvoicesRouteRoute
  BoSubscriptionsNewRouteRoute: typeof BoSubscriptionsNewRouteRoute
  BoUsersUserIdRouteRoute: typeof BoUsersUserIdRouteRoute
  BoAnnouncementsNewRoute: typeof BoAnnouncementsNewRoute
  BoOrganizationsCreateRoute: typeof BoOrganizationsCreateRoute
  BoSubscriptionsGenerateRoute: typeof BoSubscriptionsGenerateRoute
  BoSubscriptionsGenerateFailedRoute: typeof BoSubscriptionsGenerateFailedRoute
  BoAdminIndexRoute: typeof BoAdminIndexRoute
  BoAnnouncementsIndexRoute: typeof BoAnnouncementsIndexRoute
  BoContractsIndexRoute: typeof BoContractsIndexRoute
  BoDashboardIndexRoute: typeof BoDashboardIndexRoute
  BoDocumentationIndexRoute: typeof BoDocumentationIndexRoute
  BoExcludedSubscriptionsIndexRoute: typeof BoExcludedSubscriptionsIndexRoute
  BoOrganizationsIndexRoute: typeof BoOrganizationsIndexRoute
  BoPasskeysIndexRoute: typeof BoPasskeysIndexRoute
  BoProductsIndexRoute: typeof BoProductsIndexRoute
  BoRenewalIndexRoute: typeof BoRenewalIndexRoute
  BoReviewTasksIndexRoute: typeof BoReviewTasksIndexRoute
  BoSettingsIndexRoute: typeof BoSettingsIndexRoute
  BoSubscriptionsIndexRoute: typeof BoSubscriptionsIndexRoute
  BoUsersIndexRoute: typeof BoUsersIndexRoute
  BoContractsSubscriptionIdAttestationsRouteRoute: typeof BoContractsSubscriptionIdAttestationsRouteRoute
  BoContractsSubscriptionIdBillingExemptionRouteRoute: typeof BoContractsSubscriptionIdBillingExemptionRouteRoute
  BoContractsSubscriptionIdCpmsRouteRoute: typeof BoContractsSubscriptionIdCpmsRouteRoute
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute: typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute: typeof BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute
  BoContractsSubscriptionIdStatusRouteRoute: typeof BoContractsSubscriptionIdStatusRouteRoute
  BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute: typeof BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute
  BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute: typeof BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute
  BoSubscriptionsSubscriptionIdHistoryRouteRoute: typeof BoSubscriptionsSubscriptionIdHistoryRouteRoute
  BoSubscriptionsSubscriptionIdPaymentRouteRoute: typeof BoSubscriptionsSubscriptionIdPaymentRouteRoute
  BoTroubleshootingSessionsSessionIdRouteRoute: typeof BoTroubleshootingSessionsSessionIdRouteRoute
  BoUsersUserIdPaymentMethodsRouteRoute: typeof BoUsersUserIdPaymentMethodsRouteRoute
  BoUsersUserIdUnpaidInvoicesRouteRoute: typeof BoUsersUserIdUnpaidInvoicesRouteRouteWithChildren
  BoAiExperimentsAgentIdRoute: typeof BoAiExperimentsAgentIdRoute
  BoAiReviewRunIdRoute: typeof BoAiReviewRunIdRoute
  BoAiRunsWorkflowIdRoute: typeof BoAiRunsWorkflowIdRoute
  BoAiWorkflowsWorkflowIdRoute: typeof BoAiWorkflowsWorkflowIdRoute
  BoChallengesChallengeIdSubscribeRoute: typeof BoChallengesChallengeIdSubscribeRoute
  BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute: typeof BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute
  BoOrganizationsOrganizationTechnicalNameDashboardRoute: typeof BoOrganizationsOrganizationTechnicalNameDashboardRoute
  BoOrganizationsOrganizationTechnicalNameMembersRoute: typeof BoOrganizationsOrganizationTechnicalNameMembersRoute
  BoOrganizationsOrganizationTechnicalNameSlipsRoute: typeof BoOrganizationsOrganizationTechnicalNameSlipsRoute
  BoAdminDataWarehouseIndexRoute: typeof BoAdminDataWarehouseIndexRoute
  BoAdminDispatchersIndexRoute: typeof BoAdminDispatchersIndexRoute
  BoAdminJobsIndexRoute: typeof BoAdminJobsIndexRoute
  BoAdminReducersIndexRoute: typeof BoAdminReducersIndexRoute
  BoAiUnderwritingRulesIndexRoute: typeof BoAiUnderwritingRulesIndexRoute
  BoAiEvaluationsIndexRoute: typeof BoAiEvaluationsIndexRoute
  BoAiRunsIndexRoute: typeof BoAiRunsIndexRoute
  BoAiWorkflowsIndexRoute: typeof BoAiWorkflowsIndexRoute
  BoAnnouncementsAnnouncementIdIndexRoute: typeof BoAnnouncementsAnnouncementIdIndexRoute
  BoClaimsClaimIdIndexRoute: typeof BoClaimsClaimIdIndexRoute
  BoContractsSubscriptionIdIndexRoute: typeof BoContractsSubscriptionIdIndexRoute
  BoOrganizationsOrganizationTechnicalNameIndexRoute: typeof BoOrganizationsOrganizationTechnicalNameIndexRoute
  BoProductsProductGroupSlugIndexRoute: typeof BoProductsProductGroupSlugIndexRoute
  BoReviewTasksTaskIdIndexRoute: typeof BoReviewTasksTaskIdIndexRoute
  BoSettingsMembersIndexRoute: typeof BoSettingsMembersIndexRoute
  BoSettingsPaymentDetailsIndexRoute: typeof BoSettingsPaymentDetailsIndexRoute
  BoSettingsSlipsIndexRoute: typeof BoSettingsSlipsIndexRoute
  BoSubscriptionsSubscriptionIdIndexRoute: typeof BoSubscriptionsSubscriptionIdIndexRoute
  BoContractsSubscriptionIdInvoicesDebugRouteRoute: typeof BoContractsSubscriptionIdInvoicesDebugRouteRoute
  BoContractsSubscriptionIdInvoicesNewRouteRoute: typeof BoContractsSubscriptionIdInvoicesNewRouteRoute
  BoContractsSubscriptionIdPaymentMethodsNewRouteRoute: typeof BoContractsSubscriptionIdPaymentMethodsNewRouteRoute
  BoAdminJobsJobIdIndexRoute: typeof BoAdminJobsJobIdIndexRoute
  BoAdminReducersReducerNameIndexRoute: typeof BoAdminReducersReducerNameIndexRoute
  BoAiEvaluationsWorkflowIdIndexRoute: typeof BoAiEvaluationsWorkflowIdIndexRoute
  BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute: typeof BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute
  BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute: typeof BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute
  BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute: typeof BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute
  BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute: typeof BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute
  BoAdminJobsJobIdConcurrencyKeyIndexRoute: typeof BoAdminJobsJobIdConcurrencyKeyIndexRoute
  BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute: typeof BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute
  BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute: typeof BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute
}

const BoRouteChildren: BoRouteChildren = {
  BoActivitiesRouteRoute: BoActivitiesRouteRoute,
  BoActivitiesOldRouteRoute: BoActivitiesOldRouteRoute,
  BoEphemeralJobsRouteRoute: BoEphemeralJobsRouteRoute,
  BoGenerateSlipsRouteRoute: BoGenerateSlipsRouteRoute,
  BoGuaranteesTablesRouteRoute: BoGuaranteesTablesRouteRoute,
  BoLourmelSftpRouteRoute: BoLourmelSftpRouteRoute,
  BoMigrationRouteRoute: BoMigrationRouteRoute,
  BoReferralsRouteRoute: BoReferralsRouteRoute,
  BoScriptsRouteRoute: BoScriptsRouteRoute,
  BoSearchRouteRoute: BoSearchRouteRoute,
  BoToolsRouteRoute: BoToolsRouteRouteWithChildren,
  BoTrackingDocRouteRoute: BoTrackingDocRouteRoute,
  BoIndexRoute: BoIndexRoute,
  BoAdminConsumerStatusRouteRoute: BoAdminConsumerStatusRouteRoute,
  BoAdminDebugRouteRoute: BoAdminDebugRouteRoute,
  BoAdminImaRouteRoute: BoAdminImaRouteRoute,
  BoAdminSystemPromptsRouteRoute: BoAdminSystemPromptsRouteRoute,
  BoAdminTimeRouteRoute: BoAdminTimeRouteRoute,
  BoDocumentationActivityConfigurationRouteRoute:
    BoDocumentationActivityConfigurationRouteRoute,
  BoDocumentationActivitySpecificQuestionsRouteRoute:
    BoDocumentationActivitySpecificQuestionsRouteRoute,
  BoDocumentationEmailsRouteRoute: BoDocumentationEmailsRouteRoute,
  BoDocumentationEndorsementRulesRouteRoute:
    BoDocumentationEndorsementRulesRouteRoute,
  BoDocumentationExclusionsRouteRoute:
    BoDocumentationExclusionsRouteRouteWithChildren,
  BoDocumentationGeneralTermsRouteRoute: BoDocumentationGeneralTermsRouteRoute,
  BoDocumentationInjectableParamsRouteRoute:
    BoDocumentationInjectableParamsRouteRoute,
  BoDocumentationInputDimensionsRouteRoute:
    BoDocumentationInputDimensionsRouteRoute,
  BoDocumentationInvoicingBalanceRouteRoute:
    BoDocumentationInvoicingBalanceRouteRoute,
  BoDocumentationProductsRouteRoute: BoDocumentationProductsRouteRoute,
  BoDocumentationReimbursementRulesRouteRoute:
    BoDocumentationReimbursementRulesRouteRoute,
  BoDocumentationRolesRouteRoute: BoDocumentationRolesRouteRoute,
  BoDocumentationSearchRouteRoute: BoDocumentationSearchRouteRoute,
  BoDocumentationSubscriptionFunnelTextsRouteRoute:
    BoDocumentationSubscriptionFunnelTextsRouteRoute,
  BoInvoicingInvoiceIdRouteRoute: BoInvoicingInvoiceIdRouteRoute,
  BoInvoicingNegativeInvoicesRouteRoute: BoInvoicingNegativeInvoicesRouteRoute,
  BoSubscriptionsNewRouteRoute: BoSubscriptionsNewRouteRoute,
  BoUsersUserIdRouteRoute: BoUsersUserIdRouteRoute,
  BoAnnouncementsNewRoute: BoAnnouncementsNewRoute,
  BoOrganizationsCreateRoute: BoOrganizationsCreateRoute,
  BoSubscriptionsGenerateRoute: BoSubscriptionsGenerateRoute,
  BoSubscriptionsGenerateFailedRoute: BoSubscriptionsGenerateFailedRoute,
  BoAdminIndexRoute: BoAdminIndexRoute,
  BoAnnouncementsIndexRoute: BoAnnouncementsIndexRoute,
  BoContractsIndexRoute: BoContractsIndexRoute,
  BoDashboardIndexRoute: BoDashboardIndexRoute,
  BoDocumentationIndexRoute: BoDocumentationIndexRoute,
  BoExcludedSubscriptionsIndexRoute: BoExcludedSubscriptionsIndexRoute,
  BoOrganizationsIndexRoute: BoOrganizationsIndexRoute,
  BoPasskeysIndexRoute: BoPasskeysIndexRoute,
  BoProductsIndexRoute: BoProductsIndexRoute,
  BoRenewalIndexRoute: BoRenewalIndexRoute,
  BoReviewTasksIndexRoute: BoReviewTasksIndexRoute,
  BoSettingsIndexRoute: BoSettingsIndexRoute,
  BoSubscriptionsIndexRoute: BoSubscriptionsIndexRoute,
  BoUsersIndexRoute: BoUsersIndexRoute,
  BoContractsSubscriptionIdAttestationsRouteRoute:
    BoContractsSubscriptionIdAttestationsRouteRoute,
  BoContractsSubscriptionIdBillingExemptionRouteRoute:
    BoContractsSubscriptionIdBillingExemptionRouteRoute,
  BoContractsSubscriptionIdCpmsRouteRoute:
    BoContractsSubscriptionIdCpmsRouteRoute,
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute:
    BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateAgentsRouteRoute,
  BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute:
    BoContractsSubscriptionIdInsuranceCertificateGeneratorRealEstateSalesAgentsRouteRoute,
  BoContractsSubscriptionIdStatusRouteRoute:
    BoContractsSubscriptionIdStatusRouteRoute,
  BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute:
    BoOrganizationsOrganizationTechnicalNameHistoryRouteRoute,
  BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute:
    BoSubscriptionsSubscriptionIdDetailedSheetRouteRoute,
  BoSubscriptionsSubscriptionIdHistoryRouteRoute:
    BoSubscriptionsSubscriptionIdHistoryRouteRoute,
  BoSubscriptionsSubscriptionIdPaymentRouteRoute:
    BoSubscriptionsSubscriptionIdPaymentRouteRoute,
  BoTroubleshootingSessionsSessionIdRouteRoute:
    BoTroubleshootingSessionsSessionIdRouteRoute,
  BoUsersUserIdPaymentMethodsRouteRoute: BoUsersUserIdPaymentMethodsRouteRoute,
  BoUsersUserIdUnpaidInvoicesRouteRoute:
    BoUsersUserIdUnpaidInvoicesRouteRouteWithChildren,
  BoAiExperimentsAgentIdRoute: BoAiExperimentsAgentIdRoute,
  BoAiReviewRunIdRoute: BoAiReviewRunIdRoute,
  BoAiRunsWorkflowIdRoute: BoAiRunsWorkflowIdRoute,
  BoAiWorkflowsWorkflowIdRoute: BoAiWorkflowsWorkflowIdRoute,
  BoChallengesChallengeIdSubscribeRoute: BoChallengesChallengeIdSubscribeRoute,
  BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute:
    BoOrganizationsOrganizationTechnicalNameAdvancedSettingsRoute,
  BoOrganizationsOrganizationTechnicalNameDashboardRoute:
    BoOrganizationsOrganizationTechnicalNameDashboardRoute,
  BoOrganizationsOrganizationTechnicalNameMembersRoute:
    BoOrganizationsOrganizationTechnicalNameMembersRoute,
  BoOrganizationsOrganizationTechnicalNameSlipsRoute:
    BoOrganizationsOrganizationTechnicalNameSlipsRoute,
  BoAdminDataWarehouseIndexRoute: BoAdminDataWarehouseIndexRoute,
  BoAdminDispatchersIndexRoute: BoAdminDispatchersIndexRoute,
  BoAdminJobsIndexRoute: BoAdminJobsIndexRoute,
  BoAdminReducersIndexRoute: BoAdminReducersIndexRoute,
  BoAiUnderwritingRulesIndexRoute: BoAiUnderwritingRulesIndexRoute,
  BoAiEvaluationsIndexRoute: BoAiEvaluationsIndexRoute,
  BoAiRunsIndexRoute: BoAiRunsIndexRoute,
  BoAiWorkflowsIndexRoute: BoAiWorkflowsIndexRoute,
  BoAnnouncementsAnnouncementIdIndexRoute:
    BoAnnouncementsAnnouncementIdIndexRoute,
  BoClaimsClaimIdIndexRoute: BoClaimsClaimIdIndexRoute,
  BoContractsSubscriptionIdIndexRoute: BoContractsSubscriptionIdIndexRoute,
  BoOrganizationsOrganizationTechnicalNameIndexRoute:
    BoOrganizationsOrganizationTechnicalNameIndexRoute,
  BoProductsProductGroupSlugIndexRoute: BoProductsProductGroupSlugIndexRoute,
  BoReviewTasksTaskIdIndexRoute: BoReviewTasksTaskIdIndexRoute,
  BoSettingsMembersIndexRoute: BoSettingsMembersIndexRoute,
  BoSettingsPaymentDetailsIndexRoute: BoSettingsPaymentDetailsIndexRoute,
  BoSettingsSlipsIndexRoute: BoSettingsSlipsIndexRoute,
  BoSubscriptionsSubscriptionIdIndexRoute:
    BoSubscriptionsSubscriptionIdIndexRoute,
  BoContractsSubscriptionIdInvoicesDebugRouteRoute:
    BoContractsSubscriptionIdInvoicesDebugRouteRoute,
  BoContractsSubscriptionIdInvoicesNewRouteRoute:
    BoContractsSubscriptionIdInvoicesNewRouteRoute,
  BoContractsSubscriptionIdPaymentMethodsNewRouteRoute:
    BoContractsSubscriptionIdPaymentMethodsNewRouteRoute,
  BoAdminJobsJobIdIndexRoute: BoAdminJobsJobIdIndexRoute,
  BoAdminReducersReducerNameIndexRoute: BoAdminReducersReducerNameIndexRoute,
  BoAiEvaluationsWorkflowIdIndexRoute: BoAiEvaluationsWorkflowIdIndexRoute,
  BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute:
    BoContractsSubscriptionIdEndorsementTypeEndorsementIdHistoryRouteRoute,
  BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute:
    BoContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute,
  BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute:
    BoContractsSubscriptionIdEndorsementsEndorsementIdDetailedSheetRouteRoute,
  BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute:
    BoAiEvaluationsWorkflowIdDatasetsDatasetIdRoute,
  BoAdminJobsJobIdConcurrencyKeyIndexRoute:
    BoAdminJobsJobIdConcurrencyKeyIndexRoute,
  BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute:
    BoContractsSubscriptionIdEndorsementsEndorsementIdIndexRoute,
  BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute:
    BoContractsSubscriptionIdRenewalsEndorsementIdIndexRoute,
}

const BoRouteWithChildren = BoRoute._addFileChildren(BoRouteChildren)

interface ResourcesRouteChildren {
  ResourcesIndexRoute: typeof ResourcesIndexRoute
  ResourcesDocumentationInjectableParamsRouteRoute: typeof ResourcesDocumentationInjectableParamsRouteRoute
}

const ResourcesRouteChildren: ResourcesRouteChildren = {
  ResourcesIndexRoute: ResourcesIndexRoute,
  ResourcesDocumentationInjectableParamsRouteRoute:
    ResourcesDocumentationInjectableParamsRouteRoute,
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(
  ResourcesRouteChildren,
)

interface customerShellHealthInsuranceRouteRouteChildren {
  customerShellHealthInsuranceBeneficiariesRoute: typeof customerShellHealthInsuranceBeneficiariesRoute
  customerShellHealthInsuranceCpmsRoute: typeof customerShellHealthInsuranceCpmsRoute
  customerShellHealthInsuranceSanteclairRoute: typeof customerShellHealthInsuranceSanteclairRoute
  customerShellHealthInsuranceIndexRoute: typeof customerShellHealthInsuranceIndexRoute
}

const customerShellHealthInsuranceRouteRouteChildren: customerShellHealthInsuranceRouteRouteChildren =
  {
    customerShellHealthInsuranceBeneficiariesRoute:
      customerShellHealthInsuranceBeneficiariesRoute,
    customerShellHealthInsuranceCpmsRoute:
      customerShellHealthInsuranceCpmsRoute,
    customerShellHealthInsuranceSanteclairRoute:
      customerShellHealthInsuranceSanteclairRoute,
    customerShellHealthInsuranceIndexRoute:
      customerShellHealthInsuranceIndexRoute,
  }

const customerShellHealthInsuranceRouteRouteWithChildren =
  customerShellHealthInsuranceRouteRoute._addFileChildren(
    customerShellHealthInsuranceRouteRouteChildren,
  )

interface customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteChildren {
  customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute: typeof customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute
}

const customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteChildren: customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteChildren =
  {
    customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute:
      customerShellProductGuaranteesSubscriptionIdProductNameGuaranteeTypeRoute,
  }

const customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren =
  customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute._addFileChildren(
    customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteChildren,
  )

interface customerShellProductGuaranteesRouteRouteChildren {
  customerShellProductGuaranteesIndexRoute: typeof customerShellProductGuaranteesIndexRoute
  customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute: typeof customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren
}

const customerShellProductGuaranteesRouteRouteChildren: customerShellProductGuaranteesRouteRouteChildren =
  {
    customerShellProductGuaranteesIndexRoute:
      customerShellProductGuaranteesIndexRoute,
    customerShellProductGuaranteesSubscriptionIdProductNameRouteRoute:
      customerShellProductGuaranteesSubscriptionIdProductNameRouteRouteWithChildren,
  }

const customerShellProductGuaranteesRouteRouteWithChildren =
  customerShellProductGuaranteesRouteRoute._addFileChildren(
    customerShellProductGuaranteesRouteRouteChildren,
  )

interface customerShellUnpaidInvoicesRouteRouteChildren {
  customerShellUnpaidInvoicesPaymentRoute: typeof customerShellUnpaidInvoicesPaymentRoute
  customerShellUnpaidInvoicesIndexRoute: typeof customerShellUnpaidInvoicesIndexRoute
}

const customerShellUnpaidInvoicesRouteRouteChildren: customerShellUnpaidInvoicesRouteRouteChildren =
  {
    customerShellUnpaidInvoicesPaymentRoute:
      customerShellUnpaidInvoicesPaymentRoute,
    customerShellUnpaidInvoicesIndexRoute:
      customerShellUnpaidInvoicesIndexRoute,
  }

const customerShellUnpaidInvoicesRouteRouteWithChildren =
  customerShellUnpaidInvoicesRouteRoute._addFileChildren(
    customerShellUnpaidInvoicesRouteRouteChildren,
  )

interface customerShellRouteChildren {
  customerShellAccountRouteRoute: typeof customerShellAccountRouteRoute
  customerShellHealthInsuranceRouteRoute: typeof customerShellHealthInsuranceRouteRouteWithChildren
  customerShellHomeRouteRoute: typeof customerShellHomeRouteRoute
  customerShellInvoicesRouteRoute: typeof customerShellInvoicesRouteRoute
  customerShellProductGuaranteesRouteRoute: typeof customerShellProductGuaranteesRouteRouteWithChildren
  customerShellUnpaidInvoicesRouteRoute: typeof customerShellUnpaidInvoicesRouteRouteWithChildren
  customerShellContractsIndexRoute: typeof customerShellContractsIndexRoute
  customerShellLegalAssistanceIndexRoute: typeof customerShellLegalAssistanceIndexRoute
  customerShellPaymentMethodsIndexRoute: typeof customerShellPaymentMethodsIndexRoute
  customerShellReferralsIndexRoute: typeof customerShellReferralsIndexRoute
  customerShellReportClaimIndexRoute: typeof customerShellReportClaimIndexRoute
  customerShellContractsSubscriptionIdIndexRoute: typeof customerShellContractsSubscriptionIdIndexRoute
  customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute: typeof customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute
  customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute: typeof customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute
  customerShellContractsSubscriptionIdAttestationsIndexRoute: typeof customerShellContractsSubscriptionIdAttestationsIndexRoute
  customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute: typeof customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute
}

const customerShellRouteChildren: customerShellRouteChildren = {
  customerShellAccountRouteRoute: customerShellAccountRouteRoute,
  customerShellHealthInsuranceRouteRoute:
    customerShellHealthInsuranceRouteRouteWithChildren,
  customerShellHomeRouteRoute: customerShellHomeRouteRoute,
  customerShellInvoicesRouteRoute: customerShellInvoicesRouteRoute,
  customerShellProductGuaranteesRouteRoute:
    customerShellProductGuaranteesRouteRouteWithChildren,
  customerShellUnpaidInvoicesRouteRoute:
    customerShellUnpaidInvoicesRouteRouteWithChildren,
  customerShellContractsIndexRoute: customerShellContractsIndexRoute,
  customerShellLegalAssistanceIndexRoute:
    customerShellLegalAssistanceIndexRoute,
  customerShellPaymentMethodsIndexRoute: customerShellPaymentMethodsIndexRoute,
  customerShellReferralsIndexRoute: customerShellReferralsIndexRoute,
  customerShellReportClaimIndexRoute: customerShellReportClaimIndexRoute,
  customerShellContractsSubscriptionIdIndexRoute:
    customerShellContractsSubscriptionIdIndexRoute,
  customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute:
    customerShellInsuranceCertificateGeneratorRealEstateAgentsSubscriptionIdIndexRoute,
  customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute:
    customerShellInsuranceCertificateGeneratorRealEstateSalesAgentsSubscriptionIdIndexRoute,
  customerShellContractsSubscriptionIdAttestationsIndexRoute:
    customerShellContractsSubscriptionIdAttestationsIndexRoute,
  customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute:
    customerShellContractsSubscriptionIdPaymentMethodsNewIndexRoute,
}

const customerShellRouteWithChildren = customerShellRoute._addFileChildren(
  customerShellRouteChildren,
)

interface SubscribeSubscriptionIdStepIdRouteRouteChildren {
  SubscribeSubscriptionIdStepIdIndexRoute: typeof SubscribeSubscriptionIdStepIdIndexRoute
  SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute: typeof SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute
}

const SubscribeSubscriptionIdStepIdRouteRouteChildren: SubscribeSubscriptionIdStepIdRouteRouteChildren =
  {
    SubscribeSubscriptionIdStepIdIndexRoute:
      SubscribeSubscriptionIdStepIdIndexRoute,
    SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute:
      SubscribeSubscriptionIdStepIdDetailTypeDetailIdRouteRoute,
  }

const SubscribeSubscriptionIdStepIdRouteRouteWithChildren =
  SubscribeSubscriptionIdStepIdRouteRoute._addFileChildren(
    SubscribeSubscriptionIdStepIdRouteRouteChildren,
  )

interface customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteChildren {
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute: typeof customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute
}

const customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteChildren: customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteChildren =
  {
    customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute:
      customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdIndexRoute,
  }

const customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteWithChildren =
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute._addFileChildren(
    customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImpersonateRouteRoute: ImpersonateRouteRoute,
  LoginRouteRoute: LoginRouteRoute,
  ReceiveQuoteRouteRoute: ReceiveQuoteRouteRoute,
  SearchRouteRoute: SearchRouteRoute,
  SubscribeNoPossibleStepRouteRoute: SubscribeNoPossibleStepRouteRoute,
  UnsubscribeRouteRoute: UnsubscribeRouteRoute,
  BoRoute: BoRouteWithChildren,
  ChatRoute: ChatRoute,
  ResourcesRoute: ResourcesRouteWithChildren,
  redirectsContractGuaranteesRouteRoute: redirectsContractGuaranteesRouteRoute,
  redirectsPaymentMethodUpdateRouteRoute:
    redirectsPaymentMethodUpdateRouteRoute,
  PaymentAuthenticationRouteRoute: PaymentAuthenticationRouteRoute,
  RCodeRouteRoute: RCodeRouteRoute,
  SubscribeExclusionSubscriptionIdRouteRoute:
    SubscribeExclusionSubscriptionIdRouteRoute,
  SubscribeLandingRouteRoute: SubscribeLandingRouteRoute,
  customerShellRoute: customerShellRouteWithChildren,
  redirectsBakActivitiesRouteRoute: redirectsBakActivitiesRouteRoute,
  redirectsBakEphemeralJobsRouteRoute: redirectsBakEphemeralJobsRouteRoute,
  redirectsBakHomeRouteRoute: redirectsBakHomeRouteRoute,
  redirectsBakMembershipsRouteRoute: redirectsBakMembershipsRouteRoute,
  redirectsBakMigrationRouteRoute: redirectsBakMigrationRouteRoute,
  redirectsBakNewSubscriptionRouteRoute: redirectsBakNewSubscriptionRouteRoute,
  redirectsBakOrganizationsRouteRoute: redirectsBakOrganizationsRouteRoute,
  redirectsBakSearchRouteRoute: redirectsBakSearchRouteRoute,
  redirectsBakTrackingDocRouteRoute: redirectsBakTrackingDocRouteRoute,
  redirectsPaymentMethodsNewRouteRoute: redirectsPaymentMethodsNewRouteRoute,
  FormSubscriptionIdFormIdRouteRoute: FormSubscriptionIdFormIdRouteRoute,
  SAttestationsTokenRouteRoute: SAttestationsTokenRouteRoute,
  SCTokenRouteRoute: SCTokenRouteRoute,
  SEV2TokenRouteRoute: SEV2TokenRouteRoute,
  SETokenRouteRoute: SETokenRouteRoute,
  SHfTokenRouteRoute: SHfTokenRouteRoute,
  SQTokenRouteRoute: SQTokenRouteRoute,
  SRTokenRouteRoute: SRTokenRouteRoute,
  SubscribeSubscriptionIdStepIdRouteRoute:
    SubscribeSubscriptionIdStepIdRouteRouteWithChildren,
  SubscribeRestaurantsV2IdentifyRouteRoute:
    SubscribeRestaurantsV2IdentifyRouteRoute,
  redirectsBakAdminImaRouteRoute: redirectsBakAdminImaRouteRoute,
  redirectsBakDocumentationActivitySpecificQuestionsRouteRoute:
    redirectsBakDocumentationActivitySpecificQuestionsRouteRoute,
  redirectsBakDocumentationExclusionsRouteRoute:
    redirectsBakDocumentationExclusionsRouteRoute,
  redirectsBakDocumentationGeneralTermsRouteRoute:
    redirectsBakDocumentationGeneralTermsRouteRoute,
  redirectsBakDocumentationRolesRouteRoute:
    redirectsBakDocumentationRolesRouteRoute,
  redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute:
    redirectsBakDocumentationSubscriptionFunnelTextsRouteRoute,
  redirectsBakInvoicingNegativeInvoicesListRouteRoute:
    redirectsBakInvoicingNegativeInvoicesListRouteRoute,
  redirectsBakUsersUserIdRouteRoute: redirectsBakUsersUserIdRouteRoute,
  redirectsPartnerOrganizationHomeRouteRoute:
    redirectsPartnerOrganizationHomeRouteRoute,
  redirectsPartnerOrganizationNewSubscriptionRouteRoute:
    redirectsPartnerOrganizationNewSubscriptionRouteRoute,
  redirectsPartnerOrganizationSearchRouteRoute:
    redirectsPartnerOrganizationSearchRouteRoute,
  SATokenProductRouteRoute: SATokenProductRouteRoute,
  redirectsBakAdminIndexRoute: redirectsBakAdminIndexRoute,
  redirectsBakDocumentationIndexRoute: redirectsBakDocumentationIndexRoute,
  redirectsBakPendingSubscriptionsIndexRoute:
    redirectsBakPendingSubscriptionsIndexRoute,
  redirectsBakUsersIndexRoute: redirectsBakUsersIndexRoute,
  redirectsBoEarningsIndexRoute: redirectsBoEarningsIndexRoute,
  redirectsBoMembershipsIndexRoute: redirectsBoMembershipsIndexRoute,
  redirectsBoOrganizationDashboardIndexRoute:
    redirectsBoOrganizationDashboardIndexRoute,
  redirectsBoOrganizationHistoryIndexRoute:
    redirectsBoOrganizationHistoryIndexRoute,
  redirectsBoSlipsIndexRoute: redirectsBoSlipsIndexRoute,
  SATokenIndexRoute: SATokenIndexRoute,
  redirectsBakContractsSubscriptionIdInvoicingRouteRoute:
    redirectsBakContractsSubscriptionIdInvoicingRouteRoute,
  redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute:
    redirectsBakContractsSubscriptionIdNewInvoiceRouteRoute,
  redirectsBakContractsSubscriptionIdStatusRouteRoute:
    redirectsBakContractsSubscriptionIdStatusRouteRoute,
  redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute:
    redirectsBakPendingSubscriptionsSubscriptionIdHistoryRouteRoute,
  redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute:
    redirectsBakPendingSubscriptionsSubscriptionIdPaymentRouteRoute,
  redirectsBakTroubleshootingSessionSessionIdRouteRoute:
    redirectsBakTroubleshootingSessionSessionIdRouteRoute,
  redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute:
    redirectsBakV2PendingSubscriptionsSubscriptionIdDetailedSheetRouteRoute,
  redirectsPartnerOrganizationClaimsClaimIdRouteRoute:
    redirectsPartnerOrganizationClaimsClaimIdRouteRoute,
  redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute:
    redirectsPartnerOrganizationContractsSubscriptionIdRouteRoute,
  redirectsPartnerOrganizationUsersUserIdRouteRoute:
    redirectsPartnerOrganizationUsersUserIdRouteRoute,
  redirectsBakClaimsClaimIdIndexRoute: redirectsBakClaimsClaimIdIndexRoute,
  redirectsBakContractsSubscriptionIdIndexRoute:
    redirectsBakContractsSubscriptionIdIndexRoute,
  redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute:
    redirectsBakV2PendingSubscriptionsSubscriptionIdIndexRoute,
  redirectsPartnerOrganizationPendingSubscriptionsIndexRoute:
    redirectsPartnerOrganizationPendingSubscriptionsIndexRoute,
  redirectsPartnerOrganizationUsersIndexRoute:
    redirectsPartnerOrganizationUsersIndexRoute,
  customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRoute:
    customerContractsSubscriptionIdEndorsementsEndorsementIdStepIdRouteRouteWithChildren,
  customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute:
    customerContractsSubscriptionIdEndorsementsEndorsementIdExclusionRouteRoute,
  redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute:
    redirectsBakContractsSubscriptionIdRenewalEndorsementIdRouteRoute,
  redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute:
    redirectsPartnerOrganizationPendingSubscriptionsSubscriptionIdPaymentRouteRoute,
  redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute:
    redirectsPartnerOrganizationV2PendingSubscriptionsSubscriptionIdIndexRoute,
  redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute:
    redirectsBakContractsSubscriptionIdDetailedSheetVersionsVersionIdRouteRoute,
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute:
    redirectsBakContractsSubscriptionIdEndorsementEndorsementIdDetailedSheetRouteRoute,
  customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute:
    customerContractsSubscriptionIdEndorsementsEndorsementIdSignatureResultIndexRoute,
  redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute:
    redirectsBakContractsSubscriptionIdEndorsementEndorsementIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
